export default {
  diet: {
    title: "Dietas",
    buttonNewDiet: "Nueva dieta",
    table: {
      title: "Lista de dietas",
      columns: {
        status: "Estado",
        description: "Dieta",
        phosphorus: "Fósforo (mg)",
        nitrogen: "Nitrógeno (mg)",
        tdn: "TDN (g)",
        cp: "Proteína bruta (g)",
        calcium: "Calcio (mg)",
        cost: "Costo (R$/Kg",
      },
    },
    drawerTitle: "Registro de Dieta",
    drawerTitleEdit: "Edición dieta",
    drawerSubTitle:
      "Complete los campos a continuación para crear una nueva dieta",
    drawerSubTitleEdit:
      "Complete los campos a continuación para editar una nueva dieta",
    validationMessage:
      "Rellene correctamente todos los campos obligatorios (*)",
    form: {
      name: "Identificación de la dieta",
      namePlaceHolder: "Nombre de la dieta",
      pasture: "Forraje",
      pasturePlaceHolder: "¿Cuál es el forraje dietético?",
      pastureNoSelection: "Ninguno",
      supplements: "Suplme/Concent.",
      supplementsPlaceHolder:
        "¿Qué son los suplementos insertados en la dieta?",
      cost: "Costo de la dieta ($/kg)",
      costPlaceHolder: "¿Cuál es el costo de la dieta en $/kg?",
      phosphorus: "Fósforo (mg)",
      phosphorusPlaceHolder: "¿Cuánto fósforo?",
      nitrogen: "Nitrógeno (mg)",
      nitrogenPlaceHolder: "¿Cuánto nitrógeno?",
      calcium: "Calcio (mg)",
      calciumPlaceHolder: "¿Cuánto calcio?",
      tdn: "TDN (g)",
      tdnPlaceHolder: "¿Cuánto TDN?",
      cp: "Proteína bruta (g)",
      cpPlaceHolder: "¿Cuánta proteína bruta?",
      status: "Estado de la dieta",
      error: {
        requiredPastureSupplement: {
          title: "Error",
          message:
            "Ya sea forraje o al menos un suplemento/concentrado. debe ser seleccionado",
        },
      },
    },
    saveOptions: {
      only_save: "Salvar",
      save_and_create_new: "Guarde y agregue un nuevo dado",
    },
  },
  pasture: {
    title: "Forraje",
    buttonNewPasture: "Forraje nuevo",
    table: {
      title: "Lista de forraje",
      columns: {
        status: "Estado",
        description: "Forraje",
        phosphorus: "Fósforo (mg)",
        nitrogen: "Nitrógeno (mg)",
        tdn: "TDN (g)",
        cp: "CP (g)",
        calcium: "Calcio (mg)",
        cost: "Costo ($/kg)",
        entryHeight: "Altura de entrada",
        exitHeight: "Altura de salida",
        growthSpeed: "Tasa de crecimiento",
        yield: "Yiel",
      },
    },
    drawerTitle: "Lista de forraje",
    drawerTitleEdit: "Editar forraje",
    drawerSubTitle:
      "Complete los campos a continuación para crear un nuevo forraje",
    drawerSubTitleEdit:
      "Complete los campos a continuación para editar el forraje",
    validationMessage:
      "Rellene correctamente todos los campos obligatorios (*)",
    form: {
      groupFarmVisibility: "¿Quién usará el forraje?",
      name: "Identificación de forraje",
      namePlaceHolder: "Nombre del forraje",
      pastureType: "Nombre científico",
      fertilized: "Fertilizado",
      notFertilized: "No fertilizado",
      cost: "Costar",
      costPlaceHolder: "Unidad: $",
      cp: "CP: Proteína bruta",
      cpPlaceHolder: "Unidad: g",
      fdn: "NDF: Fibra detergente neutra",
      fdnPlaceHolder: "Unidad: %",
      tdn: "TDN: Nutrientes Digestibles Totales",
      tdnPlaceHolder: "Unidad: g",
      phosphorus: "Fósforo",
      phosphorusPlaceHolder: "Unidad: g/kg",
      nitrogen: "Nitrógeno",
      nitrogenPlaceHolder: "Unidad: mg/kg",
      calcium: "Calcio",
      calciumPlaceHolder: "Unidad: g/kg",
      zinc: "Zinc",
      zincPlaceHolder: "Unidad: mg/kg",
      sodium: "Sodio",
      sodiumPlaceHolder: "Unidad: g/kg",
      formation: "Crecimiento completo",
      formationPlaceHolder: "Unidad: días",
      rest: "Descansando",
      restPlaceHolder: "Unidad: días",
      entryHeight: "Altura óptima de pastoreo",
      entryHeightPlaceHolder: "Unidad: cm",
      exitHeight: "Altura de descanso óptima",
      exitHeightPlaceHolder: "Unidad: cm",
      growthRate: "Tasa de crecimiento",
      growthRatePlaceHolder: "Unidad: kg/ha/día",
      leafDensityProduction: "Producción de materia seca forrajera",
      leafDensityProductionPlaceHolder: "Unidad: t/ha/ciclo",
      growthSpeed: "Tasa de crecimiento",
      growthSpeedPlaceHolder: "Unidad: kg MS/㎡/día",
      yield: "Rendimiento",
      yieldPlaceHolder: "Unidad: kg DM/㎡",
      status: "Estado del forraje",
      nutritionalData: "DATOS NUTRICIONALES",
      capacity: "Capacidad",
      maximumConsumption: "Consumo máximo",
      minimumConsumption: "Consumo mínimo",
      radiogroup: {
        farm: "Solo para esta finca",
        group: "A todas las granjas del grupo",
      },
      fda: "ADF",
      lignin: "Lignina",
      ee: "Extracto de éter",
      maximumHeight: "Altura máxima",
      maximumHeightPlaceHolder: "Altura máxima",
    },
    modal: {
      confirmation: {
        title: "Cambiar el tipo de forraje",
        message:
          "Cuando confirme el cambio del tipo de forraje, se modificarán los valores de la altura ideal de entrada, la altura ideal de salida y las estaciones meteorológicas. ¿Quieres continuar?",
        confirmButton: "Confirmar",
        cancelButton: "Cance",
      },
    },
    errorConsumptionMaximumLessThanMinimum:
      "El consumo máximo debe ser superior al consumo mínimo",
    errorEntryHeightLessThanExitEntryHeight:
      "La altura óptima de pastoreo debe ser mayor que la altura óptima de reposo",
    errorNecessaryOneSeason:
      "Es necesario tener informada al menos una estación meteorológica",
    errorFertilizedSeasonInfoIncomplete:
      "Reporte o mantenga datos pendientes sobre el forraje fertilizado en todas las estaciones climáticas",
    errorUnfertilizedSeasonInfoIncomplete:
      "Reportar o mantener datos pendientes sobre forraje no fertilizado en todas las estaciones climáticas",
    errorPastureInfoForAllSeasonsIncomplete:
      "Reporte o mantenga datos pendientes sobre forraje fertilizado/no fertilizado en todas las estaciones climáticas",
    saveOptions: {
      only_save: "Salvar",
      save_and_create_new: "Guarde y agregue un nuevo en",
    },
  },
  breed: {
    title: "Razas",
    buttonNewBreed: "Nueva raza",
    table: {
      title: "Lista de razas",
      columns: {
        status: "Estado",
        geneticGroup: "Grupo genético",
        description: "Descripción",
        name: "Raza",
        asymptoticWeight: "Peso sigmoide (kg)",
        estimatedMaximumAge: "Edad sigmoide",
        correctionFactor: "Factor de corrección",
        maturationRate: "Maduración de la rata",
      },
      menu: {
        parameters: "Parámetro",
      },
    },
    drawerTitle: "Registro de la raza",
    drawerTitleEdit: "Editar raza",
    drawerSubTitle:
      "Complete los campos a continuación para crear una nueva raza",
    drawerSubTitleEdit:
      "Complete los campos a continuación para editar la raza",
    validationMessage:
      "Rellene correctamente todos los campos obligatorios (*)",
    form: {
      name: "Identificación de la raza",
      namePlaceHolder: "Nombre de la raza",
      description: "Descripción",
      descriptionPlaceHolder: "Descripción de la raza",
      geneticGroup: "Grupo genético",
      geneticGroupPlaceHolder: "Seleccione el grupo genético",
      status: "Estatu de la raza",
    },
    saveOptions: {
      only_save: "Salvar",
      save_and_create_new: "Guardar y crear uno nuevo",
      save_and_add_parameters: "Guardar y configurar el parámetro",
    },
    drawerParametersTitle: "Parámetros de la raza",
    formParameters: {
      asymptoticWeight: "Peso sigmoide",
      asymptoticWeightPlaceHolder: "Establecer el peso",
      theoricalCurve: "Curva teórica",
      estimatedMaximumAge: "Edad sigmoide",
      estimatedMaximumAgePlaceHolder: "Edad sigmoide",
      correctionFactor: "Factor de corrección",
      correctionFactorPlaceHolder:
        "Factor de corrección para calcular la curva de crecimiento de la raza",
      maturationRate: "Tasa de maduración",
      maturationRatePlaceHolder:
        "Tasa de maduración para calcular la curva de crecimiento de la raza",
      status: "Estado de los parámetros de raza",
      extimatedCurveTitle: "CURVA DE CRECIMIENTO ESTIMADA",
      genetic: "GENÉTICA",
      diet: "DIETA",
      gestationDivider: "Periodo de gestación",
      minGestationTime: "Min",
      medGestationTime: "Avg",
      maxGestationTime: "Mamá",
    },
  },
  handlingOperation: {
    title: "Operaciones",
    buttonNewPasture: "Nueva operación",
    table: {
      title: "Lista de operaciones",
      columns: {
        status: "Estado",
        operation: "Operación",
        action: "Actio",
      },
    },
    drawerTitle: "Lista de Operaciones",
    drawerTitleEdit: "Operación de edición",
    drawerSubTitle:
      "Complete los campos a continuación para crear una nueva operación",
    drawerSubTitleEdit:
      "Complete los campos a continuación para editar la operación",
    validationMessage:
      "Rellene correctamente todos los campos obligatorios (*)",
    form: {
      name: "Operación",
      namePlaceHolder: "Nombre de la operación",
      action: "Acción",
      actionPlaceHolder: "Seleccionar acción de procedimiento",
      recurrence: "Repetición",
      recurrenceAmount: "Qty.",
      quarantine: "Cuarentena",
      quarantineAmount: "Introduzca el número de días",
      breed: "Raza",
      breedPlaceHolder: "Seleccionar razas",
      gender: "Género",
      genderPlaceHolder: "Escoger",
      age: "Edad",
      weight: "Peso",
      dontExecuteOperation:
        "No realice la operación en animales que se encuentren en:",
      inQuarantine: "Cuarentena",
      inPregnancy: "Embarazo",
      operationCost: "Costo de operación",
      noCost: "Sin costo",
      haveCost: "Costo(defina el costo en el procedimiento)",
      status: "Operación statu",
    },
    parameters: "PARÁMETROS",
    limitations: "LÍMITES",
    errors: {
      recurrenceMinAndMaxDayCanBeNull: {
        title: "Error",
        message:
          "El número mínimo y máximo de días para la periodicidad no puede estar en blanco",
      },
      recurrenceQtdCanBeNull: {
        title: "Error",
        message:
          "El número de veces que se produce la periodicidad no puede estar en blanco",
      },
    },
    saveOptions: {
      only_save: "Salvar",
      save_and_create_new: "Guardar y añadir una nueva Operatio",
    },
  },
  handling: {
    title: "Ganadería",
    tabs: {
      pending: "En proceso",
      finalized: "Terminado",
      dietStrategies: "Estrategias dietéticas",
      vacinations: "Procedimiento veterinario",
      handlingReproduction: "Reproducción",
      animalWeightHistory: "Pesajes y Mediciones",
      picketSupplementSupply: "Suupliado",
      troughFeedingAssessment: "Evaluadores de la ingesta de alimentos",
    },
    vacinations: {
      buttonNew: "Nueva inyección",
      form: {
        titleEdit: "Inyección de edición",
        titleCreateNew: "Nueva inyección",
        dividerTitle: "Inyección previa",
        animalId: "Animal",
        lastDailyWeight: "Último pesaje",
        handlingNumber: "Animal",
        veterinarySupplementId: "Producto",
        veterinarySupplementApplicationType: "Tipo de administración",
        veterinarySupplementApplicationValue: "Dosificación",
        applicationQuantity: "Cantidad inyectada",
        applicationUnit: "Unidad",
        applicationDay: "Datos de inyección",
      },
      table: {
        title: "Veterinario",
        columns: {
          animalName: "Animal",
          veterinarySupplementName: "Nombre",
          type: "Tipo",
          applicationDate: "Fecha",
          applicationQuantity: "Cantidad",
          applicationUnit: "Uni",
          last_weight: "Último Peso",
          last_weight_date: "Fecha del Último Peso",
          last_comment: "Último Comentario",
          last_comment_date: "Fecha del Último Comentario",
        },
      },
    },
  },
  payments: {
    title: "Pago",
    ui: {
      monthlyMovementTitle: "Seguimiento de movimientos mensuales",
      invoiceDescriptionTitle: "Descripción de la factura",
      valuePrefix: "Importe",
      viewBoleto: "Ver Boleto",
      sendByEmail: "Enviar por Email",
      secondCopy: "2ª Copia",
      paymentMethodTitle: "¿Cómo prefiere pagar?",
      newCreditCard: "Nueva tarjeta de crédito",
      boleto: "Boleto",
      changeDueDateTitle: "Cambiar fecha de vencimiento",
      currentDueDatePrefix: "Actualmente su factura vence el",
      dueDatePlaceholder: "Informe la fecha de vencimiento",
      creditCardTitle: "Tarjeta de Crédito",
      cardHolderName: "Nombre del titular",
      cardNumber: "Número de Tarjeta",
      cardExpiryDate: "Fecha de vencimiento",
      cardSecurityCode: "Código de seguridad",
      periodFrom: "De",
      bovexoServices: "Servicios relacionados con BovExo",
      cardLastDigitsPrefix: "Final:",
      noInvoicesAvailable: "No hay facturas disponibles",
    },
    messages: {
      holderNameRequired: "El nombre del titular/portador es obligatorio.",
      invalidCPF: "CPF inválido.",
      invalidCardNumber: "Número de tarjeta inválido.",
      invalidExpirationDate: "Fecha de vencimiento inválida.",
      invalidSecurityCode: "Código de seguridad inválido.",
      paymentMethodUpdated: "Forma de pago actualizada con éxito",
      invalidCardData: "Datos de tarjeta inválidos",
      paymentMethodError:
        "Ocurrió un error durante la actualización de la forma de pago",
      dueDayUpdated: "Fecha de vencimiento actualizada con éxito",
      dueDayError:
        "Ocurrió un error durante la actualización del día de vencimiento",
    },
  },
  parameters: {
    title: "Parámetros",
    tabs: {
      general: "General",
      breed: "Razas",
      diet: "Dietas",
      supplement: "Supleménte./Concent.",
      pasture: "Forraje",
      alert: "Alertas",
      benchmark: "Referencia",
      marketAnalysis: "Curva de precios",
      cost: "Costos",
      activity: "Actividades",
      boitelPrice: "Boitel - Tarifas Diarias",
      integration: "Integraciones",
      financial: "Financiero/Costos",
      reproduction: "Reproducción",
      reproductionParameter: "Parámetros",
      semen: "Semen",
      inseminators: "Técnico",
      supplie: "Entradas",
      animal: "Animales",
      deathReasons: "Causa Mortis",
      unit: "Unidades",
      veterinary: "Veterinario",
      commercialization: "Comercialización",
      quota: "Cuotas",
      multipleBull: "Toro múltiple",
      reproductiveProtocol: "Protocolos",
      feedFactory: "Fábrica de Ración",
      handlingParameters: "Agricultura",
      farmDayScaleTreatmentParameter: "Horario de alimentación",
      farmReadFeederTreatmentParameter:
        "Evaluadores de la ingesta de alimentos",
      wagonAutomation: "Mezclador",
      ageRange: "Rango de Edad",
      handlingAlerts: "Alertas de Manejo",
      measurement: "Mediciones",
      stock: "Inventario",
      others: "Otros",
    },
  },
  boitelPrice: {
    title: "Boitel - Tarifa Diaria",
    buttonNew: "Nuevo",
    table: {
      title: "Boitel - Tarifa Diaria",
      columns: {
        name: "Nombre",
        farmName: "Nombre de la granja",
        validity: "Válido hasta",
        status: "Statu",
      },
    },
  },
  integrationPartners: {
    table: {
      title: "Integraciones",
      columns: {
        status: "Estado",
        system: "Sistema",
        authType: "Tipo de autenticación",
      },
    },
    authType: {
      Token: "Seña",
      UserAndPassword: "Usuario y transeúnte",
      UserAndPasswordAndCompany: "Usuario, contraseña y empresa",
      ApiKey: "Clave de API",
    },
  },
  imports: {
    title: "Archivos importados",
    tabs: {
      animal: "Animales",
      weight: "Pesajes y Mediciones",
      supplement: "Suplementos",
      financialTransactions: "Entrada financiera",
      animalCoverages: "Coberturas e DG's",
      suppliersClients: "Proveedores/Clientes",
      animalBirths: "Partos y Perdidas",
      vaccinations: "Vacunaciones",
      picketSupplementSupplyFeedReader: "Suministro/Lectura de Comedero",
    },
    status: {
      queue: "Espera",
      processing: "En proceso",
      processed: "Terminado",
      deleting: "Borrar",
      error: "Erro",
    },
    animal: {
      buttonImport: "Importación",
      table: {
        title: "Lista de Importaciones de Animales",
        columns: {
          status: "Estado",
          fileName: "Archivo",
          date: "Fecha",
          total: "Total",
          numberImported: "Importado",
          numberAlerted: "Alertas",
          numberError: "Errores",
          numberDuplicated: "Duplicado",
          numberUpdated: "Actualizado",
          message: "Mensajería",
        },
      },
      details: {
        breadCumbsImportLog: "Importaciones",
        breadCumbsImportLogDetails: "Detalles de importación de datos",
        collapseAnimals: "Animales",
        fileNameTitle: "Archivo",
        statusTitle: "Estado",
        dateTitle: "Fecha",
        table: {
          columns: {
            rowNumber: "Fila de Excel",
            handlingNumber: "Identificación del animal",
            message: "Razón",
            alert: "Alerta",
          },
        },
      },
    },
    weight: {
      buttonImport: "Importación",
      table: {
        title: "Lista de Importaciones de Pesaje y Mediciones",
        columns: {
          status: "Estado",
          fileName: "Archivo",
          date: "Fecha",
          total: "Total",
          numberImported: "Importado",
          numberError: "Errores",
          numberDuplicated: "Duplicado",
          numberUpdated: "Actualizado",
          message: "Mensajería",
        },
      },
      details: {
        breadCumbsImportLog: "Importaciones",
        breadCumbsImportLogDetails: "Detalles de importación de datos",
        collapseAnimals: "Pesadas",
        fileNameTitle: "Archivo",
        statusTitle: "Estado",
        dateTitle: "Fecha",
        table: {
          columns: {
            rowNumber: "Fila de Excel",
            weight: "Peso",
            handlingNumber: "Identificación del animal",
            aol: "AOL",
            aol100Kg: "AOL/100Kg",
            ratio: "RATIO",
            marmoreio: "MARMOLEO",
            egs: "EGS",
            message: "Reaso",
          },
        },
      },
    },
    supplement: {
      buttonImport: "Importación",
      table: {
        title: "Lista de Importaciones de Suplementos",
        columns: {
          status: "Estado",
          fileName: "Archivo",
          date: "Fecha",
          total: "Total",
          numberImported: "Importado",
          numberError: "Errores",
          numberDuplicated: "Duplicado",
          numberUpdated: "Actualizado",
          message: "Mensajería",
        },
      },
      details: {
        breadCumbsImportLog: "Importaciones",
        breadCumbsImportLogDetails: "Detalles de importación de datos",
        collapseAnimals: "Suplementos",
        fileNameTitle: "Archivo",
        statusTitle: "Estado",
        dateTitle: "Fecha",
        table: {
          columns: {
            rowNumber: "Fila de Excel",
            name: "ID del suplemento",
            message: "Reaso",
          },
        },
      },
    },
    picketSupplementSupplyFeedReader: {
      buttonImport: "Importación",
      table: {
        title: "Lista de Importaciones de Suministro y Lectura de Comedero",
        columns: {
          status: "Estado",
          fileName: "Archivo",
          date: "Fecha",
          total: "Total",
          numberImported: "Importado",
          numberError: "Errores",
          numberDuplicated: "Duplicado",
          numberUpdated: "Actualizado",
          message: "Mensajería",
        },
      },
      details: {
        breadCumbsImportLog: "Importaciones",
        breadCumbsImportLogDetails: "Detalles de importación de datos",
        collapseImported: "Importados",
        collapseNotImported: "No Importados",
        records: "registros",
        fileNameTitle: "Archivo",
        statusTitle: "Estado",
        dateTitle: "Fecha",
        types: {
          supply: "Suministro",
          feedReader: "Lectura de Comedero",
          supplyAndFeedReader: "Suministro y Lectura de Comedero",
        },
        table: {
          columns: {
            rowNumber: "Fila de Excel",
            picket: "Piquete/Corral",
            date: "Fecha",
            type: "Tipo",
            message: "Razón",
            alert: "Alertas",
          },
        },
      },
    },
    suppliersClients: {
      buttonImport: "Importación",
      table: {
        title: "Lista de Importaciones de Proveedores/Clientes",
        columns: {
          status: "Estado",
          fileName: "Archivo",
          date: "Fecha",
          total: "Total",
          numberImported: "Importado",
          numberError: "Errores",
          numberDuplicated: "Duplicado",
          numberUpdated: "Actualizado",
          message: "Mensajería",
        },
      },
      details: {
        breadCumbsImportLog: "Importaciones",
        breadCumbsImportLogDetails: "Detalles de importación de datos",
        collapseAnimals: "Proveedores/Clientes",
        fileNameTitle: "Archivo",
        statusTitle: "Estado",
        dateTitle: "Fecha",
        table: {
          columns: {
            rowNumber: "Fila de Excel",
            name: "Nombre del Proveedor/Cliente",
            message: "Razón",
          },
        },
      },
    },
    financialTransactions: {
      buttonImport: "Importación",
      table: {
        title: "Lista de Importaciones de Transacciones Financieras",
        columns: {
          status: "Estado",
          fileName: "Archivo",
          date: "Fecha",
          total: "Total",
          numberImported: "Importado",
          numberError: "Errores",
          numberDuplicated: "Duplicado",
          numberUpdated: "Actualizado",
          message: "Mensajería",
        },
      },
      details: {
        breadCumbsImportLog: "Importaciones",
        breadCumbsImportLogDetails: "Detalles de importación",
        collapseAnimals: "Contabilización financiera",
        fileNameTitle: "Archivo",
        statusTitle: "Estado",
        dateTitle: "Fecha",
        table: {
          columns: {
            rowNumber: "Fila de Excel",
            name: "ID de contabilización financiera",
            message: "Reaso",
          },
        },
      },
    },
    animalCoverages: {
      buttonImport: "Importación",
      table: {
        title: "Lista de Importaciones de Coberturas e DG's",
        columns: {
          status: "Estado",
          fileName: "Archivo",
          date: "Fecha",
          total: "Total",
          numberImported: "Importados",
          numberError: "Errores",
          numberDuplicated: "Duplicados",
          numberUpdated: "Actualizados",
          message: "Mensaje",
        },
      },
      details: {
        breadCumbsImportLog: "Importaciones",
        breadCumbsImportLogDetails: "Detalles de Importación",
        collapseAnimals: "Coberturas e DG's",
        fileNameTitle: "Archivo",
        statusTitle: "Estado",
        dateTitle: "Fecha",
        table: {
          columns: {
            rowNumber: "Fila de Excel",
            name: "Identificación de la Cobertura",
            message: "Motivo",
          },
        },
      },
    },
    animalBirths: {
      buttonImport: "Importación",
      table: {
        title: "Lista de Importaciones de Partos y Perdidas",
        columns: {
          status: "Estado",
          fileName: "Archivo",
          date: "Fecha",
          total: "Total",
          numberImported: "Importado",
          numberError: "Errores",
          numberDuplicated: "Duplicado",
          numberUpdated: "Actualizado",
          message: "Mensajería",
        },
      },
      details: {
        breadCumbsImportLog: "Importaciones",
        breadCumbsImportLogDetails: "Detalles de importación de datos",
        collapseAnimals: "Partos y Perdidas",
        fileNameTitle: "Archivo",
        statusTitle: "Estado",
        dateTitle: "Fecha",
        table: {
          columns: {
            rowNumber: "Fila de Excel",
            handlingNumber: "Identificación del animal",
            message: "Razón",
            alert: "Alerta",
          },
        },
      },
    },
    vaccinations: {
      buttonImport: "Importación",
      table: {
        title: "Lista de Importaciones de Vacunaciones",
        columns: {
          status: "Estado",
          fileName: "Archivo",
          date: "Fecha",
          total: "Total",
          numberImported: "Importado",
          numberError: "Errores",
          numberDuplicated: "Duplicado",
          message: "Mensajería",
        },
      },
      details: {
        breadCumbsImportLog: "Importaciones",
        breadCumbsImportLogDetails: "Detalles de importación de datos",
        imported: "Importado",
        notImported: "No Importado",
        vaccinations: "vacunaciones",
        fileNameTitle: "Archivo",
        statusTitle: "Estado",
        dateTitle: "Fecha",
        table: {
          columns: {
            rowNumber: "Fila de Excel",
            animalName: "Animal",
            veterinarySupplementName: "Vacuna/Medicamento",
            applicationDate: "Fecha de Aplicación",
            applicationQuantity: "Cantidad",
            message: "Razón",
            alert: "Alerta",
          },
        },
      },
    },
  },
  benchmark: {
    title: "Referencia",
    buttonNewBenchmark: "Nuevo punto de referencia",
    table: {
      title: "Lista de puntos de referencia",
      columns: {
        status: "Estado",
        description: "Benchmar",
      },
    },
    drawerTitle: "Lista de Benchmark",
    drawerTitleEdit: "Editar punto de referencia",
    drawerSubTitle:
      "Complete los campos a continuación para registrar un nuevo índice de referencia",
    drawerSubTitleEdit:
      "Complete los campos a continuación para editar un nuevo punto de referencia",
    validationMessage:
      "Rellene correctamente todos los campos obligatorios (*)",
    form: {
      name: "Nombre",
      namePlaceHolder: "Identificación",
      status: "Estado del índice de referencia",
      groupFarmVisibility: "¿Quién verá el punto de referencia?",
      radiogroup: {
        farm: "Esta granja solo",
        group: "Todas las granjas del Grou",
      },
      harvestDivider: "Cosecha sí",
    },
    errorAtLeastOneKPIValue:
      "Introduzca al menos un valor para los indicadores (KPI)",
    saveOptions: {
      only_save: "Salvar",
      save_and_create_new:
        "Guarde el punto de referencia y agregue un nuevo en",
    },
  },
  marketAnalysis: {
    title: "Curva de precios",
    buttonNewMarketAnalysis: "Nueva curva de precios",
    table: {
      title: "Lista de curvas de precios",
      columns: {
        status: "Estado",
        type: "Tipo",
        description: "Nombre",
        baseline: "Defaul",
      },
    },
    type: {
      bovexo: "BovExo",
      progressive: "Progresivo",
      linear: "Lineal",
      free: "Fre",
    },
  },
  feedFactoryParameters: {
    errorLoad: "Error al cargar los parámetros de la Fábrica de Ración.",
    errorSave: "Error al guardar los parámetros de la Fábrica de Ración.",
    successSave: "Parámetros de la Fábrica de Ración guardados con éxito.",
    form: {
      useFullMixerCapacity: "Usar capacidad total del mezclador",
      defaultWagon: "Mezclador predeterminado",
      standardCostPerBatch: "Costo fijo por batida",
      perBatch: "/batida",
    },
  },
  feedFactory: {
    tabs: {
      rawMaterials: "Materias Primas",
      supplements: "Recetas",
      productionOrders: "Órd. Producción",
      production: "Producción",
      feedingAutomation: "Automatización de Tratos",
    },
    buttonNewRawMaterial: "Nueva Materia Prima",
  },
  feedingAutomation: {
    emptyText:
      "Ninguna fabricación recibida de la automatización de tratos en el período seleccionado.",
    filters: { period: "Período" },
    situation: {
      open: "Abierta",
      finished: "Concluida",
      cancelled: "Cancelada",
    },
    launchType: { automatic: "Automático", manual: "Manual" },
    stockStatus: {
      Pending: "Esperando",
      Processing: "En proceso",
      Applied: "En stock",
      AppliedWithoutBalance: "Saldo negativo",
      Blocked: "Pendiente",
      Reversed: "Reversada",
    },
    stockStatusHelp: {
      Pending:
        "La salida de los ingredientes y la entrada de la ración aún no fueron generadas.",
      Applied: "Los ingredientes ya salieron del stock y la ración ya entró.",
      AppliedWithoutBalance:
        "El consumo fue registrado, pero el stock no tenía todo el ingrediente.",
      Blocked: "No fue posible mover el stock de esta fabricación.",
      Reversed:
        "La fabricación fue cancelada y los movimientos fueron reversados.",
    },
    stockReason: {
      MANUFACTURE_WITHOUT_RECIPE:
        "La fabricación llegó sin receta. Verifique el planeamiento de fase enviado por el socio.",
      RECIPE_NOT_FOUND:
        "La receta de esta fabricación no fue encontrada en esta hacienda.",
      RECIPE_WITHOUT_STOCK_ITEM:
        "La receta {{name}} no tiene ítem de stock para recibir la producción. Cree el ítem en la edición de la receta.",
      INGREDIENT_NOT_FOUND:
        "El ingrediente {{name}} no fue encontrado en esta hacienda.",
      INGREDIENT_WITHOUT_STOCK_ITEM:
        "El ingrediente {{name}} no tiene ítem de stock. Cree el ítem en la edición de la receta.",
      INGREDIENT_STOCK_ITEM_NOT_FOUND:
        "El ítem de stock del ingrediente {{name}} no fue encontrado en esta hacienda.",
      STOCK_ITEM_WITHOUT_UNIT:
        "El ítem de stock de {{name}} no tiene unidad de medida.",
      INGREDIENT_WITHOUT_COST:
        "No hay costo para mover el ingrediente {{name}}. Registre una entrada en su stock.",
      MANUFACTURE_WITHOUT_QUANTITY:
        "La fabricación llegó sin cantidad fabricada.",
      MANUFACTURE_WITHOUT_INGREDIENT:
        "La fabricación llegó sin ingrediente consumido.",
      MANUFACTURE_WITHOUT_DATE: "La fabricación llegó sin fecha.",
      MANUFACTURE_ALREADY_IN_STOCK:
        "Esta fabricación ya tiene movimientos de stock generados.",
      INSUFFICIENT_BALANCE:
        "El consumo de la fabricación fue registrado normalmente, pero el stock de {{name}} no tenía saldo suficiente y quedó negativo. Registre la entrada que falta para que el saldo vuelva a coincidir.",
      UNEXPECTED_ERROR:
        "Error inesperado al mover el stock de esta fabricación.",
    },
    flags: {
      leftover: "Sobra",
      substituted: "Sustituido",
      changed: "Alterado",
      realized: "Realizado",
    },
    columns: {
      day: "Día",
      manufactures: "Fabricaciones",
      manufactureDatetime: "Fecha y hora",
      time: "Hora",
      treatNumber: "Trato",
      supplementName: "Receta",
      wagonName: "Mezclador",
      situation: "Situación",
      stockStatus: "Stock",
      quantityPlanned: "Planeado (kg)",
      quantityManufactured: "Fabricado (kg)",
      quantityManufacturedDryMatter: "MS fabricada (kg)",
      deviationPercent: "Desvío",
    },
    details: {
      title: "Fabricación · Trato",
      manufactureDatetime: "Fecha y hora:",
      supplementName: "Receta:",
      wagonName: "Mezclador:",
      quantityPlanned: "Planeado:",
      quantityManufactured: "Fabricado:",
      quantityManufacturedDryMatter: "MS fabricada:",
      deviationPercent: "Desvío:",
      launchType: "Lanzamiento:",
      externalImportCode: "Código externo:",
      stockStatus: "Stock:",
      observation: "Observación:",
      noIngredients: "Ningún ingrediente informado en esta fabricación.",
      columns: {
        ingredient: "Ingrediente",
        quantityPlanned: "Planeado (kg)",
        quantityRealized: "Realizado (kg)",
        deviationPercent: "Desvío",
        flags: "Marcadores",
      },
    },
    messages: {
      errorLoad:
        "Error al cargar las fabricaciones de la automatización de tratos.",
    },
  },
  production: {
    buttonPrint: "Imprimir ficha",
    loadingBatches: "Cargando las batidas...",
    noBatchesYet: "Ninguna batida ejecutada todavía.",
    missingStockAlert:
      "Estas órdenes fueron calculadas con falta de insumo: {{codes}}. Verifique el stock antes de producir.",
    columns: {
      batches: "Batidas",
      plannedDryMatter: "Planificado (kg MS)",
      producedDryMatter: "Producido (kg MS)",
      realizedTotalCost: "Costo realizado",
    },
    batchColumns: {
      number: "Batida",
      date: "Fecha",
      plannedOriginalMatter: "Planeado (MO)",
      produced: "Producido (MO)",
      producedDryMatter: "Producido (MS)",
      deviation: "Desvío (MO)",
    },
    ingredientColumns: {
      name: "Insumo",
      planned: "Planeado (kg MO)",
      realized: "Usado (kg MO)",
      deviation: "Desvío (MO)",
    },
    noIngredients: "Ningún ingrediente registrado en esta batida.",
    menu: {
      executeBatch: "Ejecutar batida",
      closePartial: "Cerrar parcial",
      print: "Imprimir ficha",
    },
    details: {
      title: "O.P.",
      date: "Fecha:",
      targetDryMatter: "MS Objetivo:",
      batches: "Batidas:",
      totalCost: "Costo total:",
      costPerKg: "Costo/kgMS:",
      realizedCost: "Costo realizado:",
      batchLabel: "Batida",
      executed: "Ejecutada",
      planned: "Planificada",
      columns: {
        sequence: "Sec.",
        batchNumber: "Lote",
        mixingTime: "Tiempo",
        ingredient: "Insumo",
        plannedOriginalMatter: "MO Plan.",
        realizedOriginalMatter: "MO Real",
      },
    },
    batch: {
      title: "Ejecutar",
      batchLabel: "Batida",
      order: "Orden",
      recipe: "Receta",
      plannedPerBatch: "Planificado por batida",
      manufactureDate: "Fecha de producción",
      observation: "Observación",
      ingredients: "Insumos",
      totalUsed: "Total usado:",
      execute: "Ejecutar",
      columns: {
        ingredient: "Insumo",
        batch: "Lote",
        planned: "Planificado (kg)",
        realized: "Usado (kg)",
        deviation: "Desvío",
      },
    },
    messages: {
      errorLoad: "Error al cargar las órdenes de producción.",
      successExecute: "Batida ejecutada con éxito.",
      errorExecute: "Error al ejecutar la batida.",
      confirmClosePartial: "¿Confirma el cierre parcial de esta orden?",
      confirmClosePartialDetail: "Las batidas pendientes no serán producidas.",
      successClosePartial: "Orden cerrada parcialmente.",
      errorClosePartial: "Error al cerrar la orden parcialmente.",
      nothingToPrint:
        "Seleccione al menos una orden en la lista para imprimir la ficha.",
      errorPrint: "Error al generar la ficha de impresión.",
    },
  },
  productionOrder: {
    buttonNew: "Nueva Orden",
    table: {
      columns: {
        code: "Código",
        supplementName: "Receta",
        wagonName: "Mezclador",
        targetDryMatterKg: "Objetivo (kg MS)",
        plannedDryMatterKg: "Planificado (kg MS)",
        numberOfBatches: "Batidas",
        totalCost: "Costo total",
        costPerKgDryMatter: "Costo/kg MS",
        productionDate: "Fecha de producción",
        status: "Estado",
      },
    },
    status: {
      Calculated: "Calculada",
      Scheduled: "Programada",
      InProgress: "En proceso",
      ClosedTotal: "Cerrada total",
      ClosedPartial: "Cerrada parcial",
      Cancelled: "Cancelada",
    },
    menu: {
      schedule: "Programar",
      cancel: "Cancelar orden",
    },
    form: {
      titleCreateNew: "Nueva Orden de Producción",
      titleEdit: "Editar Orden de Producción",
      titleDetails: "Orden de Producción",
      supplement: "Receta",
      wagon: "Mezclador",
      productionDate: "Fecha de producción",
      targetDryMatterKg: "Objetivo (kg de MS)",
      useFullMixerCapacity: "Usar capacidad total del mezclador",
      observations: "Observaciones",
      buttonCalculate: "Calcular batidas",
      resultTitle: "Resultado del cálculo",
      numberOfBatches: "N° de batidas",
      dryMatterPerBatchKg: "Capacidad del mezclador (MS)",
      originalMatterPerBatchKg: "Capacidad del mezclador (MO)",
      plannedDryMatterKg: "MS planificada",
      plannedOriginalMatterKg: "MO total",
      inputCost: "Costo de los insumos",
      manufacturingCost: "Costo de fabricación",
      totalCost: "Costo total",
      costPerKgDryMatter: "Costo por kg de MS",
      itemsTitle: "Ingredientes",
      items: {
        supplementName: "Insumo",
        dryMatterPercentage: "Contenido de MS (%)",
        plannedDryMatterKg: "kg de MS",
        plannedOriginalMatterKg: "kg de MO",
        batch: "Lote",
        availableQuantity: "Saldo",
        unitCost: "Costo unitario",
        totalCost: "Costo total",
      },
      noBatch: "Sin lote",
      expiresAt: "vence el",
      mustCalculate: "Calcule las batidas antes de guardar.",
    },
    warnings: {
      title: "Avisos",
      targetAdjusted:
        "El objetivo se ajustó de {{informed}} a {{adjusted}} kg de MS para completar todas las batidas del mezclador.",
      missingStock:
        "Saldo insuficiente de {{name}}: la orden necesita {{required}} kg y hay {{available}} kg en stock. La orden se creará normalmente.",
      partialBatch:
        "Cada batida queda con {{batch}} kg de MS, {{missing}} kg por debajo de la capacidad del mezclador. Para producir con todas las batidas llenas, use {{suggested}} kg de MS.",
      missingCost:
        "{{name}} no tiene costo registrado ni entrada en el stock. Su costo se tomó como cero, por lo que el costo total de la orden está subestimado.",
      expiredBatch:
        "El lote {{batch}} de {{name}} está vencido desde {{expiration}}.",
      acknowledge: "Estoy enterado",
      acknowledged: "Enterado",
      pending:
        "Confirme todos los avisos para guardar la orden. Pendientes: {{count}}.",
    },
    errors: {
      NEGATIVE_COST:
        "El costo de {{name}} es negativo y no puede moverse al stock. Registre una entrada con el costo correcto antes de ejecutar la batida.",
      RECIPE_NOT_FOUND: "Receta no encontrada en esta hacienda.",
      SUPPLEMENT_NOT_FORMULATED:
        "El ítem seleccionado no es una receta formulada.",
      RECIPE_INACTIVE: "La receta {{name}} está inactiva.",
      RECIPE_WITHOUT_INGREDIENTS: "La receta {{name}} no tiene ingredientes.",
      RECIPE_WITHOUT_DRY_MATTER:
        "La receta {{name}} no tiene materia seca para producir.",
      WAGON_NOT_FOUND: "Mezclador no encontrado en esta hacienda.",
      WAGON_INACTIVE: "El mezclador {{name}} está inactivo.",
      WAGON_WITHOUT_CAPACITY:
        "El mezclador {{name}} no tiene capacidad registrada. Informe la capacidad en Parámetros de Manejo.",
      FEED_FACTORY_PARAMETERS_NOT_CONFIGURED:
        "Los parámetros de la Fábrica de Ración no están completos. Informe el costo fijo por batida en Parámetros.",
      INGREDIENT_NOT_FOUND: "No se encontró un ingrediente de la receta.",
      INGREDIENT_WITHOUT_STOCK_ITEM:
        "El ingrediente {{name}} no tiene ítem de stock. Vincule un ítem de stock en la pestaña Recetas o en el menú Stock.",
      INGREDIENT_STOCK_ITEM_NOT_FOUND:
        "El ítem de stock del ingrediente {{name}} no fue encontrado en esta hacienda.",
      INGREDIENT_WITHOUT_DRY_MATTER_PERCENTAGE:
        "El ingrediente {{name}} no tiene el contenido de materia seca informado.",
      SUPPLEMENT_REQUIRED: "Informe la receta.",
      WAGON_REQUIRED: "Informe el mezclador.",
      TARGET_DRY_MATTER_REQUIRED:
        "Informe el objetivo en kg de materia seca, mayor que cero.",
      PRODUCTION_DATE_REQUIRED: "Informe la fecha de producción.",
      REQUEST_REQUIRED: "No fue posible leer los datos de la orden.",
      ONLY_CALCULATED_CAN_BE_UPDATED:
        "Solo es posible editar una orden con estado Calculada.",
      ONLY_CALCULATED_CAN_BE_DELETED:
        "Solo es posible eliminar una orden con estado Calculada.",
      ONLY_CALCULATED_CAN_BE_SCHEDULED:
        "Solo es posible programar una orden con estado Calculada.",
      ONLY_CALCULATED_OR_SCHEDULED_CAN_BE_CANCELLED:
        "Solo es posible cancelar una orden con estado Calculada o Programada.",
    },
    readiness: {
      title: "Esta receta todavía no puede generar orden de producción",
      withoutStockItem:
        "Sin ítem de stock: {{names}}. Vincule un ítem de stock a cada uno en el menú Stock.",
      withoutDryMatter:
        "Sin contenido de materia seca: {{names}}. Informe el contenido de MS en el suplemento.",
    },
    messages: {
      errorLoad: "Error al cargar las órdenes de producción.",
      errorCalculate: "Error al calcular las batidas.",
      successSave: "Orden de producción guardada con éxito.",
      errorSave: "Error al guardar la orden de producción.",
      successSchedule: "Orden de producción programada con éxito.",
      errorSchedule: "Error al programar la orden de producción.",
      successCancel: "Orden de producción cancelada con éxito.",
      errorCancel: "Error al cancelar la orden de producción.",
      successDelete: "Orden de producción eliminada con éxito.",
      errorDelete: "Error al eliminar la orden de producción.",
      confirmDelete: "¿Confirma la eliminación de esta orden de producción?",
      confirmSchedule: "¿Confirma la programación de esta orden de producción?",
      confirmCancel: "¿Confirma la cancelación de esta orden de producción?",
      noRecipes:
        "Ninguna receta disponible. Registre una formulación en la pestaña Recetas.",
    },
  },
  supplement: {
    title: "Supleménte./Concent.",
    buttonNewSupplement: "Nuevo Suplèm./Concent.",
    buttonNewSupplementFormulated: "Nuevo Formulación",
    table: {
      title: "Lista de Supplem./Concent.",
      columns: {
        status: "Estado",
        description: "Supleménte./Concent.",
        industrialName: "Marca",
        supplierName: "Fabricante",
        createdAt: "Fecha de creación",
        userName: "Creado por",
        version: "Versión",
        cp: "CP: Proteína bruta",
        tdn: "TDN: Nutrientes Digestibles Totales",
        npn: "NNP - Compuestos nitrogenados no proteicos (máx.)",
        dryMatterPercentage: "DM: Materia seca",
        phosphorus: "Fósforo",
        nitrogen: "Nitrógeno",
        calcium: "Calcio",
        zinc: "Zinc",
        sodium: "Sodio",
        additiveEffect: "Efecto aditivo",
        fda: "ADF",
        lignin: "Lignina",
        ee: "Extracto de éter",
      },
    },
    drawerTitle: "Supleménte./Concent. Lista",
    drawerTitleEdit: "Editar Supllem./Concent.",
    drawerSupplementFormulatedTitle: "Registro de Formulación",
    drawerSupplementFormulatedTitleEdit: "Editar Formulación",
    drawerSubTitle:
      "Complete los campos a continuación para registrar un nuevo Supplem./Concent.",
    drawerSubTitleEdit:
      "Complete los campos a continuación para editar un nuevo Suplemento/Contenido.",
    drawerSupplementFormulatedSubTitle:
      "Complete los campos a continuación para registrar una nueva formulación de Suplemento/Concentración.",
    drawerSupplementFormulatedSubTitleEdit:
      "Complete los campos a continuación para editar la formulación de Suplemento/Concentración.",
    validationMessage:
      "Rellene correctamente todos los campos obligatorios (*)",
    form: {
      stockItemsDivider: "ÍTEMS DE STOCK",
      restrictionsDivider: "RESTRICCIONES",
      supplementType: "Ración o Suplegio.?",
      supplementTypeHelp:
        "Ración/Mezcla: Dieta preparada, producida en la propia granja. Suplementos: Producto comprado y suministrado en forma pura.",
      supplementClassification:
        "¿Cuál es la clasificación de la Suplema/Ración?",
      supplementClassificationHelp: {
        title_0: "Suplemento mineral.",
        description_0:
          " Cuando contenga macro y/o micro elementos minerales en su composición, y pueda presentar, en el producto final, un valor inferior al cuarenta y dos por ciento de proteína equivalente.",
        title_1: "Suplemento proteína-mineral.",
        description_1:
          " cuando tenga en su composición, macro y/o micro elemento mineral, al menos un 20% de proteína bruta (PC) y aporte, al menos, 30 gramos de proteína bruta (PC) por cada 100 kg de peso corporal.",
        title_2: "Suplemento Energético-Proteína-Mineral",
        description_2:
          " cuando tenga en su composición, macro y/o micro elemento mineral, al menos un 20% de proteína bruta, aportará al menos 30 gramos de proteína bruta y 100 gramos de nutrientes digestibles totales (TDN) por cada 100 kg de peso corporal.",
        source: "*Según MAPA brasileño - IN12 2004/11/30",
      },
      name: "Nombre genérico",
      namePlaceHolder: "Identificación",
      importCode: "Importación de código",
      mixingTime: "Tiempo de Mezcla",
      mixingTimeHelp:
        "Tiempo total de mezcla, en minutos: es la suma de los tiempos informados en los ingredientes de la receta.",
      stabilityRange: "Rango de Estabilidad",
      stabilityRangeHelp:
        "Ingrese el Rango de Estabilidad de la Materia Prima para iniciar el conteo para pasar al siguiente ingrediente en el mezclador.",
      stabilityTime: "Tiempo de Estabilidad",
      stabilityTimeHelp:
        "Ingrese el Tiempo de Estabilidad de la Materia Prima después de la adición, en minutos.",
      inclusionOrder: "Secuencia de Mezcla",
      itemMixingTime: "Tiempo de mezcla (min)",
      createStockItem: "Crear ítem de stock",
      createStockItemHelp:
        "Cree un ítem de stock cuando el producto de la receta se almacene. Una receta servida directo en el comedero no necesita un ítem de stock nuevo.",
      stockItem: "Ítem de stock",
      stockItemEditHelp:
        "El ítem de stock vinculado a la receta no se edita aquí. Para cambiarlo, use el menú Stock.",
      stockItemGroupRecipeHelp:
        "Esta receta es compartida por todas las haciendas del grupo. Los ítems de stock son por hacienda, por eso ni el ítem de la receta ni los de los ingredientes pueden ser creados o vinculados desde aquí.",
      rationStockItemTitle: "Ítem de stock de la ración",
      rationStockItemHelp:
        "Producto final de esta receta. Necesario cuando la ración se almacena antes de ir al comedero.",
      ingredientsStockItemsTitle: "Ítems de stock de los ingredientes",
      ingredientsStockItemsHelp:
        "Materias primas de la receta, consumidas del stock en cada batida.",
      stockItemInternalId: "Identificación",
      stockItemAbbreviation: "Abreviación",
      stockItemUnit: "Unidad de medida",
      ingredient: "Ingrediente",
      stockItemGroupItem: "Grupo",
      stockItemItemGroup: "Subgrupo",
      baseAmount: "Por cada",
      observations: "Observaciones",
      observationsPlaceHolder: "Observaciones de la receta",
      industrialName: "Marca",
      industrialNamePlaceHolder: "Marca",
      supplierName: "Fabricante",
      supplierNamePlaceHolder: "Nombre del fabricante",
      status: "Supleménte./Concent. Estado",
      nutritionalDataDivider: "Datos nutricionales",
      capacityDivider: "Cantidad por tipo de oferta",
      sustenanceCapacity: "Cantidad por tipo de oferta",
      information: 'Toda la información está relacionada con "Animal/día"',
      sustenanceCapacityDrawerTitle: "Cantidades por tipo de oferta.",
      minimumAmount: "Min Amt.",
      maximumAmount: "Max Amt.",
      minimum: "Min",
      maximum: "Máximo",
      ratio: "Proporción",
      cost: "Costo diario",
      costPlaceHolder: "Unidad: $",
      cp: "CP: Proteína bruta",
      cpPlaceHolder: "Unidad: g/kg",
      tdn: "TDN: Nutrientes Digestibles Totales",
      tdnPlaceHolder: "Unidad: g/kg",
      npn: "NNP - Compuestos nitrogenados no proteicos (máx.)",
      npnPlaceHolder: "Unidad: g/kg",
      dryMatterPercentage: "DM: Materia seca",
      phosphorus: "Fósforo",
      phosphorusPlaceHolder: "Unidad: g/kg",
      nitrogen: "Nitrógeno",
      nitrogenPlaceHolder: "Unidad: mg/kg",
      calcium: "Calcio",
      calciumPlaceHolder: "Unidad: g/kg",
      zinc: "Zinc",
      zincPlaceHolder: "Unidad: mg/kg",
      sodium: "Sodio",
      sodiumPlaceHolder: "Unidad: g/kg",
      voluntaryConsumption: "Alimentación voluntaria",
      minimumVoluntaryConsumptionPlaceHolder: "Informar",
      maximumVoluntaryConsumptionPlaceHolder: "Informar",
      pure: "Ofrenda de puros",
      mix: "Oferta de productos mixtos",
      recommendedTrough: "Tamaño de comedero recomendado",
      recommendedTroughPlaceHolder: "Informar",
      groupFarmVisibility: "¿Quién usará el Suplemento/Concent.?",
      radiogroup: {
        farm: "Esta granja solo",
        group: "Todas las granjas del grupo",
      },
      additiveEffect: "Efecto aditivo",
      additiveEffectPlaceHolder: "Unidad: g/dia",
      additiveEffectHelp:
        "Algunos suplementos minerales tienen aditivos en su formulación que mejoran la ganancia de peso de los animales, y el proveedor puede indicar una ganancia incremental (g/día), que se suma a la ganancia prevista calculada (Pastura + Suplemento) o indicar un aumento porcentual en la Proteína Bruta total (PC) a considerar en el cálculo.",
      fda: "ADF",
      fdaPlaceHolder: "Unidad: g/kg",
      lignin: "Lignina",
      ligninPlaceHolder: "Unidad: g/kg",
      ee: "Extracto etéreo",
      eePlaceHolder: "Unidad: %/m",
    },
    formFarmRestrictions: {
      title: "Restricciones",
      reproductiveStatusList: "Estados Reproductivos",
      minSupplementOfferedPerDay: "Oferta Mínima (/día)",
      maxSupplementOfferedPerDay: "Oferta Máxima (/día)",
      maxDays: "Días Máximos",
      age: "Edad (meses)",
      liveWeight: "Peso Vivo (kg)",
      minimum: "Mín.",
      maximum: "Máx.",
      male: "Machos",
      female: "Hembras",
      calf: "Terneros",
      heifer: "Novillas",
      reproductiveStatusOptions: {
        castrated_male: "Machos Castrados",
        pregnant_female: "Hembras Gestantes",
        anestrous_female: "Hembras en Anestro",
        lactating_female: "Hembras Lactantes",
        lactating_calf: "Terneros/Novillas Lactantes",
        supplemented_animals: "Animales Suplementados",
        breeding_males: "Machos Reproductores",
        dairy_cows: "Vacas Lecheras",
        animals_on_pasture: "Animales en Pastoreo",
      },
    },
    confirmClearNutritionalData:
      "Estás deseleccionando el Ingrediente/Suplemento Original. ¿Deseas borrar los datos relacionados?",
    errorVoluntaryConsumptionMaximumLessThanMinimum:
      "El consumo máximo recomendado por el proveedor debe ser mayor o igual al consumo mínimo.",
    errorPureMaximumLessThanMinimum:
      "La Oferta Pura máxima debe ser mayor o igual a la Oferta Pura mínima.",
    errorPureMaximumTroughLessThanMinimumTrough:
      "El valor máximo recomendado en comedero para la Oferta Pura debe ser mayor o igual al valor mínimo.",
    errorMixMaximumLessThanMinimum:
      "La Oferta Mezcla máxima debe ser mayor o igual a la Oferta Mezcla mínima.",
    errorMixMaximumTroughLessThanMinimumTrough:
      "El valor máximo recomendado en comedero para la Oferta Mezcla debe ser mayor o igual al valor mínimo.",
    errorNecessarySustenanceCapacity:
      "Es necesario ingresar los datos de cantidad por tipo de oferta.",
    errorWrongNpnInput:
      "¡Atención! Solo se clasifican como Suplementos Minerales los productos con hasta 42,0 % de NNP - Equivalente Proteico. Por favor, verifica la Clasificación de este Suplemento.",
    errorNecessaryFormulatedItems:
      "Es necesario ingresar al menos una materia prima.",
    errorFormulatedItemWithoutRawMaterial: "Debes indicar la materia prima.",
    errorFormulatedItemWithoutAmount:
      "Debes indicar la cantidad de la materia prima.",
    errorFormulatedItemTotalAmount:
      "La suma de las materias primas en % debe ser exactamente 100%. Suma actual:",
    ingredientWithoutName: "ingrediente sin nombre",
    errorIngredientStockItemWithoutGroup:
      "Informe el Grupo y el Subgrupo del ítem de stock de estos ingredientes: {{names}}.",
    ingredientStockItemsBlockTitle:
      "Algunos ingredientes todavía no tienen ítem de stock",
    ingredientStockItemsBlockHelp:
      "Al guardar, se creará el ítem de stock de estos ingredientes: {{names}}. Informe el Grupo y el Subgrupo de cada uno.",
    ingredientStockItemsWillBeCreated:
      "Se crearán {{count}} ítems de stock para los ingredientes:",
    ingredientsWillUseFarmCopy:
      "Estos ingredientes pasarán a usar el registro de la propia hacienda:",
    errorStockItemNotSelected:
      "Debes seleccionar un ítem de stock para la receta",
    errorStockItemWithoutInternalId:
      "Debes indicar la identificación del ítem de stock",
    errorStockItemWithoutUnit:
      "Debes indicar la unidad de medida del ítem de stock",
    errorStockItemWithoutGroup:
      "Debes indicar el grupo y el subgrupo del ítem de stock",
    errorFormulatedItemWithItself:
      "La receta no puede ser materia prima de sí misma",
    errorFormulatedItemWithoutAddedAmount:
      "Debes indicar la cantidad en kg de materia seca de la materia prima agregada",
    errorFormulatedItemWithoutBaseAmount:
      "Debes indicar cada cuántos kg de materia seca de la mezcla se agrega la materia prima",
    errorFormulatedItemWithoutPercentItems:
      "La receta necesita al menos una materia prima en % para formar la mezcla",
    errorFormulatedItemAddedInclusionOrder:
      "La materia prima agregada por kg cada X kg debe tener secuencia de mezcla posterior a las materias primas en %",
    errorFormulatedItemWithoutOriginalMatterAmount:
      "Debes indicar la cantidad de materia original.",
    errorFormulatedItemWithDuplicate:
      "Cada materia prima debe indicarse solo una vez.",
    errorVoluntaryConsumptionType:
      "El tipo de consumo voluntario debe ser igual al campo Oferta en las restricciones",
    successInactivate: "El complemento se ha desactivado correctamente",
    errorInactivate:
      "El complemento no se ha desactivado. Contacte con el soporte técnico.",
    successActivate: "El complemento se activó correctamente",
    errorActivate:
      "El complemento no se ha activado. Contacte con el soporte técnico.",
    successSaveFormulated: "Formulación guardada correctamente",
    errorSaveFormulated: "Error al guardar la formulación",
    errorSaveFormulatedNutrientsMismatch:
      "Los valores nutricionales de la formulación no coinciden con las materias primas. Alguna materia prima puede haber sido modificada: cierre, abra la formulación nuevamente y guarde.",
    saveOptions: {
      only_save: "Salvar",
      save_and_create_new: "Guarde y agregue un nuevo Supplem./Concent",
    },
    details: {
      tabs: {
        supplementData: "Suplemento",
        supplementHistory: "Datos históricos",
      },
      supplementType: "Tipo",
      supplementClassification: "Clasificación",
      name: "Nombre genérico",
      industrialName: "Marca",
      supplierName: "Fabricante",
      ratio: "Proporción",
      cost: "Costar",
      nutritionalDataDivider: "Datos Nutricionales",
      tdn: "TDN: Nutrientes Digestibles Totales",
      cp: "CP: Proteína bruta",
      dryMatterPercentage: "MS: Matéria Seca",
      calcium: "Calcio",
      phosphorus: "Fósforo",
      nitrogen: "Nitrógeno",
      zinc: "Zinc",
      sodium: "Sodio",
      voluntaryConsumption: "Alimentación voluntaria",
      pure: "Amt. de Producto Puro",
      mix: "Amt. de Mixto",
      recommendedTrough: "Recom. Artesa",
      minimum: "Min.",
      maximum: "Máximo.",
      information: 'Toda la información está relacionada con "Animal/día"',
      capacityDivider: "CANTIDADES POR MODO DE OFERTA",
      sustenanceCapacity: "CANTIDADES POR MODO DE OFERTA",
      sustenanceCapacityDrawerTitle:
        "Cantidades por modo de oferta de suplemento/concentrado.",
      npn: "NNP - Compuestos nitrogenados no proteicos (máx.)",
      additiveEffect: "Efecto aditivo",
      fda: "ADF",
      lignin: "Lignina",
      ee: "Extracto etéreo",
    },
  },
  lot: {
    validationMessage:
      "Rellene correctamente todos los campos obligatorios (*)",
    tabs: {
      production: "Producción",
      movementHistory: "Bitácora de Movimientos",
      receipt: "Recibir",
    },
    production: {
      title: "Lotes de producción",
      buttonNewLot: "Nuevo lote de producción",
      details: {
        breadCumbsProductionLot: "Lotes de producción",
        breadCumbsLotDetails: "Detalles del lote ",
        createdAt: "Creado:",
        options: "Opciones",
        labelSystem: "ACTIVIDAD",
        labelDietStrategy: "Estrategia de dieta",
        baseline: "Referencia",
        optionalStrategies: "Estrategias opcionales",
        optional: "Opcionales",
        labelAnimals: "ANIMALES",
        labelAsymptoticWeight: "PESO SIGMOIDE",
        labelMarketValuation: "VALOR DE MERCADO",
        labelProductionCost: "Costo de producción",
        makeValuation: "Evaluación de ejecución",
        labelWeights: "PESADAS",
        labelAverageWeight: "PESO PROMEDIO:",
        labelAverageWeightGain: "Subdirector General:",
        labelPicket: "PADRADO / CORRAL:",
        labelProductionArea: "ÁREA ÚTIL:",
        labelTotalArea: "SUPERFICIE TOTAL:",
        labelSupportCapacity: "Tapa de transporte:",
        titleAnimals: "Animales",
        titleWeigth: "Peso",
        viewBy: "Ver por:",
        tooltipEstimatedCurve:
          'Curva teórica obtenida de BREED. Haga clic en "Estimar para BATCH" para establecer los valores de BATCH',
        rankBy: "Clasificar por",
        supplementSupply: {
          title: "Suministro de Suplemento",
          refreshData: "Actualizar datos",
          hidePanels: "Ocultar paneles",
          showPanels: "Mostrar paneles",
          dashboards: {
            perDiet: "Por Dieta",
            totalCost: "Costo Total Asignado",
            averageConsumeMO: "Consumo Promedio MO",
            averageConsumeMS: "Consumo Promedio MS",
            animalCostPerDay: "Costo Asignado",
            totalAnimalCost: "Costo Total",
            suffixCabDay: "Cab/día",
            suffixCab: "Cab",
            columns: {
              diet: "Dieta",
              days: "Días",
              amountSupplied: "Cantidad Suministrada (kg)",
              cost: "Costo",
            },
          },
          table: {
            columns: {
              date: "Fecha",
              treatNumber: "N° Trato",
              picketName: "Potrero/Corral",
              supplementName: "Dieta",
              amountAnimals: "Cant. Cab.",
              totalSupplyCost: "Costo",
              treatQuantitySupplied: "Cantidad Suministrada (Kg) MO",
              totalSupplementSuppliedInKilosPerAnimal: "Cons. MO/Cab",
              dryMatterPercentage: "%MS",
              totalSupplementSuppliedInDryMatter:
                "Cantidad Suministrada (Kg) MS",
              totalSupplementSuppliedInDryMatterPerAnimal: "Cons. MS/Cab",
            },
          },
        },
      },
      table: {
        columns: {
          lotNumber: "Número de lote",
          lotName: "LOTE",
          salesScenario: "Escenario de ventas",
          dietStrategyName: "Estrategia de dieta",
          profitCenter: "Actividad",
          createdAtAndEndAt: "Apertura/Cierre",
          status: "Estado",
          amount: "Oficina.",
          gdp: "WDA",
          gmd: "Subdirector General",
          diet: "Dieta",
          averageWeight: "Peso medio",
          target: "Targe",
          picketName: "Potrero/Corral",
        },
      },
      drawer: {
        title: "Crear lote de producción",
        titleEdit: "Editar lote de producción",
        subtitle: "Complete los campos a continuación para crear un LOTE",
        subtitleEdit: "Complete los campos a continuación para editar un lote",
        form: {
          status: "Estado",
          name: "Nombre del lote*",
          namePlaceHolder: "Nombre del lote",
          identification: "Código de Importación",
          identificationPlaceHolder: "Código de Importación",
          profitCenter: "Actividad*",
          profitCenterPlaceHolder: "Seleccione la Actividad",
          asymptoticWeight: "Peso Asintótico",
          carcassHarnessing: "Rendimiento de la Canal",
          informPlaceHolder: "Ingrese",
          picket: "Potrero / Corral",
          picketMessage:
            "Seleccione el potrero / corral si desea asignar este lote",
          picketPlaceHolder: "Seleccione el potrero / corral",
          projectionWeightType: "Tipo de proyección de peso",
          projectionWeightTypeDietStrategy: "Estrategia de dieta",
          projectionWeightTypeFarmProjection: "Proyección de ganancia de peso",
          weightGainProjection: "Proyección de ganancia de peso",
          weightGainProjectionPlaceholder: "Seleccione la proyección",
          startWeightGainProjectionDate:
            "Fecha de inicio de la proyección de ganancia de peso",
          dietStrategyBaseLine: "Estrategia de dieta",
          dietStrategyBaseLineMessage:
            "Seleccione la estrategia que se utilizará para la alimentación de los animales añadidos a este lote",
          dietStrategies: "Estrategia de Dieta - Opcional",
          dietStrategiesPlaceHolder:
            "Seleccione una o más estrategias de dieta",
          dietStrategiesTooltip:
            "Las estrategias de dieta opcionales seleccionadas se utilizarán más adelante en las simulaciones de escenarios de compra y venta",
          checkboxSaveAndAddNewAnimals: "Guardar y agregar animales",
          picketId: "Potrero",
          picketLotEntry: "Fecha de entrada del Lote",
          breedId: "Raza",
          referenceAcquisitionDate: "Fecha de adquisición",
          referenceBirthdayDate: "Fecha de nacimiento del animal",
          dismembermentDate: "Fecha de desmembramiento",
          referenceAcquisitionWeight: "Peso medio por animal",
        },
        warningPendingTitle: "Lote pendiente",
        warningPendingDescription: "El lote está pendiente de aprobación",
        gmdCurve: {
          buttonOpen: "Curva GMD",
          title: "Curva de Crecimiento GMD",
          subtitle: "Defina el tipo de ganancia media diaria para este lote",
          dividerTitle: "CURVA GMD",
          dividerChart: "GRÁFICO DE LA CURVA",
          form: {
            startGainWeightDate: "Fecha de inicio de ganancia de peso",
            startGainWeightDatePlaceholder: "Seleccione la fecha",
            informType: "Tipo de información",
            informTypePeriod: "Por período",
            informTypeFixed: "Fijo",
            timeUnitReference: "Unidad de tiempo",
            timeUnitReferenceDay: "Día",
            timeUnitReferenceWeek: "Semana",
            fixedGmdWeight: "GMD fijo (kg/día)",
            fixedGmdWeightPlaceholder: "0,000",
            period: "Período",
            periodPlaceholderDay: "Nº del día",
            periodPlaceholderWeek: "Nº de la semana",
            gmdWeight: "GMD (kg/día)",
            gmdWeightPlaceholder: "0,000",
            buttonAddPeriod: "Agregar período",
            buttonDeletePeriod: "Eliminar",
            buttonConfirm: "Confirmar",
          },
          table: {
            columnPeriod: "Período",
            columnGmdWeight: "GMD (kg/día)",
            columnActions: "Acciones",
          },
          chart: {
            titleX: "Período",
            titleY: "GMD (kg/día)",
            seriesName: "Curva GMD",
          },
          validation: {
            periodMustBeIncreasing:
              "El período debe ser mayor que el período anterior",
            gmdWeightMustBePositive: "El GMD debe ser mayor que cero",
            atLeastOnePeriod: "Agregue al menos un período",
          },
        },
      },
      saveOptions: {
        only_save: "Salvar",
        save_and_create_new: "Guardar y agregar un nuevo BATC",
      },
      addAnimalsPage: {
        listLotProduction: "Lista: Lotes de producción",
        title: "Añadir animal al lote",
        descriptionMessage:
          "Seleccione los animales en la columna gris y muévalos a la columna naranja haciendo clic en el botón",
        selectPlaceHolder:
          "Seleccionar la raza de animales que deben componer el LOTE",
        listAnimals: "Lista de animales",
        productionLot: "Producción BATCH",
        modal: {
          message: "Haga clic en confirmar para agregar los animales al lote",
          lot: "LOTE",
          profitCenter: "Actividad",
          amount: "Amoun",
        },
        error: {
          noAnimalsTitle: "Error",
          noAnimalsMessage: "Debes seleccionar al menos un ánima",
        },
      },
      dismemberLotPage: {
        listLotProduction: "Lista: Lotes de producción",
        title: "LOTE DIVIDIDO",
        descriptionMessage:
          "Seleccione los animales en la tabla y haga clic en el botón 'Dividir' para reubicar a los animales",
        profitCenter: "Actividad",
        productionSubSystem: "Subsistema de producción",
        animalsTotal: "Total de animales",
        animalsSelected: "Animales seleccionados",
        dismemberButton: "Partir",
        destinationLots: "LOTES de destino",
        drawer: {
          title: "LOTE DIVIDIDO",
          description:
            "Seleccione a continuación si la subdivisión será en un nuevo LOTE o en un LOTE existente.",
          newButton: "Nuevo",
          existingButton: "Existente",
          alertMessage:
            "La actividad del BATCH informado difiere del BATCH actual",
          searchInputPlaceHolder: "Búsqueda por LOTE I",
        },
      },
      tabs: {
        calf: "Cria",
        rearingFattening: "Recria/Engorda",
      },
    },
    receipt: {
      title: "Recepción de BATCHs",
      buttonNewLot: "Nuevo",
      collapse: {
        animals: "Animales",
        receiptIn: "Recibido o",
      },
      table: {
        columns: {
          breed: "Raza",
          gender: "Género",
          birthday: "Edad (meses)",
          weight: "Peso estimado",
          amount: "Qtd. animais",
          confirmedAmount: "De los animales recibidos",
          purchaseCost: "Coste de adquisición",
          numbers: "Numeración",
        },
        boitelColumns: {
          identification: "Identificación",
          amount: "De los animales",
          breed: "Raza",
          entryDate: "Fecha de ingreso",
          weightRange: "Rango de peso",
          confirmedAmount: "De los animales recibidos",
          identifiedAmount: "De los animales identificados",
          status: "Statu",
        },
        status: {
          confirmed: "Empedernido",
          pending: "Pendin",
        },
      },
      finalize: {
        title: "Creación de BATCH de recepción",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        buttonFinalize: "FINALIZAR LA RECEPCIÓN",
        buttonFinalizeCancel: "CANCELAR RECIBO",
        supplier: "Proveedor",
        dateReceiving: "FECHA DE RECEPCIÓN",
        animalsReceived: "De los animales recibidos",
        grid: {
          title: "Recepción de BATCH",
          animalsInserted: "Animales añadidos",
          buttonAddAnimals: "Añade animales",
          columns: {
            breed: "Raza",
            gender: "Género",
            birthday: "Edad (meses)",
            weight: "Peso estimado",
            amount: "Oficina.",
            purchaseCost: "Coste de adquisición",
            numbers: "Numeración",
          },
          deleteBox: {
            description: "Tras la confirmación, el lote se eliminará",
            buttonConfirm: "Confirmar",
            buttonCancel: "Cance",
          },
        },
        newLotAnimalsReceipt: {
          title: "Nuevos animales",
          description: "Rellenar los datos de recepción del animal",
          saveOptions: {
            only_save: "Salvar",
            save_and_create_new: "Guardar y crear un nuevo recibo",
            save_and_handle: "Guardar y empezar a criar",
          },
        },
        newLotItem: {
          title: "Agrupamiento de animales",
          description:
            "Agrupe los animales que se reciben de acuerdo con sus características completando la información a continuación.",
          tabGeneralTitle: "General",
          tabNumbersTitle: "Numeración",
          breed: "Raza",
          gender: "Género",
          birthday: "DOB",
          birthdayPlaceHolder: "Escoger",
          estimatedWeight: "Peso estimado",
          estimatedWeightPlaceHolder: "Introduzca el peso (kg)",
          amount: "Importe",
          amoutPlaceHolder: "Ingresa el monto",
          purchaseCost: "Coste de adquisición",
          purchaseCostPlaceHolder: "Introduzca el coste de adquisición",
          usePrefixedIdentification: "Usar identificación con prefijo",
          animalCost: "Costo animal",
          animalCostPlaceHolder: "Introduzca el costo del animal",
          shippingCost: "Flete",
          shippingCostPlaceHolder: "Introduzca el valor del flete",
          commissionAuctionCost: "Comisión Subasta",
          commissionAuctionCostPlaceHolder:
            "Introduzca el valor de la comisión",
          fees: "Otras Tasas",
          feesPlaceHolder: "Introduzca el valor de otras tasas",
          totalAnimalCost: "Costo Total Animal",
          totalAnimalCostPlaceHolder: "Costo total calculado automáticamente",
          initialIdentificationSequence: "Secuencia inicial de identificación",
          initialIdentificationSequencePlaceHolder:
            "Introduzca la secuencia inicial",
          initialIdentificationSequenceExample:
            "Ejemplo: Si introduce 'ABC123', los animales serán identificados como ABC124, ABC125, ABC126...",
          rangeDescription:
            "Suma el número de animales que tienen las características",
          range: "Gamas",
          numbersInserted: "Números introducidos",
          animalFarmFunction: "Propósito",
          animalReproductionCategory: "Categoría",
          saveOptions: {
            only_save: "Salvar",
            create_new: "Guardar y crear nuevos animales receiivin",
          },
        },
        errors: {
          noAnimalsAdd: {
            title: "No se añaden animales",
            description: "Es necesario añadir la cantidad informada de animal",
          },
          amountAnimalsInLotItenBiggerThanAmountAnimalsReceveid: {
            title: "El número de animales es superior a",
            description:
              "El número de animales inscritos es mayor que el indicado en el BATC receptor.",
          },
          amountAnimalsInLotItenLessThanAmountAnimalsReceveid: {
            title: "Número de animales inferior a",
            description:
              "El número de animales inscritos es inferior al indicado en el documento de recepción.",
          },
          amountAnimalsInLotItenBiggerThanAmountReported: {
            title: "Número de animales no válido",
            description:
              "El número de animales inscritos es mayor que el indicado en la cantidad BATCH.",
          },
        },
      },
      supplier: {
        title: "Entrada de Animales - Compra",
        buttonNext: "Próximo",
        buttonBack: "Atrás",
        titleBox: "Registro de recibos",
        messageError: "Rellene todos los campos obligatorios (*)",
        supplierTitle: "Proveedor",
        supplierComboBoxPlaceHolder: "Escoger",
        lotName: "Nombre del lote",
        lotNameInputPlaceHolder: "Recepción del nombre del lote",
        dateTitle: "Fecha de ingreso",
        datePlaceHolder: "Escoger",
        shouldCreateLotEntry: "¿Publicar y crear animales?",
        buttonToday: "HOY",
        qtyAnimalsTitle: "Cantidad de animales",
        qtyAnimalsInputPlaceHolder: "Cantidad de animales",
        receiptNameTitle: "Número de recibo",
        supplierInformationsTitle: "Datos de proveedores",
        documentTitle: "EIN",
        responsibleTitle: "Responsable",
        emailTitle: "Correo electrónico",
        contactTitle: "Contacto",
        addressTitle: "Direcciones",
      },
      messages: {
        successDeleteMessage: "Lote de recepción eliminado con éxito",
        errorDeleteMessage:
          "Error al eliminar el lote de recepción. Contacte al soporte.",
      },
    },
  },
  picket: {
    status: {
      break: "Descansando",
      pasturage: "Pastoreo",
      renovation: "Renovación",
      maintenance: "Mantenimiento",
      leased: "Arrendado",
      deleted: "Borrado",
      active: "Activo",
      inactive: "Inactiv",
    },
    dashboards: {},
    propertyType: {
      own: "Propiedad",
      foreign: "Rente",
    },
    tabs: {
      picket: "Potrero/Corral",
      retreat: "Unidad de rango/RO",
      map: "Mapa",
    },
    title: "Listado de Paddocks/Corrales",
    buttonNewPicket: "Nuevo Paddock/Corral",
    table: {
      columns: {
        picketName: "Potrero/Corral",
        totalAndProductionArea: "Total/Superficie útil",
        propertyType: "Tipo",
        profitCenterName: "Actividad",
        lotName: "LOTE",
        status: "Estado",
        inAndOutLot: "Entrada de lote",
        supportCapacity: "Tapa de transporte.",
        averageWeight: "Peso medio",
        gmd: "Subdirector General",
        amountAnimals: "Oficina",
      },
    },
    pastureTable: {
      title: "Estado de los pastizales",
      titleTooltip:
        "El Gráfico de Estado de Pastura proporciona diferentes vistas para que pueda monitorear y planificar el movimiento de los animales entre potreros, con el fin de optimizar el uso de la pastura. - MS Stock: Muestra la disponibilidad de MS (%) del forraje utilizado, de acuerdo con la temporada climática y el consumo de los animales presentes en el potrero. La rutina de recálculo se realiza diariamente para actualizar la disponibilidad estimada para los próximos 30 días. - Tasa de Abastecimiento: Muestra la relación de Oferta y Consumo de Materia Seca (MS) del forraje disponible en el potrero, mostrando la cantidad de días que el lote de animales puede permanecer en el potrero, de acuerdo con el stock de MS disponible y el consumo esperado de los animales.",
      columns: {
        picketName: "Paddock",
        status: "Estado",
        days: "Accum. Días",
        lotation: "Rata de calcetín",
      },
      tableType: {
        dryStockOption: "DM disponible",
        OfferRateOption: "DM rati",
      },
    },
    drawerTitle: "Registro de Paddock/Corral",
    drawerTitleEdit: "Editar Paddock",
    drawerTitleEditIntensiveSubSystem: "Editar bolígrafo",
    drawerSubTitle:
      "Complete los campos a continuación para crear un nuevo paddock/corral",
    drawerSubTitleEdit:
      "Complete los campos a continuación para editar un nuevo paddock/corral",
    drawerAllocateLotTitle: "Asignación de lotes en el paddock/corral",
    drawerAllocateLotSubTitle: "Asignación de lotes en el paddock/corral",
    validationMessage:
      "Rellene correctamente todos los campos obligatorios (*)",
    searchInputPlaceHolder: "Busque el ID de lote y presione (ENTER).",
    alertLotWithProfitCenterDifferent:
      "¡La actividad del lote seleccionado se atribuirá al Paddock/Pen!",
    detail: {
      name: "Identificación",
      productionSubSystem: "Subsistema",
      supplierId: "Proveedor",
      supplierDivider: "Proveedor",
      sustenanceCapacityDivider: "Tapa de transporte.",
      pastureDivider: "FORRAJE",
      infrastructureDivider: "INFRAESTRUCTURA",
      pasture: "FORRAJE",
      pastureDailyCost: "Costo diario",
      pastureAnimalCapacity: "Densidad de población",
      pastureArea: "Área útil",
      pastureLeafDensity: "Densidad de forraje",
      pastureFertilized: "Fertilizado",
      pastureCurrentHeight: "Altura actual del césped",
      pastureCurrentHeightDate: "Fecha actual de altura del césped",
      pastureGrowthSpeed: "Tasa de crecimiento",
      troughSpacePerAnimal: "Espacio de artefacto por animal",
      totalTroughSpace: "Tamaño total del canal",
      drinkingFountain: "Tamaño total del tanque de agua",
      lotId: "LOTE",
      leaseCost: "Costo de arrendamiento",
      profitCenterId: "Actividad",
      profitCenterType: "Tipo",
      pastureId: "Tipo de forraje",
      moreInformationButton: "Más información",
    },
    form: {
      name: "Id. de paddock/pluma",
      namePlaceHolder: "Id. de paddock/pluma",
      importCode: "Importación de código",
      automacaoTratosDivider: "Integración con Automatización de Alimentación",
      initialTag: "Tag Inicial",
      finalTag: "Tag Final",
      integrationCode: "Código de Integración",
      propertyType: "¿El paddock/corral es interno o subcontratado?",
      productionSubSystem: "Subsistema de producción",
      productionSubSystemPlaceHolder: "Seleccione Sistema",
      supplierId: "Proveedor",
      supplierIdPlaceHolder: "Seleccionar proveedor",
      sustenanceCapacity: "Tapa de transporte.",
      alocateLotTitle: "ASIGNAR LOTE DE PRODUCCIÓN",
      infrastructureDivider: "INFRAESTRUCTURA",
      lotId: "LOTE",
      lotIdPlaceHolder: "Seleccione un lote",
      lotStartDate: "Fecha actual de entrada del lote",
      oldLotEndDate: "Fecha de salida del lote anterior ",
      leaseMonthlyCost: "Costo de arrendamiento",
      profitCenterId: "Actividad utilizada",
      profitCenterIdPlaceHolder: "Seleccione Actividad",
      status: "Estado del paddock",
      sustenanceCapacityDrawerTitle: "Capacidad de carga del potrero",
      sustenanceCapacityDrawerTitleIntensiveSubSystem:
        "Capacidad de carga del bolígrafo",
      drinkingFountain: "Tamaño del tanque de agua",
      troughSpacePerAnimal: "Tamaño de la cubeta por cabeza",
      totalTroughSpace: "Tamaño de la cubeta",
      pastureDivider: "FORRAJE",
      pastureId: "FORRAJE",
      pastureIdPlaceHolder: "Selecione o tipo de forrageira",
      pastureAnimalCapacity: "Densidad de población",
      pastureArea: "Área útil",
      pastureLeafDensity: "Densidad MS del forraje",
      pastureFertilized: "Fertilizado",
      pastureDailyCost: "Costo diario ",
      pastureDailyCostTooltip:
        "Al introducir un valor en este campo, se utilizará en la Estrategia de Dieta, independientemente de la Estación del Clima. En caso de no ingresar ningún valor, se utilizará el Costo registrado en Pastos para cada Estación Climática.",
      pastureCurrentHeight: "Altura actual de los pastos",
      pastureCurrentHeightDate: "Fecha actual de altura de los pastos",
      pastureGrowthSpeed: "Tasa de crecimiento",
      observation: "Observaciones",
      error: {
        requiredPastureId: {
          title: "Datos no válidos",
          message:
            "Seleccionar el tipo de forraje cuando el subsistema de producción es Extensivo o Semi-Intensivo",
        },
        requiredSupplierId: {
          title: "Datos no válidos",
          message:
            "Seleccionar el proveedor cuando el tipo de paddock sea Tercera Parte",
        },
        supplementConsumptionMeasureTypeInvalid: {
          title: "Datos no válidos",
          message:
            "Tipo de medición no válido para el tipo de consumo seleccionado",
        },
        productionSubSystemDifferentFromPicketProductionSubSystem: {
          title: "Datos no válidos",
          message:
            "No se puede asignar este lote porque el subsistema de producción es diferente del potrero/pe",
        },
        sustenanceCapacityNotInformed: {
          title: "Datos no válidos",
          message: "Los datos de la capacidad de carga deben ser reportados",
        },
      },
    },
    saveOptions: {
      only_save: "Salvar",
      save_and_create_new: "Crea un paddock/corral y añade uno nuevo",
      save_and_add_lot: "Guarde y agregue Batch al paddock/pe",
    },
    drawerMaintenance: {
      title: "Poner Paddock/Pen en mantenimiento",
      subtitle:
        "Indique en el campo a continuación el tiempo que el paddock/corral estará en mantenimiento",
      labelAmountDays: "Cantidad de días",
      finishIn: "Terminando en:",
      infoMessage: "Se le notificará cuando finalice el período",
    },
    drawerRenovation: {
      title: "Poner Paddock/Pen en mantenimiento",
      subtitle:
        "Indique en el campo a continuación el tiempo que el paddock/corral estará en mantenimiento",
      labelAmountDays: "Cantidad de días",
      finishIn: "Terminando en:",
      infoMessage: "Se le notificará cuando finalice el período",
    },
    drawerBreakTitle:
      "¿Estás seguro de que quieres poner este paddock/corral en reposo?",
    drawerInactivate:
      "¿Estás seguro de que quieres desactivar este paddock/corral?",
    drawerReactivate:
      "¿Estás seguro de que quieres reactivar este paddock/corral?",
    drawerDelete: "¿Está seguro de que desea eliminar este paddock/corral?",
  },
  retreat: {
    title: "Lista de unidades de rango",
    buttonNew: "Nueva Gama",
    table: {
      columns: {
        status: "Estado",
        retreatName: "Gama",
        area: "Son",
      },
      expandedColumns: {
        picketName: "Potrero/Corral",
        area: "Área",
        activity: "Actividad",
        status: "Estado",
        lot: "BATC",
      },
    },
  },
  profitCenter: {
    title: "Actividades",
    saveOptions: {
      only_save: "Salvar",
      save_and_create_new: "Crear actividad y agregar una nueva",
    },
    table: {
      title: "Listado de actividades",
      columns: {
        name: "Nombre",
        status: "Estado",
        type: "Tipo",
        productionSubSystem: "Subsistema de producción",
      },
    },
    drawerTitle: "Listado de actividades",
    drawerTitleEdit: "Editar actividad",
    drawerSubTitle:
      "Complete los campos a continuación para crear una nueva actividad",
    drawerSubTitleEdit:
      "Complete los campos a continuación para editar una nueva actividad",
    validationMessage:
      "Rellene correctamente todos los campos obligatorios (*)",
    modalCheckbox: "Guarde y agregue el lote al paddock / corral",
    form: {
      name: "Id. de actividad",
      namePlaceHolder: "Nombre de la actividad",
      externalIntegrationCode: "Código Externo",
      productionSubSystem: "Subsistema de producción",
      productionSubSystemPlaceHolder: "¿Qué es el subsistema de producción?",
      type: "Tipo",
      typePlaceHolder: "¿Cuál es el tipo de actividad?",
      status: "Estatus de la actividad",
    },
  },
  farm: {
    title: "Explotaciones agrarias",
    table: {
      title: "Lista de granjas",
      columns: {
        name: "Nombre",
        status: "Statu",
      },
    },
    drawerTitle: "Lista de granjas",
    drawerTitleEdit: "Editar granja",
    drawerSubTitle:
      "Complete los campos a continuación para crear una nueva granja",
    drawerSubTitleEdit:
      "Complete los campos a continuación para editar una granja",
    validationMessage:
      "Rellene correctamente todos los campos obligatorios (*)",
    form: {
      logo: "Sube el logo de tu finca",
      confinement: "¿Confinamiento?",
      boitel: "¿Es Boitel?",
      boitelVisibleToAllSystem:
        "Marca la casilla si deseas aparecer en la lista de Boitel - Diarias para todos los usuarios de BovExo.",
      checkVisibleForAllSystem:
        "Al marcar esta casilla, aceptas agregar esta finca a la lista de proveedores y clientes de este grupo, y permites que esta finca sea visible para todos los usuarios de Bovexo.",
      farmSisbov: "¿Finca ERAS (SISBOV)?",
      farmSisbovInfoTooltip:
        "Al marcar que la finca es ERAS (Establecimientos Rurales Aprobados SISBOV), se habilitarán campos y controles relacionados con la trazabilidad.",
      name: "Nombre comercial de la finca",
      namePlaceHolder: "Nombre comercial de la finca",
      externalIntegrationCode: "Código Externo",
      externalIntegrationCodePlaceHolder: "Código Externo",
      group: "Grupo",
      groupPlaceHolder: "Selecciona el grupo",
      companyName: "Razón social",
      companyNamePlaceHolder: "Razón social de la finca",
      document: "CNPJ",
      documentPlaceHolder: "CNPJ",
      zipCode: "Código Postal",
      zipCodePlaceHolder: "Código Postal",
      address: "Dirección",
      addressPlaceHolder: "Carretera, autopista, calle...",
      city: "Ciudad",
      cityPlaceHolder: "Ciudad",
      state: "Estado",
      statePlaceHolder: "Estado",
      status: "Estado de la finca",
      country: "País",
      countryPlaceHolder: "País",
      totalArea: "Área total",
      rentAreaOutSourced: "Área arrendada a terceros",
      livestockArea: "Área de pastoreo",
      nonProductiveArea: "Área de reserva no productiva",
      cultivationArea: "Área de cultivo",
      improvementsArea: "Área de mejora",
      complementAddress: "Complemento de dirección",
      complementAddressPlaceHolder: "Complemento de dirección",
      farmOwner: "Propietarios",
      weatherStation: "Estación Meteorológica",
      weatherStationPlaceHolder: "Estación Meteorológica",
    },
    saveOptions: {
      only_save: "Salvar",
      save_and_create_new: "Guarde la granja y agregue una nueva en",
    },
    messages: {
      successSubmit: "Granja creada/actualizada con éxito.",
      errorSubmit:
        "La granja no fue creada/actualizada. Por favor, contacte con soporte.",
      errorFarmDocumentAlreadyExists:
        "El documento de la Granja ya existe en nuestra base de datos.",
      errorFarmOwnerDocumentAlreadyExists:
        "El documento del Propietario ya existe en nuestra base de datos.",
    },
  },
  farmOwner: {
    title: "Propietarios de granjas",
    buttonNew: "Nuevo",
    table: {
      columns: {
        code: "Código",
        name: "Nombre",
        document: "IRS/EIN",
        participation: "% Partícipe.",
        mainOwner: "Principal ",
      },
    },
    form: {
      code: "Código",
      name: "Nombre",
      document: "IRS/EIN",
      participation: "% Partícipe.",
      mainOwner: "Principal ",
    },
  },
  supplier: {
    title: "Proveedores",
    modalTitle: "Seleccione un proveedor",
    types: {
      supplement: "Supleménte./Concent.",
      technology: "Tecnología",
      cattleFarmer: "Ganado",
      others: "Otros",
      veterinarySupplement: "Aporte veterinario",
    },
    table: {
      title: "Lista de proveedores",
      columns: {
        name: "Nombre",
        type: "Tipo",
        status: "Estado",
        phoneNumber: "Contacto",
        email: "Correo electrónico",
        city_uf: "Ciudad/Estadísticas",
      },
    },
    export: {
      columns: {
        id: "ID",
        farm_id: "Finca",
        name: "Nombre",
        type: "Tipo",
        document_type: "Tipo de documento",
        document: "Documento",
        responsible_name: "Nombre del responsable",
        email: "Correo electrónico",
        phone_number: "Teléfono",
        address: "Dirección",
        zip_code: "Código postal",
        city_id: "ID de la ciudad",
        city_name: "Ciudad",
        state_id: "ID del estado",
        state_name: "Estado",
        farm_status: "Estado",
        external_integration_code: "Código de integración externa",
      },
    },
    drawerTitle: "Registro de proveedores",
    drawerTitleEdit: "Editar proveedor",
    drawerSubTitle:
      "Complete los campos a continuación para crear un nuevo proveedor",
    drawerSubTitleEdit:
      "Complete los campos a continuación para editar el Proveedor",
    validationMessage:
      "Rellene correctamente todos los campos obligatorios (*)",
    form: {
      name: "Proveedor",
      namePlaceHolder: "Nombre comercial del proveedor",
      externalIntegrationCode: "Código Externo/Integración",
      externalIntegrationCodePlaceHolder: "Código Externo/Integración",
      type: "Tipo",
      typePlaceHolder: "Tipo de proveedor",
      phoneNumber: "Contacto",
      phoneNumberPlaceHolder: "Número de teléfono",
      document: "IRS/EIN",
      documentPlaceHolder: "IRS o EIN",
      email: "Correo electrónico",
      emailPlaceHolder: "Correo electrónico",
      zipCode: "CREMALLERA",
      zipCodePlaceHolder: "CREMALLERA",
      address: "Dirección",
      addressPlaceHolder: "Calle, carretera...",
      city: "Ciudad/Condado",
      cityPlaceHolder: "Ciudad/Condado",
      state: "Saciar",
      statePlaceHolder: "Saciar",
      country: "País",
      countryPlaceHolder: "País",
      status: "Estado del proveedor",
      groupFarmVisibility: "¿Quién utilizará este proveedor?",
      radiogroup: {
        farm: "Esta granja",
        group: "Todas las granjas del grupo",
      },
    },
    saveOptions: {
      only_save: "Salvar",
      save_and_create_new: "Guarde Supplyer y agregue uno nuevo en",
    },
    messages: {
      cpfInvalid: "¡CPF incorrecto!",
      cpfInvalidDescription: "Por favor, ingrese un CPF válido.",
      cnpjInvalid: "¡CNPJ incorrecto!",
      cnpjInvalidDescription: "Por favor, ingrese un CNPJ válido.",
      contactFormatInvalid: "Formato de contacto inválido.",
    },
  },
  manufacturer: {
    title: "Fabricantes",
    drawerTitle: "Registro de Fabricante",
    drawerSubTitle:
      "Complete los campos a continuación para crear un nuevo fabricante",
    validationMessage:
      "Complete todos los campos obligatorios con * correctamente",
    form: {
      name: "Nombre",
      namePlaceHolder: "Nombre del fabricante",
    },
    messages: {
      duplicateName: "¡Fabricante ya registrado!",
      duplicateNameDescription:
        "Ya existe un fabricante con este nombre registrado en esta finca.",
      createSuccess: "Fabricante creado con éxito",
      createError: "No fue posible crear el fabricante",
    },
  },
  clientList: {
    export: {
      columns: {
        name: "Nombre",
        type: "Tipo",
        document_type: "Tipo de documento",
        document: "Documento",
        phone: "Teléfono",
        farm_status: "Estado",
        zip_code: "Código postal",
        address: "Dirección",
        city: "Ciudad",
        state: "Estado",
      },
    },
  },
  cattleProducer: {
    title: "Productores",
    table: {
      title: "Lista de productores",
      columns: {
        name: "Nombre",
        document: "Documento",
        status: "Estado",
      },
    },
    drawer: {
      title: "Registro de Productor",
      titleEdit: "Editar Productor",
    },
    form: {
      name: "Nombre",
      document: "Documento",
      documentPlaceHolder: "CPF o CNPJ",
      properties: "Propiedades",
      property: "Propiedad",
      propertyName: "Nombre",
      propertyDocument: "Documento",
      addProperty: "Agregar Propiedad",
      validation: {
        nameRequired: "El nombre es obligatorio",
        cpfError: "¡CPF incorrecto!",
        cpfErrorDescription: "Por favor, ingrese un CPF válido.",
        cnpjError: "¡CNPJ incorrecto!",
        cnpjErrorDescription: "Por favor, ingrese un CNPJ válido.",
        propertyCpfError: "¡CPF de propiedad incorrecto!",
        propertyCpfErrorDescription:
          "Por favor, ingrese un CPF válido para la propiedad.",
        propertyCnpjError: "¡CNPJ de propiedad incorrecto!",
        propertyCnpjErrorDescription:
          "Por favor, ingrese un CNPJ válido para la propiedad.",
      },
    },
    buttons: {
      buttonNew: "Nuevo Productor",
    },
    select: {
      placeholder: "Seleccione un productor",
    },
    modal: {
      deleteTitle: "Confirmar eliminación",
      deleteContent: "¿Está seguro de que desea eliminar este productor?",
    },
    notifications: {
      createSuccess: "Productor creado con éxito",
      createError: "El productor no fue creado",
      updateSuccess: "Productor actualizado con éxito",
      updateError: "El productor no fue actualizado",
      deleteSuccess: "Productor eliminado con éxito",
      deleteError: "El productor no fue eliminado",
      error5043Message:
        "El productor no puede ser eliminado, porque está en uso en un contrato.",
    },
  },
  animal: {
    buttonNew: "Nuevo Animal",
    buttonGenerateReport: "Generar lista de animales",
    buttonGenerateReportInfoTooltip:
      "Seleccione uno o más animales en la tabla de abajo para generar el informe.",
    buttonGenerateReportERA: "Generar informe de movimiento",
    listingReportTitle: "Lista de Animales",
    dashboard: {
      activeAnimals: "Animales activos",
      activeLots: "Lotes activos",
      animalsByGender: {
        title: "Amt. por Género",
        female: "Hembra",
        male: "Mal",
      },
      hidePanels: "Ocultar paneles",
      showPanels: "Mostrar paneles",
      extensive: "EXTENSIVO",
      semiIntensive: "SEMI-INTENSIVO",
      intensive: "INTENSIVO",
      gmd: "GDP",
      avgWeight: "Peso promedio",
      avgAge: "Edad promedio",
      animals: "Animales",
      lots: "Lotes",
      noAnimalAlert: "No hay alertas de animales en esta fecha",
      fattenTab: "Recría/Engorde",
      reproductionTab: "Reproducción",
    },
    messages: {
      createdSuccess: "Animal creado con éxito",
      updatedSuccess: "Animal actualizado con éxito",
    },
    drawer: {
      title: "Agregar animal",
      validation: {
        supplierRequired: "Proveedor no informado",
        supplierRequiredDesc:
          'Informe un proveedor o marque la opción "Animal provisto por la propia granja".',
        carcassYieldInvalid: "Rendimiento de Carcasa inválido",
        carcassYieldInvalidDesc:
          'El valor del campo "Rendimiento de Carcasa" debe estar dentro del rango de valores (45% y 60%)',
        datesInvalid: "Fechas inválidas",
        datesInvalidDesc1:
          "La Fecha de Adquisición no puede ser anterior a la Fecha de Nacimiento.",
        datesInvalidDesc2:
          "La Fecha de Destete no puede ser anterior a la Fecha de Nacimiento.",
        weightsInvalid: "Pesos inválidos",
        birthWeightDesc:
          "El Peso al Nacimiento no puede ser mayor que el Peso al Destete.",
        duplicateIdentification:
          "Existen animales activos en esta propiedad que tienen la misma Identificación.",
      },
      messages: {
        alertTitle: "Alerta",
        animalOver60Months: "El animal tiene más de 60 meses.",
        confirm: "¿Confirmar?",
        createError: "Error al registrar",
        createErrorDesc: "No se pudo registrar el animal. Contacte al soporte",
        updateError: "Ocurrió un error al actualizar",
        updateErrorDesc: "Por favor, contacte al administrador.",
        cannotUpdate: "No es posible actualizar.",
        animalHasEvent:
          "El animal tiene un evento de {type} posterior a la fecha de muerte indicada.",
        eventDate: "Fecha:",
        identifyAnimal: "¡Atención! ¿Desea identificar este animal?",
        lastAnimalInLot:
          '¡Atención! Este es el último animal en el Lote "{lotName}". Al confirmar el registro de muerte, el Lote quedará con estado "Pendiente". Si ya no utilizará este lote, podrá inactivarlo.',
        animalDeadTitle: "Animal fallecido",
        setAsAlive: "Definir animal como vivo",
        animalDiscardedTitle: "Animal descartado",
        discardCauseLabel: "Causa:",
        saleScenarioWarningEdit:
          "Si el animal está en un lote que tiene escenario(s) de venta, al confirmar, reprocese los escenario(s) para que el animal sea considerado.",
        saleScenarioWarningNew:
          "Si el animal se agrega a un lote que tiene escenario(s) de venta, al confirmar, reprocese los escenario(s) para que el animal sea considerado.",
      },
      form: {
        ownFarmAnimal: "Animal provisto por la propia granja",
        milkCrossbreed: "Cruzado de leche",
        ageLabel: "Edad (días/meses/años)",
        purposeReproduction: "Reproducción",
        purposeFatten: "Engorda",
        firstInsemination: "1a. Inseminación",
        traceabilitySISBOV: "TRAZABILIDAD (NAIS)",
        genealogy: "GENEALOGÍA",
        mother: "MADRE",
        father: "PADRE",
        supplier: "Proveedor",
        identification: "Identificación",
        semen: "Semen",
        selectProductionLot:
          "Seleccione un Lote de Producción existente para este animal:",
        productionLot: "Lote de producción",
        associateReceiptLot: "Asociar el animal a un Lote de Recepción.",
        receiptLot: "Lote de Recepción",
      },
      saveOptions: {
        saveOnly: "Guardar solo",
        saveAndAddNew: "Guardar y agregar nuevo animal",
      },
      tooltips: {
        reproductionCategoryInfo: "",
      },
    },
    reproduction: {
      tabFemales: "Hembras",
      tabMales: "Machos",
      identificationLabel: "Identificación",
      identificationOptions: {
        handlingNumber: "Identificación",
        tagId: "Id. Electrónica",
        sisbov: "NAIS",
        nickname: "Nombre",
        registry: "Registro",
      },
      radioAnimals: "Animales",
      radioReproductionEvents: "Eventos Reproductivos",
    },
    ageInputPlaceholders: {
      days: "Días",
      months: "Meses",
      years: "Años",
    },
    animalDiscard: {
      descriptionPlaceholder: "Descripción del descarte",
    },
    animalDeath: {
      descriptionPlaceholder: "Descripción de la muerte",
    },
    curveParameter: {
      drawerTitle: "Parámetros del animal",
      defineParams: "Defina los parámetros del lote",
      saveSuccess: "Curva de crecimiento estimada guardada.",
      saveError: "Hubo un error al guardar la curva de crecimiento estimada.",
    },
    columns: {
      title: "Lista de animales",
      buttonCompare: "Comparar",
      handlingNumber: "Identificación",
      picket: "Potrero/Corral",
      lot: "LOTE",
      sisbov: "NAIS",
      tagId: "Identificación electrónica de la etiqueta",
      breed: "Raza",
      gender: "Género",
      birthdayMonths: "Edad",
      weightRanking: "Clasificación",
      currentWeight: "Último peso",
      gdp: "Subdirector General",
      lastDailyWeightDate: "Última fecha de pesaje",
      target: "Blanco",
      status: "Estado",
      supplier: "Proveedor",
      reproductionCategory: "Categoría Reprod.",
      reproductionStatus: "Reprod. Situación",
      reproductionState: "Reprod. Statu",
    },
    searchAnimal: {
      label: "Identificación",
      modalTitle: "Seleccione un animal",
      fieldLabel: "Campo de búsqueda",
      genderFilter: "Género",
      genderAll: "Todos",
      male: "Macho",
      female: "Hembra",
      handlingNumber: "Identificación",
      sisbov: "NAIS",
      tagId: "Identificación electrónica de la etiqueta",
      nickname: "Apodo",
      registry: "Registro",
    },
    details: {
      animalProductionPageLink: "Animales Productivos",
      animalPageDescription: "Detalles del animal",
      emptyMessage: "No se han encontrado datos de animales",
      bovexoId: "Id Bovexo",
      registry: "Registro",
      sisbov: "NAIS",
      age: "DOB",
      source: "Proveedor",
      farmOwner: "Proprietário",
      castrated: "Castrado",
      tagId: "Identificación electrónica de la etiqueta",
      sex: "Género",
      male: "Masculino",
      female: "Hembra",
      acquisition: "Adquisición",
      handlingNumber: "Identificación",
      weight: "Peso",
      current: "Atual",
      location: "Ubicación",
      picket: "Potrero/Corral",
      lot: "LOTE",
      breed: "Raza",
      weightGain: "Aumento de peso",
      accumulated: "Acumulado",
      lastWeight: "Último peso",
      forSlaughter: "para Sacrificio/Venta",
      expected: "Esperado",
      asymptoticWeight: "Peso sigmoide",
      economicReturn: "Retorno económico",
      currentValue: "Valor actual",
      accumulatedCost: "Costo acumulado",
      animalFarmFunction: "Propósito",
      animalReproductionCategory: "Categoría",
      margin: "Margen",
      appropriateCosts: "Costos asignados",
      femaleSituation: "Condición",
      femaleSituationTime: "Tiempo de condición",
      birthForecast: "Previsión de nacimiento",
      coverageDate: "Fecha de servicio de la reproducción",
      coverageType: "Tipo de servicio Reprod",
      coverageSemenOrMaleIdentification: "Toro",
      weightCoverage: "Peso en Reprod Serv.",
      semenDeparture: "Salida",
      observation: "Obs. Cobertura",
      bodyConditionScore: "ECC",
      pregnancyDiagnosisDate: "Fecha de Diagnóstico de Gestación",
      pregnancyDiagnosisResult: "Resultado del Diagnóstico (DG)",
      pregnancyDiagnosisOvarianEvaluationResult: "Evaluación Ovárica (DG)",
      birthDate: "Nacimiento",
      birthType: "Tipo de Parto",
      gestationDays: "Duración de la Gestación",
      childsGender: "Sexo de las Crías",
      childsIds: "ID de las Crías",
      childsBirthday: "Peso al Nacer",
      childsStatus: "Estado Actual de las Crías",
      childsWeaningWeightDate: "Fecha de Destete",
      childsWeaningWeight: "Peso de Destete",
      iep: "Intervalo entre Partos",
      tab: {
        production: "Producción",
        reproduction: "Cría",
        genetic: "Genético",
        geneology: "Genealogía",
        evaluation: "Evaluación",
        zoonosis: "Zoonosis",
        weighing: "Pesadas",
        dailyWeights: "Pesos diarios",
        weightGains: "Aumento de peso (GMD)",
        measurements: "Mediciones",
        animalHistory: "Historial",
      },
      animalHistory: {
        lots: "Historial de Lotes",
        pickets: "Historial de Potreros",
        refresh: "Actualizar",
        lotName: "Lote",
        picketName: "Nombre del Potrero",
        activity: "Actividad",
        dietStrategy: "Est. de Dieta",
        entryDate: "Entrada",
        exitDate: "Salida",
        weightIn: "Peso Entrada",
        weightOut: "Peso Salida",
        daysQuantity: "Cant. de Días",
      },
      history: {
        title: "Registro de peso y mediciones",
        tooltipHistoryWeight:
          "En esta opción, se mostrarán los pesos registrados para el animal y la ganancia de peso respectiva.\n\n 1. Pesos: Se muestran todos los pesos registrados para el animal, incluso si se realiza más de un pesaje en el mismo día, como los pesos de las básculas dinámicas.\n 2. Pesos Diarios: Son los pesos que realmente se considerarán para el animal, ya sea para calcular el PIB o el ADG. Si se utilizan básculas de pesaje dinámicas, que pueden registrar más de un peso en el mismo día para el mismo animal, se tendrá en cuenta la regla definida en la configuración de Pesos, disponible en [Parámetros/General].\n 3. Aumentos de peso (GMD): se refiere a la GMD, es decir, la ganancia diaria entre el pesaje en esta fecha y la anterior.",
        grid: {
          emptyMessage: "No hay antecedentes de peso registrados",
          emptyMessageMeasurements: "No hay mediciones registradas",
          in: "Empezar",
          out: "Fin",
          manual: "Manual",
          date: "Fecha",
          hour: "Hora",
          inOut: "S/E",
          weight: "Peso (kg)",
          eventTitle: "Tipo",
          originEvent: {
            birthday: "DOB",
            purchase: "Adquisición",
            weaning: "Destete",
            sale: "Vendido",
            transfer: "Transferência",
          },
        },
      },
      totalWeight: {
        title: "Peso total",
        tooltip:
          "Este gráfico compara o último peso do animal com a media dos animais semelhantes no mesmo grupo genético, raça e do mesmo lote",
        graph: {
          currentWeight: "Peso actual",
          lot: "LOTE",
          genetic: "Genético",
          breed: "Raza",
          weight: "Peso",
          type: "Tipo",
          estimated: "E esperado",
        },
      },
      averageDailyGain: {
        title: "Ganancia media diaria",
        tooltip:
          "Este gráfico compara la última ganancia diaria de peso del animal con el promedio de animales similares del mismo grupo genético, raza y del mismo lote.",
        graph: {
          currentGain: "Subdirector General actual",
          lot: "LOTE",
          genetic: "Genético",
          breed: "Raza",
          weight: "Peso",
          type: "Tipo",
          estimated: "E esperado",
        },
      },
      dailyWeightGain: {
        title: "EVOLUCIÓN DEL PESO Y ADG",
        graph: {
          weight: "Peso",
          time: "Día",
        },
      },
    },
    drawerTitleEdit: "Editar Animal",
    drawerSubTitleEdit:
      "Rellena los datos que aparecen a continuación para editar un animal",
    drawerSubTitleEditDeathAnimal:
      "Animal muerto, todos los campos han sido desactivados",
    drawerAnimalDeathTitle: "Animal muerto",
    animalDeathPopConfirmTitle:
      "Tras la confirmación, se considera que el animal se encuentra en un estado de muerte permanente.",
    edit: {
      form: {
        nickname: "Nombre",
        nicknamePlaceHolder: "Nombre",
        registry: "Registro",
        registryPlaceHolder: "Registro",
        sisbov: "NAIS",
        sisbovPlaceHolder: "NAIS",
        tagId: "Identificación electrónica de la etiqueta",
        tagIdPlaceHolder: "Identificación electrónica de la etiqueta",
        sex: "Género",
        male: "Masculino",
        female: "Hembra",
        acquisition: "Adquisición",
        handlingNumber: "Identificación",
        handlingNumberPlaceHolder: "Identificación del animal.",
        breed: "Raza",
        breedPlaceHolder: "Seleccionar raza",
        cap: "¿Animal castrado?",
        birthday: "DOB",
        birthdayWeight: "Peso al nacer",
        firstInseminationWeight: "Primera inseminación",
        weaningWeight: "Peso al destete",
        weaningDate: "Fecha de destete",
        asymptoticWeight: "Peso sigmoide",
        asymptoticWeightInfoTooltip:
          "El peso sigmoide es el peso que, con base en la información que el usuario/productor tiene sobre la historia del Animal o Lote de Animales (considerando genética, manejo previo, interacción genotipo-ambiente, marco, entre otras variables), cree que es el límite de peso potencial. Es decir, por encima de este peso, este animal difícilmente aumentará de peso en condiciones normales.",
        acquisitionDate: "Fecha de adquisición",
        purchaseCost: "Precio de adquisición",
        acquisitionEstimatedWeight: "Peso de adquisición",
        carcassHarnessing: "Rendimiento de la canal",
        animalFarmFunction: "Propósito",
        animalReproductionCategory: "Categoría",
        sisbovIdentificationDate: "Identificar fecha",
        sisbovInsertBNDDate: "Inclusión de fecha NAIS",
        sisbovSlaughterDate: "Fecha de lanzamiento de Slaughter",
        farmOwner: "Owne",
      },
      weights: "Pesos",
      receipt: "Recibido",
      sale: "Sal",
    },
    drawerAnimalDiscardTitle: "Eliminación de animales",
    discard: {
      motives: {
        Age: "Edad",
        ReproductiveProblems: "Cuestiones reproductivas",
        IllnessesOrPhysicalProblems: "Enfermedades o problemas físicos",
        BodyCondition: "Condición corporal",
        NegativePregnancy: "Embarazo negativo",
        MaternalAbility: "Habilidad materna",
      },
    },
    carcassHarnessingInfoTooltip:
      "La canal del animal debe indicarse si se realiza un análisis ecográfico de la canal. La utilización del Lote y la Estrategia de Dieta son expectativas. Cuando ambos están presentes, prevalecen Animal, Dieta, Lote en este orden",
  },
  dietStrategy: {
    new: {
      title: "Creación de una estrategia de dieta",
      message:
        "Seleccionar el periodo total de la estrategia y definir las dietas y el tiempo de ejecución de cada una",
      name: "Nombre de la estrategia de dieta",
      namePlaceHolder: "Nombre de la estrategia de dieta",
      totalPeriod: "Periodo total",
      year: "Año",
      oneYear: "1 año",
      twoYears: "2 años",
      threeYears: "3 años",
      dietAndExecutionTime: "Dietas y tiempo de ejecución",
      dietPlaceHolder: "Selecciona una dieta",
      deleteDietPeriod: "Eliminar dieta",
      totalTime: "Periodo total",
      weeks: "Semana(s)",
      buttonAddDiet: "Añade la dieta",
      drawerTitle: "Resumen de la estrategia dietética",
      start: "Empezar",
      end: "Fin",
      notification: {
        success: {
          message: "¡Estrategia de dieta creada!",
          description: "La estrategia se incluyó en el sistema",
        },
        error: {
          dontHaveName: {
            message: "Error",
            description:
              "Debe introducir un nombre para la estrategia de dieta",
          },
          dontHaveDiet: {
            message: "Error",
            description: "Todos los períodos necesitan una dieta seleccionada",
          },
        },
      },
    },
    title: "Lista de Estrategias de Dieta",
    buttonNewDietStrategy: "Nueva estrategia",
    table: {
      status: "Estado",
      name: "Nombre",
      diet: "Dieta",
      totalTime: "Tiempo total",
    },
    modal: {
      simple: {
        title: "Subsistema de Producción Divergente",
        message:
          "El subsistema de producción seleccionado para este período no corresponde al subsistema utilizado en el paddock/corral donde se asigna el lote. Para obtener un buen rendimiento, se recomienda que ambos utilicen el mismo sistema.",
        confirmButton: "Está bien, lo entiendo",
      },
    },
  },
  weightStrategy: {
    title: "Estrategia de Peso",
    tabs: {
      dietStrategy: "Estrategia de Dieta",
      weightGainProjection: "Proyección de Ganancia de Peso",
    },
  },
  generalParameters: {
    weatherSeason: {
      title: "Estaciones Meteorológicas",
      editMessage:
        "Defina las estaciones meteorológicas más adecuadas para la ubicación de la granja utilizando el cuadro lateral:",
      table: {
        columnDayMonth: "Días/Mes",
        columnNextSeason: "Próxima temporada",
        columnMonthSeason: "Corriente Seaso",
      },
    },
    farmDeathReason: {
      buttonNew: "Nuevo",
      table: {
        title: "Causa Mortis",
        columns: {
          name: "Nombre",
          status: "Conditio",
        },
      },
    },
    quotas: {
      buttonNew: "Nuevo",
      table: {
        title: "Cuotas",
        columns: {
          name: "Nombre",
          type: "Tipo",
          status: "Conditio",
        },
      },
    },
    successParameterUpdated: "¡Los parámetros se han cambiado con éxito!",
    errorParameterUpdated: "Vaya... Los parámetros no cambiaron",
  },
  cost: {
    tabs: {
      fixedCost: "Costos de Activos Fijos",
      infrastructureCost: "Infraestructura y mano de obra",
      operatingVariableCost: "Variables operativas",
      zootechnicalVariableCost: "Costos zootécnicos",
      sanityCost: "Sanidad animal",
    },
    form: {
      error:
        'Es necesario informar los campos "Valor de costo" y "Depreciación" en los costos marcados en rojo',
      growth: "Vaca-ternero",
      recreateFattenPasture: "R&F - Pastos",
      recreateFattenSemiConfinement: "R&F - Pastos/Corrales de Engorde",
      recreateFattenConfinement: "R&F - Corral de engorde ",
      area: "Área",
      potentialOccupation: "Densidad máxima de población",
      staticCapacity: "Llevando a Capac.",
      staticCapacityTooltip:
        "Los valores de este campo se calculan multiplicando el área por la densidad máxima de población.",
      fence: "Esgrima",
      costValue: "Costar",
      depreciationValue: "Depreciación",
      total: "Total",
      amountAnimals: "Amt. Animales",
      totalDailyCostPerAnimal: "Costo diario por animal",
      dietCost: "Dieta",
      costProtocol: "Custo de Vet Procedur",
    },
    costType: {
      FixedCost: "Costos de activos fijos",
      InfrastructureCost: "Costos de infraestructura y mano de obra",
      OperatingVariableCost: "Variables operativas",
      ZootechnicalVariableCost: "Costos de Zootech/Veterinario",
      sanityCost: "Coste de la sanidad animal",
    },
    code: {
      1: "Oficinas y Edificios",
      2: "Impuestos ",
      3: "Seguro",
      4: "Establecimiento de pastos",
      5: "Esgrima",
      6: "Corral",
      7: "Represas",
      8: "Máquinas e implementos",
      9: "Edificios e infraestructuras",
      10: "Fuerza de trabajo operativa",
      11: "Mano de obra técnica",
      12: "3ª Fuerza laboral tecnológica",
      13: "Energía",
      14: "Teléfono/Internet",
      15: "ERP",
      16: "Oficina de contabilidad",
      17: "Mantenimiento de Edificios/Infraestructuras",
      18: "Mantenimiento de Máquinas/Implem",
      19: "Combustible y lubricantes",
      20: "Mantenimiento de pastos",
      21: "Fertilización",
      22: "Mantenimiento de Corrales/Cercas",
      23: "Arrendamiento de pastos",
      24: "Vacunas",
      25: "Vermífugos",
      26: "Medicinas",
      27: "Identificación",
      28: "Costos con animales de servicio y relacionados",
      29: "Otros Costos Administrativos",
      30: "Procedimiento veterinario cos",
    },
  },
  saleScenario: {
    error: {
      DietStrategyExpired:
        "No fue posible procesar el escenario de ventas porque contiene estrategias dietéticas caducadas.",
      InternalError:
        "Se ha producido un error al procesar el escenario. Póngase en contacto con el servicio de asistencia",
    },
  },
  purchaseScenario: {
    error: {
      DietStrategyExpired:
        "El escenario de compra no se pudo procesar porque la estrategia de dieta proporcionada está caducada",
    },
  },
  movementHistory: {
    title: "Historial(es) de transacciones",
    table: {
      columns: {
        originalLotsNames: "Lote de origen",
        destinationLotsNames: "Lotes de destino",
        requestDate: "Fecha de movimiento",
        fromDismemberLot: "¿Desdoblamiento?",
        fileName: "Nombre de archivo",
        animalHandlingNumber: "Animal",
        lotOriginName: "Lote de origen",
        lotDestinationName: "Lote de destino",
        createdAtDate: "Fecha de inscripción",
      },
    },
  },
  financial: {
    tabs: {
      costing: "Cálculo de costes",
      cashFlow: "Flujo de caja",
      parameters: "Parámetros",
      transactions: "Entradas Financieras",
      animalSell: "Transf/Ventas de Producción",
      resultCenterAnalysis: "Análisis CC/PC",
      bankConciliation: "Conciliación Bancaria",
    },
    costType: {
      Growth: "Vaca-ternero",
      RecreateFattenPasture: "Ext - Pastos",
      RecreateFattenSemiConfinement: "Semi-Pasto/Corral de Engorde",
      RecreateFattenConfinement: "Int - Corral de engorde",
      Agriculture: "Cultivos",
      Others: "Otro",
    },
    transactions: {
      title: "Entradas",
      buttonCreateNewFinancialTransaction: "Nueva publicación",
      buttonExportTransactions: "Exportar registros",
      form: {
        title: "Nueva publicación",
        documentNumber:
          "Número de documento de factura/impuesto sobre las ventas",
        supplierId: "Proveedor",
        billingDate: "Fecha de la factura",
        expirationDate: "Fecha de vencimiento",
        mainValueCurrency: "Seleccionar moneda",
        mainValue: "Valor bruto",
        fees: "Valor de los intereses/multas",
        discount: "Descuentos",
        value: "Valor neto",
        payment: "Pago",
        actions: "Acción",
        actionsOptions: {
          launch: "Exponer",
          launchAndSettle: "Publicación y liquidación",
          settle: "Asentamiento",
        },
        settleDate: "Fecha de liquidación",
        inCash: "En efectivo",
        part: "Cuotas",
        financialNatureId: "Naturaleza",
        financialClassId: "Clase",
        costActivityType: "Actividad",
        description: "Descripción",
        resultCenter: "Centro de beneficio",
        resultCenterApportionmentDefault: "Predeterminado",
        resultCenterApportionmentCustom: "Redefinir",
        transactionType: "Tipo",
        clientId: "Cliente",
        financialProjectId: "Proyecto de inversión",
        bonus: "Sobresueldo",
        financialIssueId: "Pendencia Financiera",
        financialPaymentMethodId: "Forma de Pago",
        financialTaxableDeductibleId: "Tributable/Deducible IR",
        bankAccountFarmId: "Fuente de pago",
        errors: {
          installmentsNotGeneratedError:
            'Es necesario generar las cuotas. Para hacer esto, haga clic en la opción "Cuotas" en el campo "Pago"',
        },
      },
      modalInstallments: {
        title: "Crear cuotas",
        value: "Valor de Trx",
        expirationDate: "Fecha de vencimiento",
        installmentTotal: "o de Cuotas",
        buttonCalc: "Cálculo",
        expireDateRequired:
          "Es necesario ingresar la Fecha de Vencimiento para generar las cuotas.",
      },
      modalEditInstallment: {
        title: "Editar datos de liquidación de la cuota",
      },
      table: {
        columns: {
          nature: "Naturaleza",
          class: "Clase",
          values: "Valores",
          origin: "Origen",
          billingDate: "Fecha de la factura",
          expirationDate: "Fecha de vencimiento",
          installment: "Plazo",
          documentNumber: "Número de factura",
          value: "Valor",
          bankAccountFarmName: "Fuente de Pago",
          isPaidPartially: "Parte. Pagado",
          isSettled: "Estado",
          settleDate: "Fecha de liquidación",
          financialClassDepreciation: "Asignación",
          valueDepreciation: "Costo de asignación",
          supplierName: "Proveedor/Cliente",
          costActivityType: "Actividad",
          r: "CR",
          financialProjectName: "Proyectos",
          transactionType: "Tipo",
          entityName: "Proveedor/Cliente",
          financialIssueId: "Pendencia Financiera",
          financialPaymentMethodId: "Forma de Pago",
          financialTaxableDeductibleId: "Tributable/Deducible IR",
          bankAccountFarmId: "Fuente de pago",
          discount: "Descuentos",
          fees: "Intereses/Multas",
        },
      },
      modalResultCenterApportionment: {
        title: "Imputación por Cuenta de Beneficio",
      },
    },
    cashFlow: {
      title: "Flujo de caja",
      buttonDisbursementReport: "Informe de Desembolso",
      buttonCashFlowReport: "Informe de Flujo de Caja",
      buttonCreateBudget: "Nuevo presupuesto",
      filters: {
        status: "Estado",
        visualization: "Visualización",
        exibition: "Monitor",
        timeExibition: "Visualización del tiempo",
        timeExibitionOptions: {
          year: "Anual",
          harvest: "Cosecha",
        },
        harvest: "Safra/Anõ",
        costType: "Actividad",
        financialProjectId: "Proyecto de inversión",
        bankAccountFarmId: "Fuente de pago",
      },
      table: {
        columns: {
          nature: "Naturaleza",
          class: "Clase",
          values: "Valor",
        },
      },
    },
    costing: {
      title: "Tabla de costos",
      filters: {
        visualization: "Monitor",
        timeExibition: "Visualización del tiempo",
        timeExibitionOptions: {
          year: "Anual",
          harvest: "Cosecha",
        },
        harvest: "Safra/Anõ",
        costType: "Actividad",
        financialProjectId: "Proyecto de inversión",
        bankAccountFarmId: "Fuente de pago",
      },
      table: {
        columns: {
          nature: "Naturaleza",
          class: "Clase",
          values: "Valor",
        },
      },
    },
    parameters: {
      tabs: {
        parameters: "Parámetros",
        costing: "Cálculo de costes",
        resultCenter: "Centro de beneficio",
        costCenter: "Centro de costos",
        financialProject: "Proyecto de Inversión",
        additionalControls: "Controles Adicionales",
        financialIssue: "Pendencias Financieras",
        financialPaymentMethod: "Método de Pago",
        financialTaxableDeductible: "Tributable/Deducible IR",
        bankAccountFarm: "Cuentas Bancarias",
      },
      generalFinancialParameters: {
        title: "Parámetros",
        parameter4001: "¿Utilizar la conversión de divisas?",
        parameter4002: "Costos de la dieta",
        parameter4002Help:
          "Definir si los costos de la dieta serán apropiados para los animales en función de la estrategia de dieta o el suministro",
        parameter4002DietStrategy: "Estrategia de Dieta",
        parameter4002SupplementSupply: "Suministro",
        farmConvertions: {
          title: "Monedas",
          buttonNew: "Nueva moneda",
          table: {},
          form: {
            titleNew: "Nueva moneda",
            currency: "Divisa",
            standard: "Establecer como predeterminado",
          },
        },
      },
      costing: {
        title: "Tabla de parámetros de cálculo del coste",
        table: {
          columns: {
            nature: "Naturaleza",
            stock: "Control de Inventarios",
            class: "Clase",
            depreciation: "Depreciación (meses)",
            shouldCost: "Cálculo de costes",
            shouldDisbursement: "Desembolso",
            product: "Producto",
            costCenter: "Centro de costos",
            type: "Typ",
            expense: "Gasto",
            revenue: "Ingreso",
            defaultValueChanged: "Valor predeterminado modificado",
          },
        },
        buttonNew: "Nueva clase",
        messages: {
          inactivateSuccess: "Clase financiera inactivada con éxito.",
          inactivateError:
            "No se pudo inactivar la clase financiera. Contacte al soporte.",
          activateSuccess: "Clase financiera activada con éxito.",
          activateError:
            "No se pudo activar la clase financiera. Contacte al soporte.",
          resetSuccess:
            "Clase financiera restablecida con éxito, los valores predeterminados de BovExo han sido restaurados.",
          resetError:
            "No se pudo restablecer la clase financiera. Contacte al soporte.",
          resetDefault: "Restablecer valores predeterminados",
        },
      },
      resultCenter: {
        title: "Tabla de centros de beneficio",
        buttonNew: "Nuevo",
        form: {
          title: "Centro de beneficio",
          labelTitle: "Título:",
          labelType: "Tipo:",
          labelStartDate: "Validez Inicial:",
          labelEndDate: "Validez Final:",
          labelName: "Nombre",
          labelCode: "Código",
          labelNameColon: "Nombre:",
          labelCodeColon: "Código:",
        },
        financialNatureApportionmentForm: {
          title: "Criterios para la imputación de gastos/costes indirectos",
        },
        messages: {
          deleteSuccess: "Centro de Resultado eliminado con éxito",
          deleteError:
            "No se pudo eliminar el Centro de Resultado. Contacte al soporte",
          saveSuccess: "Centro de Resultado creado con éxito",
          updateSuccess: "Centro de Resultado actualizado con éxito",
          saveError:
            "No se pudo guardar el Centro de Resultado. Contacte al soporte",
          loadError:
            "No se pudo cargar el centro de resultado. Contacte al soporte",
          apportionmentUpdateSuccess: "Prorrateo actualizado con éxito",
          apportionmentUpdateError:
            "No se pudo actualizar el prorrateo. Contacte al soporte",
          apportionmentLoadError:
            "No se pudo cargar el prorrateo del centro de resultado. Contacte al soporte",
          validateError: "Los valores deben sumar 100%",
          finalDateBeforeInitial:
            "La Validez Final no puede ser anterior a la Validez Inicial.",
          noRetreats: "No hay retiros registrados.",
          noOwners: "No hay propietarios registrados.",
          noActivities: "Actividades no informadas.",
          noItems: "Ítems no informados.",
        },
        tableColumns: {
          nome: "Nombre",
          tipo: "Tipo",
          status: "Estado",
          padrao: "Estándar",
        },
        types: {
          activityType: "Actividades",
          retreat: "Retiros",
          farmOwner: "Propietarios",
          custom: "Manual",
        },
      },
      costCenter: {
        title: "Tabla Centros de Costos",
        buttonNew: "Nuevo",
        form: {
          title: "Centro de costos",
          labelTitle: "Título:",
          labelStartDate: "Validez Inicial:",
          labelEndDate: "Validez Final:",
          labelResultCenter: "Centro de Resultado",
          columnClass: "Clase",
          columnName: "Nombre",
          apportionmentAutomatic: "Automático",
          apportionmentNumberOfAnimals: "# Animales",
          apportionmentArea: "Área",
        },
        apportionmentForm: {
          title: "Centros de Coste x Centro de Beneficio",
        },
        modal: {
          title: "Centros de costos",
          table: {
            columns: {
              financialClass: "Clas",
            },
          },
        },
        messages: {
          deleteSuccess: "Centro de Costo eliminado con éxito",
          deleteError:
            "No se pudo eliminar el Centro de Costo. Contacte al soporte",
          saveSuccess: "Centro de Costo creado con éxito",
          updateSuccess: "Centro de Costo actualizado con éxito",
          saveError:
            "No se pudo guardar el Centro de Costo. Contacte al soporte",
          loadError:
            "No se pudo cargar el centro de costo. Contacte al soporte",
          apportionmentUpdateSuccess: "Prorrateo actualizado con éxito",
          apportionmentUpdateError:
            "No se pudo actualizar el prorrateo. Contacte al soporte",
          apportionmentLoadError:
            "No se pudo cargar la información del centro de costo. Contacte al soporte",
          resultCenterLoadError:
            "No se pudo cargar la información de los centros de resultado. Contacte al soporte",
          finalDateBeforeInitial:
            "La Validez Final no puede ser anterior a la Validez Inicial.",
          noItems:
            "No se puede guardar el Centro de Costo sin ingresar todos los ítems",
        },
      },
      farmConvertions: {
        messages: {
          currencyCreated: "Moneda registrada con éxito.",
          currencyAlreadyRegistered: "¡Moneda ya registrada!",
          currencyFavorited:
            "Moneda establecida como predeterminada con éxito.",
          currencyActivated: "Moneda activada con éxito.",
          currencyInactivated: "Moneda inactivada con éxito.",
        },
      },
    },
    animalSell: {
      title: "Transf/Ventas de producción",
      buttonNew: "Nuevo Traspaso/Venta",
      buttonExport: "Resultado de las ventas",
      form: {
        title: "Transferencia/Ventas de producción",
        animalSelectionDescription:
          "Seleccione los animales en la tabla para proceder con la venta.",
        sellDate: "Fecha de salida",
        client: "Cliente",
        financialNatureId: "Naturaleza Financiera",
        financialClassId: "Clase",
        priceNegotiated: "Precio negociado",
        weightPerAnimal: "Peso promedio/animal",
        carcassHarnessing: "Aprovechamiento de la canal",
        documentNumber: "Nº Doc. Fiscal",
        supplier: "Proveedor",
        billingDate: "Fecha de facturación",
        expirationDate: "Fecha de vencimiento",
        payment: "Pago",
        inCash: "Al contado",
        part: "A plazos",
        resultCenter: "Centro de Resultado",
        resultCenterApportionmentDefault: "Por Defecto",
        resultCenterApportionmentCustom: "Redefinir",
        totalValue: "Facturación Total",
        AVERAGE_COST: "Costo Prom. Actual",
        AVERAGE_MARKET_VALUE: "Valor Prom. Mercado",
        MARGIN_VALUE: "Margen sobre costo",
        MARGIN_VALUE_INFO_TOOLTIP:
          'El valor del campo "Precio Negociado" será el Costo Prom. Actual más el margen informado.',
        INPUT_PRICE: "Valor Informado",
        AVERAGE_LAST_WEIGHT: "Peso Prom. Última Pesada",
        AVERAGE_PROGRESSIVE_WEIGHT: "Peso Prom. Estimado Atual",
        INPUT_WEIGHT: "Peso Informado",
        animalTableColumns: {
          handlingNumber: "Identificación",
          lotName: "Lote",
          picketName: "Piquete/Bahía",
          breedName: "Raza",
          gender: "Sexo",
          age: "Edad",
          lastDailyWeight: "Último Peso",
          lastDailyWeightDate: "Última Pesada",
          weightSell: "Peso Venta",
          carcassHarnessing: "Aprov. canal",
          pricePerKilo: "Preciso/Kg",
          pricePerArroba: "Preciso/@",
          priceNegotiated: "Precio Venta",
          removeAnimal: "Quitar",
          removeSelectedAnimals: "Quitar seleccionados",
        },
        financialIssueId: "Pendencia Financiera",
        financialPaymentMethodId: "Forma de Pago",
        financialTaxableDeductibleId: "Tributable/Deducible IR",
        bankAccountFarmId: "Fuente de pago",
        carcassType: {
          PERCENTAGE: "%",
          WEIGHT: "Peso",
        },
      },
      table: {
        columns: {
          origin: "Origen",
          isTransfer: "Transf.",
          documentNumber: "Número de factura",
          client: "Cliente",
          sellDate: "Fecha Inv.",
          amountAnimais: "o Animales",
          gender: "Género",
          totalValue: "Monto total",
          averageValue: "Valor/animal",
          carcassHarnessing: "% Carc. Rendimiento",
          paymentType: "Pago",
          financialProjectName: "Proyecto",
        },
      },
      transferPanelTable: {
        columns: {
          status: "Estado",
          originGroupName: "Grupo de Origen",
          originFarmName: "Finca de Origen",
          amountAnimals: "Cant. Animales",
        },
      },
      messages: {
        errorAtLeastOneAnimal:
          "Es necesario tener al menos un animal en la venta.",
        selectClientText1:
          "¿Esta transferencia de animales implicará compensación financiera (pago) entre las partes?",
        selectClientText2:
          "Hemos detectado que esta puede ser una operación de transferencia de animales entre unidades de un mismo grupo económico. BovExo no gestiona los aspectos fiscales/legales de la operación, pero para efectos de análisis de los resultados de la operación, el valor mínimo que se registrará, para fines generales, es el costo acumulado de los animales transaccionados.",
        infoTooltipText1:
          "Este valor será calculado según el tipo de Valor Negociado, de la siguiente manera:",
        infoTooltipText2:
          "Valor/@ Negociado: Corresponde al peso promedio de los animales, convertido en @ (es decir, dividido por 15). La cantidad de @ se multiplica por el valor negociado de @ con el comprador, y luego se multiplica por el rendimiento de la canal. Esto da el valor promedio por animal, que luego se multiplica por la cantidad de animales, obteniendo así el valor total de facturación.",
        infoTooltipText3:
          "Valor/Kg Negociado: Corresponde al peso promedio de los animales, multiplicado por la cantidad de animales y luego multiplicado por el valor informado por Kg, obteniendo así el valor total de facturación.",
        successSubmitCreate:
          "Su venta está siendo procesada y pronto se completará.",
        errorSubmitCreate:
          "No se pudo realizar la venta. Por favor, contacte al soporte.",
        successSubmitUpdate:
          "La actualización de su venta está siendo procesada y pronto se completará.",
        errorSubmitUpdate:
          "No se pudo actualizar la venta. Por favor, contacte al soporte.",
        error5032:
          '¡Atención! Esta venta no puede ser modificada porque su transacción financiera ha sido "Procesada".',
        modalErrorAnimalsWithPreviousEvents:
          "¡Animales con eventos posteriores a la fecha de venta informada!",
        modalAlertAnimalsInSaleScenarioText1: "¡Atención!",
        modalAlertAnimalsInSaleScenarioText2:
          "Hay animales seleccionados que están asociados a Escenarios de Venta Activos. Al confirmar la venta, estos Escenarios de Venta serán reprocesados, generando un nuevo resultado solo para los animales que aún están activos.",
        modalConfirmPriceNegotiatedText1:
          'El valor ingresado en el campo "Precio Negociado" es inferior a lo que debería asignarse para fines gerenciales.',
        modalConfirmPriceNegotiatedText2: "¿Confirma el valor?",
        successOnDelete: "Transferencia/Venta eliminada con éxito.",
        errorMessageOnDeleteTransferAlreadyConfirmed:
          "¡Atención! Esta venta/transferencia ya ha sido confirmada en la granja de Destino.",
        errorMessageOnDelete:
          "La venta no fue eliminada. Por favor, contacte al soporte.",
        modalConfirmFinancialTransactions:
          "¿Actualizar la Transacción Financiera de esta Venta?",
        modalConfirmExpirationDate:
          "¡Atención! La fecha de vencimiento es anterior a la de facturación.",
        error: "Error",
        errorNoAnimals: "No es posible continuar sin informar animales",
        errorAnimalsWithoutSaleWeight:
          "Existen animales sin información de peso de venta",
        errorCarcassHarnessingRange:
          "El aprovechamiento de canal debe estar entre 25% y 75,5%",
        errorCarcassHarnessingGreaterThanWeight:
          "El aprovechamiento de canal no puede ser mayor que el peso del animal",
        errorAnimalsWithoutCarcassHarnessing:
          "Existen animales sin información de % aprov. canal",
        errorAnimalsCarcassHarnessingOutOfRange:
          "Existen animales con % aprov. canal fuera del intervalo permitido 25% hasta 75,5%",
        errorAnimalsCarcassWeightOutOfRange:
          "Existen animales con peso de canal fuera del intervalo permitido",
        errorBillingDateBeforeSellDate:
          "La fecha de facturación no puede ser anterior a la fecha de salida.",
        errorInvalidInstallments: "¡Parcelamiento inválido!",
        errorInvalidResultCenter: "¡Centro de Resultado inválido!",
        errorFinancialProjectAfterBillingDate:
          "El proyecto financiero seleccionado inicia después de la fecha de facturación. Por favor, seleccione otro proyecto.",
        errorSaleWithEventsAfterDate:
          "¡No está permitida la venta de animales con eventos posteriores a la fecha de salida!",
        errorRegisterTransaction: "No fue posible registrar la transacción.",
        modalAnimalLastEventIdentification: "Identificación",
        modalAnimalLastEventEvent: "Evento",
        modalAnimalLastEventDate: "Fecha",
        ok: "Ok",
        attention: "Atención",
        generateDocumentTooltip:
          'Generar "{documentNumber}" único automáticamente.',
      },
    },
    resultCenterAnalysis: {
      filters: {
        resultCenter: "Centro de beneficio",
        costCenter: "Centro de costos",
        period: "Periodo",
        visualization: {
          label: "Visualización",
          costing: "Cálculo de costes",
          cashFlow: "Efectivo Flo",
        },
        buttonConfirm: "Proces",
      },
      income: {
        title: "Ingresos",
        costCenterName: "Centro de costos",
        total: "Valor total",
        totalPercentage: "Total (%",
      },
      expense: {
        title: "Expensas",
        costCenterName: "Centro de costos",
        total: "Valor total",
        totalPercentage: "Total (%",
      },
      total: "Equilibrio",
    },
    messages: {
      deleteSuccess: "Transacción eliminada con éxito.",
      deleteError: "La transacción no fue eliminada. Contacte al soporte.",
      issueResolved: "Pendencia de la Transacción resuelta.",
      issueReopened: "Pendencia de la Transacción reabierta.",
      saveSuccess: "Transacción financiera guardada con éxito.",
      updateSuccess: "Transacción financiera actualizada con éxito.",
      saveError:
        "Se produjo un error al registrar la transacción. Contacte al soporte",
      errorTitle: "Error al registrar",
      projectAfterBillingDate:
        "El proyecto financiero seleccionado comienza después de la fecha de facturación. Por favor, seleccione otro proyecto.",
      budgetExceeded: "El valor presupuestado para esta Clase fue superado.",
      budgetWarningTitle: "¡Atención!",
      classNotCosting:
        "Los movimientos asociados a esta Clase no se consideran para el Costeo, solo para la gestión del Flujo de Caja.",
      classNotCostingTitle: "Atención",
      errorDateExpiration:
        "¡Atención! La fecha de vencimiento es anterior a la de facturación.",
      errorDateConfirm: "Confirmar",
      errorDateCancel: "Cancelar",
      editingTransaction: "Editando transacción",
      resultCenterReinform:
        "Por favor, vuelva a ingresar el prorrateo del Centro de Resultado.",
      noAnimalsForSale: "Para continuar, debe seleccionar al menos 1 animal.",
      resultCenterLoadError: "¡No se encontró ningún centro de resultados!",
      deleteTransactionConfirm:
        "Al eliminar este movimiento, todos los movimientos relacionados al Documento y Proveedor/Cliente también serán eliminados",
      saveErrorTitle: "Error al guardar",
      saveInvoiceError: "Error al guardar la factura. Contacte al soporte.",
    },
    table: {
      rateio: "Prorrateo",
      parcelas: "Cuotas",
      partialPayment: "Pago Parcial",
      issueResolved: "Pend. Resuelta",
      issueReopen: "Reactivar Pend.",
      valuePaid: "Monto Pagado",
      remainingValue: "Valor residual",
      tagOpen: "Abierto",
      tagSettled: "Liquidado",
      tagConciliated: "Conciliado",
      tagPartialConciliated: "Parç. Conciliado",
      tagExternal: "Externo",
      tagConversion: "Conversión",
      tagPending: "Pendiente",
      tagStandard: "Estándar",
      settle: "Liquidar",
      removeSettle: "Remover liquidación(es)",
      tooltipSettle: "Seleccione uno o más movimientos para liquidar",
      tooltipRemoveSettle:
        "Seleccione uno o más movimientos para remover las liquidaciones",
    },
    apportionmentActivity: {
      title: "Prorrateo por Actividades",
      totalValue: "Valor total",
      apportionmentType: "Tipo de prorrateo",
      byHead: "Por Cabeza",
      byPercentage: "Porcentaje",
    },
    resultCenter: {
      editedLabel: "(Editado)",
      numberOfAnimals: "# Animales",
      area: "Área",
    },
    financialNatureApportionmentForm: {
      natureza: "Naturaleza",
      rateio: "Prorrateo",
      numberOfAnimals: "# Animales",
      area: "Área",
      automatic: "Automático",
    },
    resultCenterApportionment: {
      loadError:
        "No se pudo cargar la información de los centros de resultados. Contacte al soporte",
      apportionmentTypeRequired: "Tipo de prorrateo no informado.",
      apportionmentSumError: "La suma del prorrateo debe ser el 100%.",
    },
    bankConciliation: {
      statement: {
        fileLoaded: "Archivo cargado con éxito",
        fileError: "Error al enviar el archivo",
        fileErrorBankNotRegistered:
          "Error al procesar el archivo. Banco no registrado.",
        fileErrorAccountNotRegistered:
          "Error al procesar el archivo. Cuenta Bancaria no registrada.",
        fileErrorAlreadyImported:
          "Error al procesar el archivo. El archivo ya fue importado en el sistema.",
        statementSaved: "Extracto guardado con éxito",
        statementSaveError: "Error al guardar el extracto",
        selectFile: "Seleccione un archivo",
        selectRecord: "Seleccione al menos un registro para continuar",
      },
    },
    settleModal: {
      messages: {
        fetchError: "Error al buscar movimientos financieros",
        settleSuccess:
          "Los movimientos financieros fueron actualizados y liquidados",
        settleError:
          "No se pudieron liquidar los movimientos financieros. Contacte al soporte.",
        unsettleSuccess:
          'Los movimientos financieros fueron actualizados y su estado actualizado a "Abierto"',
        unsettleError:
          "No se pudieron actualizar los movimientos financieros. Contacte al soporte.",
        selectFirst: "Debe seleccionar los movimientos primero.",
        dateIncompatibleError:
          "Fecha de liquidación incompatible con la fecha de facturación de {{count}} Mov. Financiero(s).",
        alreadySettledWarningTitle: "Atención",
        alreadySettledWarningContent:
          "Los movimientos que ya estaban liquidados serán actualizados. ¿Desea continuar?",
        alreadySettledWarningOk: "No",
        alreadySettledWarningCancel: "Sí",
        selectOnlySettledError:
          'Por favor, seleccione solo movimientos con el estado "Liquidado".',
        selectOnlyNotPartiallyPaidError:
          "Por favor, seleccione solo movimientos que no fueron pagados parcialmente.",
        errorTitle: "Error",
        warningTitle: "Atención",
      },
    },
    financialClass: {
      messages: {
        saveSuccess: "Clase financiera creada con éxito.",
        updateSuccess: "Clase financiera actualizada con éxito.",
        saveError:
          "Error al crear/actualizar la clase financiera. Contacte al soporte.",
        warningTitle:
          "Al confirmar, los siguientes elementos deben considerarse:",
        warningContent:
          'Actualice la información de esta nueva Clase en "Centro de Costo X Centro de Resultado" para todos los Centros de Costo en Parámetros > Costeo > Centro de Costo, de lo contrario, los costos y movimientos de esta Clase no serán apropiados.',
      },
    },
    financialProject: {
      messages: {
        alreadyExists:
          "¡Atención! Ya existe un proyecto registrado con este nombre.",
        saveSuccess: "Proyecto Financiero registrado/actualizado con éxito.",
        saveError:
          "Error al guardar el Proyecto Financiero. Contacte al soporte.",
      },
    },
    financialCashFlowBudget: {
      title: "Nuevo presupuesto",
      form: {
        monthYear: "Mes/Año*",
        activities: "Actividades*",
        defaultCurrency: "Moneda predeterminada",
        total: "Total:",
        insertUntilMonthYear: "Insertar/Actualizar hasta Mes/Año",
      },
      messages: {
        dateError:
          'El mes y año del campo "Insertar/Actualizar hasta Mes/Año" debe ser mayor que el mes y año de inicio.',
        valueError: 'Es necesario ingresar un valor para alguna "Clase".',
        saveSuccess: "Presupuesto registrado con éxito",
        saveError: "Error al registrar presupuesto. Contacte al soporte.",
      },
    },
    importFinancialTransactionNote:
      "Obs. Si no se informa un N° de Documento, el sistema generará un número aleatorio.",
    importSelectCurrencyLabel: "Seleccione la moneda de importación",
    import: {
      messages: {
        templateGenerating:
          "Su plantilla de importación está siendo generada y pronto se descargará. Por favor espere.",
        templateError:
          "Hubo un error al generar la plantilla. Contacte al soporte.",
        importedAndUpdated: "Movimientos financieros importados y actualizados",
        importedAndUpdatedDesc:
          'Algunos movimientos financieros fueron actualizados/insertados. Acceda al menú "Importaciones", pestaña "Mov. Financieros" para ver los detalles.',
        imported: "Movimientos financieros importados",
        partiallyImported: "Movimientos financieros importados parcialmente",
        partiallyImportedDesc:
          'Algunos movimientos financieros no fueron importados. Acceda al menú "Importaciones", pestaña "Mov. Financieros" para ver los detalles.',
        processedWithError: "¡Archivo procesado con error!",
        processedWithErrorDesc:
          'Todos los movimientos financieros no fueron importados. Acceda al menú "Importaciones", pestaña "Mov. Financieros" para ver los detalles.',
        importError: "Error al importar",
        importErrorDesc: "Ningún movimiento financiero fue incluido.",
      },
    },
    partialPayment: {
      messages: {
        saveSuccess: "El pago parcial fue guardado con éxito.",
        saveError:
          "No fue posible guardar el pago parcial. Contacte al soporte.",
        valueExceedsError:
          'El valor del campo "Valor Pag. Parcial" debe ser menor que el valor de {{value}} de la movimentación financiera original.',
      },
    },
    export: {
      messages: {
        dateError:
          "La fecha de vencimiento no puede ser anterior a la fecha de facturación.",
        exportError: "Error interno. ¡Contacte al soporte!",
      },
    },
    dashboard: {
      form: {},
      messages: {
        loadError: "¡Error al retornar el resultado del panel financiero!",
        projectsNotFound: "¡Ningún proyecto financiero encontrado!",
        resultCenterNotFound: "¡Ningún centro de resultados encontrado!",
        costCenterNotFound: "¡Ningún centro de costos encontrado!",
      },
    },
  },
  costs: {
    messages: {
      depreciationRequired:
        "Es obligatorio informar el valor de Depreciación en los costos que han sido completados con su valor.",
    },
  },
  costType: {
    AllTypes: "Todo",
    Growth: "Vaca-ternero",
    RecreateFattenPasture: "R&F - Pastos",
    RecreateFattenSemiConfinement: "R&F - Pastos/Corrales de Engorde",
    RecreateFattenConfinement: "R&F - Corral de engorde",
    Agriculture: "Cultivos",
    Others: "Otro",
  },
  buttons: {
    assign: "Asignar",
    back: "Atrás",
    next: "Siguiente",
    save: "Salvar",
    cancel: "Cancelar",
    confirm: "Confirmar",
    login: "Inicia sesión",
    buttonNewProfitCenter: "Nueva actividad",
    buttonNewFarm: "Nueva granja",
    buttonNewSupplier: "Nuevo proveedor",
    yes: "Sí",
    no: "No",
    putToDeath: "Establecido como muerto",
    allocateLot: "Asignar lote",
    download: "Descargar",
    processWeights: "Procesar pesajes importados",
    processAnimals: "Procesar animales importados",
    processSupplements: "Proceso supplem./concent.",
    processVaccinations: "Procesar vacunaciones",
    edit: "Editar",
    editing: "Corrección",
    addInfo: "Datos del informe",
    delete: "Borrar",
    useAsFavorite: "Establecer como favorito",
    generate: "Crear",
    putToDiscard: "Descartar",
    process: "Proces",
    accept: "Aceptar",
    reject: "Rechazar",
    updateTable: "Tabla de actualización",
    viewAll: "Ver todo",
    add: "Adicionar",
    close: "Cerrar",
    activate: "Ativar",
    inactivate: "Inativar",
  },
  topbar: {
    title: "Administración  ",
    group: {
      title: "Grupos",
      subtitle: "Seleccione un grupo",
      submenus: {
        farm: "Granja(s)",
        add_farm: "Añadir lejos",
      },
    },
    question: {
      title: "Preguntas",
      submenus: {},
    },
    notification: {
      title: "Observaciones",
      submenus: {},
      footer: "Mostrar todo",
    },
    add: {
      title: "Agregar",
      submenus: {
        profit_center: "Actividad",
        picket: "Potrero/Corral",
        picketSupplementSupply: "Nuevo/Editar Alimentación",
        user: "Usuario",
        balance: "Dispositivo de pesaje",
        sell_and_buy: "Escenario de Adquisición/Ventas",
        animal: "Animal",
        lotProduction: "Lote de producción",
        buy: "Adquisición",
        birth: "DOB",
        importAnimalsWeights: "Pesajes de importación",
        importAnimals: "Importación de animales",
        importSupplements: "Importación Supplem./Concent.",
        importFinancialTransactions: "Importar transacciones financieras",
        importSuppliersClients: "Importar fornecedores/clientes",
        importAnimalCoverage: "Importar coberturas e DG's",
        importAnimalBirth: "Importar partos y perdidas",
        importVaccinations: "Importar vacunaciones",
        downloadBovManager: "Descargar BovManage",
      },
    },
    language: {
      title: "Traducción",
      submenus: {
        pt_br: "Português - BR",
        en: "Inglés - EE.UU.",
        es: "Español - E",
      },
    },
    user: {
      title: "Usuario",
      submenus: {
        edit_profile: "Editar perfil",
        change_user: "Cambiar usuario",
        change_password: "Cambiar contraseña",
        add_new_user: "Agregar usuario",
        signout_application: "Log ou",
      },
    },
    search: {
      title: "Buscar",
      submenus: {
        user: "Usuario",
        profit_center: "Actividad",
        picket: "Potrero/Corral",
        balance: "Dispositivo de pesaje",
        animal: "Animal",
        buy: "Adquisición",
        birth: "HACER",
      },
    },
  },
  table: {
    menu: {
      makeStandard: "Establecer como predeterminado",
      edit: "Editar",
      details: "Detalles",
      delete: "Borrar",
      inactivate: "Inactivar",
      activate: "Activar",
      addAnimalsToLotProduction: "Añade animales",
      dismemberLotProduction: "División de lotes",
      allocateLotToPicket: "Asignar lote al potrero/establo",
      putPicketInMaintenance: "Realizar el mantenimiento",
      putPicketInBreak: "Reposo",
      putPicketInRenovation: "Renovar",
      setBaseline: "Establecer como predeterminado",
      movePickets: "Transf Paddocks/Corral",
      classify: "Clasificar",
    },
  },
  error: {
    formError: "Por favor, rellene correctamente los campos obligatorios (*).",
    noGroupSelected: "Seleccione un grupo en el menú superior",
    sisbovInvalidTitle: "NAIS no válido",
    sisbovInvalidMessage: "El número NAIS debe contener al menos 15 caracteres",
  },
  notifications: {
    types: {
      newObject: "Nuevo objeto",
      purchase: "Adquisición",
      sale: "Venta",
      alert: "Alerta",
      warning: "Advertencia",
      other: "Othe",
    },
    drawer: {
      title: "Tus notificaciones y alertas",
      buttonVilualizeAll: "Establecer todo como leído",
      buttonLoadOldNotifications: "Subir los más antiguos",
      notificationsNotRead: "Observaciones no rea",
      tabNotificationTitle: "Notificaciones",
      tabAlertTitle: "Alertas",
    },
  },
  sessionExpired: {
    title: "¡Sesión caducada!",
    message:
      "Para mantener su cuenta segura, comprobamos periódicamente su presencia, vuelva a iniciar sesión",
    titleAlmostExpired: "¡Tu sesión caducará pronto!",
    messageAlmostExpired:
      "Para mantener tu cuenta segura, comprobamos periódicamente tu presencia, no olvides guardar lo que estás haciendo antes de que caduque tu sesión.",
    buttonLogout: "Cerrar sesión ahora",
    buttonConfirm: "Vale, lo entiendo",
    toExpire: "a caducar..",
  },
  sidebar: {
    home: "Hogar",
    farm: "Explotaciones agrarias",
    profit_center: "Actividades",
    picket: "Unidad de Rango/Paddocks",
    lot: "Lotes",
    animal: "Animales",
    decision: "Decisiones",
    parameters: "Parámetros",
    imports: "Importaciones",
    administration: "Administración",
    suppliers: "Proveedores",
    operations: "Operaciones",
    breed: "Razas",
    handling: "Agricultura",
    diet: "Dietas",
    pasture: "Zonas de pastoreo",
    supplement: "Supleménte./Concent.",
    adminAndUser: "Empleados de la granja",
    userInvite: "Invitación de acceso",
    client: "Clientela",
    cattleProducer: "Productores",
    payment: "Pagos",
    supplierManagement: "Gestión de proveedores",
    financial: "Entrada Financiera",
    stock: "Inventario de Insumos",
    feedFactory: "Fábrica de Raciones",
    report: "Informes",
  },
  languages: {
    pt_br: "PT",
    en: "EN",
    es: "S",
  },
  status: {
    active: "Activo",
    inactive: "Inactivo",
    dismembered: "Dividido",
    pendingData: "Datos faltantes",
    informedData: "Dat reportado",
    pending: "Pendiente",
    processing: "Tratamiento",
    completed: "Terminado",
    refused: "Rechazado",
    error: "Error",
    transfer: "Transferido",
    dead: "Muerto",
    sold: "Vendido",
    processed: "Procesado",
    confirmed: "Confirmado",
    classified: "Clasificado",
  },
  productionSubSystem: {
    semiIntensive: "Semi-Pasto/Corral de Engorde",
    intensive: "Int - Corral de engorde",
    extensive: "Ext - Pastos",
    SI: "Semi-Pasto/Corral de Engorde",
    I: "Int - Corral de engorde",
    E: "Ext - Pastur",
    Extensive: "Ext - Pastur",
    SemiIntensive: "Semi-Pasto/Corral de Engorde",
    Intensive: "Int - Corral de engorde",
  },
  productionSystem: {
    fatten: "Acabado",
    create: "Vaca-ternero",
    recreate: "Rearin de Bakground",
  },
  kpi: {
    capacity: "Ocupación",
    production: "Producción",
    cost: "Costar",
    margin: "Margen",
    gdp: "Subdirector General",
    enjoy: "Volumen de negocios (%head)",
    carbonFootprint: "Huella de carbono",
    disbursement: " Desembolso (/cabeza/mes)",
    weanCalf: "ot Peso Terneros Destetados / Peso Tot Vaca",
    iep: "CIV",
    reproductiveEfficiency: "Eficiencia reproductiva",
    weanCalfCost: "Costo por ternero destetado",
    discardedCows: "Vacas desechadas",
    assetValue: "Valor de los activos ganaderos",
    incrementalMargin: "Margen incremental",
    tooltips: {
      tooltipCapacity:
        " La ocupación es la relación (en %) entre el número actual de cabezas asignadas y la capacidad total, tal como se define en el registro de corrales de confinamiento.",
      tooltipEnjoy:
        " La tasa de rotación mide la capacidad del rebaño para generar excedentes (@ = 30 kg de peso corporal) en un espacio de tiempo determinado.",
      tooltipProduction:
        " Cantidad de @ (30 kg de peso corporal) producida por hectárea/año.",
      tooltipGDP:
        " Peso Diario Ganancia promedio, desde que el animal ingresa a la Granja.",
      tooltipMargin:
        " Margen de beneficio esperado por @ (=30kg BW) producido.",
      tooltipCost: " Costo de producción de @ (= 30 kg de peso corporal).",
      tooltipCarbonFootprint:
        " Objetivo máximo de emisiones en Kg de CO₂E por Kg de ganancia de peso.",
      tooltipDisbursement:
        " Desembolso por Cabeza/Mes de los animales actualmente en cada subsistema de producción.",
      tooltipAssetValue: "Valor de los activos ganaderos.",
      tooltipIncrementalMargin: "Margen incremental.",
      tooltipWeanCalf:
        " Indicador de la proporción del peso de los animales destetados en relación con las hembras reproductoras.",
      tooltipIEP:
        " Intervalo entre partos para hembras reproductoras que han parido al menos dos veces (Secondiparous)",
      tooltipReproductiveEfficiency:
        " Eficiencia Reproductiva Final de las vacas atendidas, considerando Tasa de Preñez (RP), Tasa de Natalidad (RM) y Tasa de Destete (RM).",
      tooltipWeanCalfCost:
        " Costo del ternero destetado, incluidos todos los costos incurridos por la vaca y el ternero.",
      tooltipDiscardedCows: "% de vacas descartadas en el período",
    },
  },
  zipCodeValid: "Código postal encontrado",
  zipCodeInvalid: "Código postal no encontrado",
  defaultSelectPlaceholder: "Seleccione una opción",
  defaultMultiSelectPlaceholder: "Seleccione una o más opciones",
  defaultDatePickerPlaceholder: "Selecciona una fecha",
  defaultPlaceholder: "Introduzca un valor",
  filters: {
    applyFilter: "Aplicar filtro",
    cleanFilter: "Filtro limpio",
    filterBy: "Filtrar por",
    filterByOptions: {
      age: "Edad",
      gender: "Género",
      breed: "Raza",
      supplier: "Proveedores",
      farmOwner: "Dueño",
    },
    compareBy: "Comparar por",
    value: "Valor(es)",
    male: "Masculino",
    female: "Hembra",
    min: "Min",
    max: "un",
    equal: "Igual a",
    greaterThan: "Mayor que",
    lessThan: "Menos que",
    between: "Entre",
  },
  groupAndFarmModal: {
    hello: "¡Hola!",
    groupSelectedLabel: "Seleccione un grupo",
    groupSelectedPlaceHolder: " Seleccione un grupo ",
    farmSelectedLabel: "Seleccione una granja",
    farmSelectedPlaceHolder: " Seleccione una granja",
    buttonAccessFarm: " Granja de acceso",
  },
  importAnimalWeights: {
    title: " Historial de pesaje y mediciones de importación ",
    message:
      '<p class="message">Descargue <strong>la plantilla a continuación, complete las columnas de la hoja de cálculo</strong> con valores de peso, <strong>e importe el archivo</strong> en la secuencia, haciendo clic para procesar pesajes</p>',
    draggerMessage:
      " Haga clic o arrastre el archivo a esta área para cargarlo.",
    importType: {
      label: "Seleccione el tipo de importación:",
      weights: "Importar Pesajes",
      weightsAndMeasurements: "Importar Pesajes y Mediciones",
    },
  },
  importAnimals: {
    title: " Importar animales al lote de producción ",
    message:
      '<p class="message">Seleccione un lote de producción, descargue <strong>la plantilla a continuación, complete las columnas de la hoja de cálculo</strong> con los datos de los animales a importar, <strong>ejecute importando</strong> y haga clic para procesar animales</p>',
    messageForDifferentsLots:
      '<p class="message">Descargue <strong>la plantilla a continuación, complete las columnas de la hoja de cálculo</strong> con datos relacionados con animales y lotes, <strong>execute import</strong> y haga clic para procesar animals</p>',
    messageForIdentifyAnimals:
      '<p class="message">Download<strong>la plantilla a continuación, llene las columnas de la hoja de cálculo</strong> con datos relacionados con ambos, animales, lotes de producción y lotes receptores, <strong>ejecute importando</strong> y haga clic para procesar animales</p>',
    draggerMessage:
      " Haga clic o arrastre el archivo a esta área para cargarlo. ",
    helpMessage:
      ' Importar animales por lote y proveedor: Introduzca el lote y el proveedor de cada animal en la hoja de cálculo. De esta manera, es posible importar animales de diferentes proveedores y para más de un lote de producción. El proveedor y el lote de producción deben registrarse con anticipación, y el campo "Id de lote" debe usarse en la hoja de cálculo para el lote de producción, mientras que para el proveedor, ingrese el "IRS/EIN" del registro. \nImportar animales para un solo lote y proveedor: Seleccione un lote de producción y un proveedor ya registrado. Si el animal a importar es de la propia granja, seleccione la opción "Animal(es) suministrado(s) por la propia granja"',
  },
  invoiceUploadViewer: {
    buttons: {
      loadXml: "Cargar Xml",
      loadPdf: "Cargar Pdf",
      viewDocument: "Ver Documento",
    },
    errors: {
      parseXml:
        "No fue posible leer el archivo XML. Verifique si es una NF-e válida.",
      parsePdf:
        "No fue posible leer el archivo PDF. Verifique si es una DANFE válida.",
    },
    drawer: {
      title: "Documento Fiscal",
      emitter: {
        title: "Emisor",
        razaoSocial: "Razón Social",
        nomeFantasia: "Nombre Fantasía",
        cnpj: "CNPJ",
        ie: "Inscripción Estadual",
        municipioUf: "Municipio/UF",
      },
      identification: {
        title: "Identificación de la NF-e",
        accessKey: "Clave de Acceso",
        protocol: "Protocolo",
        status: "Estado SEFAZ",
        number: "Número",
        series: "Serie",
        issueDate: "Fecha de Emisión",
        exitEntryDate: "Fecha Salida/Entrada",
        operationNature: "Naturaleza de la Operación",
      },
      recipient: {
        title: "Destinatario",
        razaoSocial: "Razón Social",
        cnpj: "CNPJ/CPF",
        municipioUf: "Municipio/UF",
      },
      taxes: {
        title: "Cálculo del Impuesto",
        products: "Valor Productos",
        freight: "Valor Flete",
        insurance: "Valor Seguro",
        discount: "Descuento",
        ipi: "Valor IPI",
        icms: "Valor ICMS",
        pis: "Valor PIS",
        cofins: "Valor COFINS",
        others: "Otros Gastos",
        total: "Total de la Factura",
      },
      items: {
        title: "Ítems",
        code: "Código",
        description: "Descripción",
        ncm: "NCM",
        cfop: "CFOP",
        unit: "Un.",
        quantity: "Cant.",
        unitValue: "Vl. Unit.",
        totalValue: "Vl. Total",
        empty: "Sin ítems",
      },
    },
  },
  error404: {
    title: "ERROR 404",
    subTitle: "Página no encontrada",
    button: "Ir a Hom",
  },
  months: {
    january: "Enero",
    jan: "Ene",
    february: "Febrero",
    feb: "Feb",
    march: "Marzo",
    mar: "Estropear",
    april: "Abril",
    apr: "Apr",
    may: "Mayo",
    mmay: "Mayo",
    june: "Junio",
    jun: "Jun",
    july: "Julio",
    jul: "Jul",
    august: "Agosto",
    aug: "Ago",
    september: "Septiembre",
    sep: "Sep",
    october: "Octubre",
    oct: "Oct",
    november: "Noviembre",
    nov: "Nov",
    december: "Diciembre",
    dec: "De",
  },
  notInformed: "No informado",
  Profile: {
    drawerTitle: " Datos personales ",
    form: {
      fullName: "Nombre completo",
    },
  },
  scenarePage: {
    title: "Escenarios de Boitel",
    table: {
      column: {
        clientID: "ID de cliente",
        name: "Nombre del escenario",
        createdAt: " Fecha de creación ",
        updatedAt: " Fecha de la última actualización",
        status: "Estado",
        labelStatus: {
          hired: "Contraído",
          saved: "Salvar",
        },
      },
      detailsRow: {
        rangeWeight: "Rango de peso",
        amountAnimals: " Nº de animales ",
        entryDate: " Fecha de ingreso ",
        exitDay: " Fecha de salida ",
        daysOfStay: " Nº de Tarifas Diarias ",
        dailyPrice: "Precio diario",
        dietStrategy: "Dieta",
        carcassHarnessing: "Rendimiento de la canal - %",
        totalIncome: "Ingresos totales",
        incomeForCab: "Ingresos/cabeza",
        marginForCab: "Margen/hea",
      },
    },
  },
  boitelContractsPage: {
    title: "Contratos",
    buttonNewContract: "Nuevo Contrato",
    buttonExportContractsReport: "Exportar Informe de Contratos",
    buttonExportContractsSaleResultReport:
      "Exportar Informe de Resultado de Venta",
    table: {
      menu: {
        selectAnimals: "Seleccionar Animales",
      },
      column: {
        identificationContract: "Número de Contrato",
        customerName: "Produtor",
        dateContract: "Fecha de Contrato",
        finalDateContract: "Plazo del Contrato",
        status: "Estado",
        statusOptions: {
          vigente: "Vigente",
          encerrado: "Cerrado",
          pendente: "Pendiente",
          erro: "Error",
        },
        amountAnimals: "Cant. Animales",
        selectedAnimals: "Animales Selec.",
        animalGender: "Sexo de Animales",
        animalGenderOptions: {
          vaca: "Vaca",
          V: "Vaca",
          novilha: "Novilla",
          N: "Novilla",
          machoInteiro: "Macho Entero",
          I: "Macho Entero",
          machoCastrado: "Macho Castrado",
          C: "Macho Castrado",
        },
        entryWeight: "Peso de Entrada",
        contractDays: "Días Cont.",
        consecutiveDays: "Días Cor.",
        fileUrl: "Archivo",
        contractType: "Tipo de Contrato",
        contractTypeOptions: {
          daily: "Diaria",
          dryMatterConsume: "Cons. MS",
          arrobaProduction: "@ Prod.",
          partnership: "Asociación",
        },
      },
    },
    detailsDrawer: {
      title: "Detalles del Contrato Boitel",
      tabs: {
        general: "Información General",
        animals: "Animales Seleccionados",
      },
      errorLoadingAnimals: "Error al cargar los animales.",
      emptyAnimals: "Ningún animal seleccionado para este contrato.",
    },
    deleteModal: {
      title: "Confirmar exclusión",
      content: "¿Está seguro de que desea excluir este contrato?",
      success: "Contrato excluido con éxito",
      error: "Error al excluir contrato",
    },
    selectAnimals: {
      title: "Seleccionar Animales del Contrato",
      relateButton: "Relacionar",
      footerTotalSelected: "Animales seleccionados para el contrato:",
      herdsColumn: "Conjunto",
      summaryTitle: "Resumen por conjunto",
      animalsLabel: "animales",
      cardEdit: "Editar",
      cardDelete: "Excluir",
      deleteConfirmTitle: "Excluir relacionamiento",
      deleteConfirmText:
        "¿Desea excluir el relacionamiento de este conjunto con el contrato?",
      relateDrawerEditTitle: "Editar relacionamiento del conjunto",
      noAnimalsToSave: "Ningún animal relacionado para guardar.",
      saveSuccess: "Animales del contrato guardados con éxito.",
      saveError: "Error al guardar animales del contrato.",
      errorLoadingAnimals: "Error al cargar animales.",
      relateDrawer: {
        title: "Relacionar animales al conjunto",
        selectHerd: "Conjunto del contrato",
        selectHerdPlaceholder: "Seleccione el conjunto",
        selectHerdRequired: "Selecione un conjunto.",
        entryDateType: "Fecha de entrada",
        entryDateSingle: "Fecha única para todos",
        entryDatePerAnimal: "Fecha específica por animal",
        entryDate: "Fecha de Entrada",
        entryDateRequired: "Informe la fecha de entrada.",
        entryDateAllRequired:
          "Informe la fecha de entrada para todos los animales.",
        selectedAnimalsList: "Animales seleccionados",
        validationExceedsAmount:
          "La cantidad de animales seleccionados supera la cantidad del conjunto.",
        validationNoSlots:
          "No hay cupos suficientes en el conjunto para los animales seleccionados.",
        validationBreedMismatch:
          "Hay animales de razas diferentes a las esperadas en el grupo seleccionado.",
      },
    },
    form: {
      titleCreate: "Nuevo Contrato",
      titleEdit: "Editar Contrato",
      successCreate: "Contrato creado con éxito",
      successUpdate: "Contrato actualizado con éxito",
      errorSave: "Error al guardar contrato",
      carcassPercentageRangeError: "% Aprov. Canal debe estar entre 40 y 70.",
      errorLoading: "Error al cargar contrato",
      sections: {
        contractData: "Datos del Contrato",
        client: "Cliente",
        herd: "Rebaño",
        contractType: "Tipo de Contrato",
      },
      identificationContract: "Identificación del Contrato",
      identificationContractPlaceholder:
        "Ingrese la identificación del contrato",
      contractDate: "Fecha",
      contractDateTooltip: "Fecha de inicio de vigencia del contrato.",
      initialDateContract: "Fecha Inicial",
      initialDateContractTooltip:
        "Fecha prevista de inicio de entrada de los Lotes de Animales.",
      fileUrl: "Archivo",
      uploadFile: "Seleccionar archivo",
      cattleProducer: "Produtor",
      multipleFarm: "Granja",
      cattleProducerFarm: "Granja del Produtor",
      cattleProducerFarmPlaceholder: "Seleccione la granja",
      cattleProducerFarmRequired:
        "Es necesario seleccionar una granja del productor",
      cattleProducerRequired: "Es necesario seleccionar un productor",
      addHerd: "Agregar Rebaño",
      herdsRequired: "Se debe agregar al menos un rebaño",
      contractType: "Tipo",
      contractTypePlaceholder: "Seleccione el tipo de contrato",
      herds: {
        cjt: "CJTO",
        amountAnimals: "Cant",
        amountAnimalsPlaceholder: "Cantidad",
        breed: "Raza",
        breedPlaceholder: "Seleccione la raza",
        gender: "Sexo/Categoría",
        genderPlaceholder: "Seleccione el género",
        genderOptions: {
          vaca: "Vaca",
          novilha: "Novilla",
          machoInteiro: "Macho Entero",
          machoCastrado: "Macho Castrado",
        },
        weightAverage: "Peso Medio",
        weightAveragePlaceholder: "Peso promedio",
        useSisbov: "Sisbov",
        trace: "Id. Individual?",
        entryDate: "Fecha Entrada",
        farm: "Granja",
        farmPlaceholder: "Seleccione la granja",
        supplement: "Dieta",
        supplementPlaceholder: "Seleccione la dieta",
      },
      herdForm: {
        title: "Agregar/Editar Rebaño",
      },
      dailyContract: {
        cjt: "CJTO",
        amountAnimals: "Cant. Animales",
        numberOfDays: "N° Días",
        numberOfDaysPlaceholder: "Número de días",
        protocolValue: "Protocolo Sanitario",
        protocolValuePlaceholder: "Valor protocolo",
        fixedValue: "Valor Fijo",
        fixedValuePlaceholder: "Valor fijo",
        dietValue: "Valor Dieta",
        dietValuePlaceholder: "Valor dieta",
        otherValue: "Otros",
        otherValuePlaceholder: "Otros valores",
        dailyValue: "Valor Diaria",
        dailyValuePlaceholder: "Valor diaria",
        observation: "Observación",
        observationPlaceholder: "Ingrese una observación",
        prevCost: "Custo Previsto",
      },
      dryMatterConsumeContract: {
        measurement: "Medición",
        preFixed: "Pre-Fijado",
        provision: "Suministro",
        report: "Informe",
        cjto: "Cjto",
        unique: "Única",
        cjt: "CJTO",
        averageOffer: "Oferta Media",
        averageOfferPlaceholder: "Oferta media",
        numberOfDays: "N° Días",
        numberOfDaysPlaceholder: "Número de días",
        costPerKilogramDryMatterPlaceholder: "Valor por KgMS",
        value: "Valor",
        valuePlaceholder: "Valor",
      },
      arrobaProductionContract: {
        report: "% Aprov. Canal Informe",
        byLot: "Por Lote",
        unique: "Único",
        cjt: "CJTO",
        carcassHarnessingPercentage: "% Aprov. Canal Entrada",
        carcassHarnessingPercentagePlaceholder: "% Aprov. Canal Entrada",
        valuePerArroba: "Valor @",
        valuePerArrobaPlaceholder: "Valor @",
      },
      partnershipContract: {
        partnershipType: "Tipo de parceria",
        partnerPercentage: "Percentual do parceiro",
        numberOfDays: "N° Diárias",
        numberOfDaysPlaceholder: "Número de diárias",
        partnershipTypeOptions: {
          CARCASS_HARNESSING: "% Aprov. de Carcaça",
          ARROBA_PRODUCTION: "@ Produzida",
        },
        report: "Informe",
        byLot: "Por Lote",
        unique: "Único",
        cjt: "CJTO",
        carcassEntryPercentage: "% Aprov. Canal Entrada",
        carcassEntryPercentagePlaceholder: "% Aprov. Canal Entrada",
        agreedWeightLabel: "Seleccione Peso Acordado",
        agreedWeightPvFaz: "PV Faz.",
        agreedWeightPvConf: "PV Conf.",
        maxBreak: "Quebra Máxima Permitida",
        maxBreakPlaceholder: "Quebra máxima",
      },
    },
    tabs: {
      contracts: "Contratos",
      slaughterSchedule: "Programación",
    },
  },
  slaughterSchedule: {
    title: "Programación de Faena",
    errorLoading: "Error al cargar datos de programación de faena",
    drawer: {
      title: "Detalles del Lote",
    },
    table: {
      column: {
        status: "Estado",
        statusOptions: {
          active: "Activo",
          inactive: "Inactivo",
          sold: "Vendido",
        },
        picketName: "Potrero/Baya",
        lotName: "Lote",
        type: "Tipo",
        contractTypeOptions: {
          daily: "Diaria",
          dryMatterConsume: "Consumo MS",
          arrobaProduction: "@ Producción",
          partnership: "Asociación",
          own: "Propio",
        },
        ownType: "Propio",
        producerPartner: "Productor/Socio",
        animalsAmount: "Cant. Animales",
        gender: "Sexo",
        genderOptions: {
          male: "Macho",
          female: "Hembra",
          both: "Ambos",
        },
        breed: "Raza",
        entryDate: "Fecha Entrada",
        entryWeight: "Peso Entrada",
        contractForecast: {
          blockTitle: "Previsión Contrato",
          forecastAdg: "GMD Prev.",
          currentForecastWeight: "Peso Actual Prev.",
          stayTime: "Tiempo Perm.",
          slaughterWeight: "Peso Faena",
          slaughterDays: "Días Faena",
          slaughterDate: "Fecha Faena",
        },
        saleScenarioBlock: {
          blockTitle: "Escenario de Venta BovExo",
          projectedWeightEd: "Peso Proy. ED",
          saleScenario: "Escenario de Venta",
          cvProcessingDate: "Fecha Procesamiento CV",
          suggestedSaleDate: "Fecha Sugerida de Venta",
          estimatedSaleWeight: "Peso Estimado de Venta",
        },
      },
    },
  },
  boitelSaleScenario: {
    title: "Escenarios de venta",
    result: "Resultado(s)",
    btn: {
      newScenare: "Nuevo Scenari",
    },
    table: {
      column: {
        scenare: "Escenario",
        client: "Cliente",
        favorite: "Favorito",
        status: "Estado",
        actions: "Acciones",
        labelStatus: {
          analyzing: "Evaluar",
          processed: "Procesado",
          canceled: "Cancelado",
          partialCanceled: "Parte Cancelada",
          sold: "Vendido",
          partialSold: "Parte Sol",
        },
      },
      detailsRow: {
        identification: "Identificación",
        saleAnimals: " Animales en venta ",
        receive: "Para recibir",
        margin: "Margen",
        processedAt: " Procesado en",
      },
    },
    new: {
      title: "Creación: Boitel Sale",
      tabs: {
        lots: {
          title: "Batches selectio",
        },
        dietStrategy: {
          title: "Selección de la estrategia dietética",
        },
        parameters: {
          title: "Definición de parámetros",
          form: {
            name: "Nombre del escenario*",
            animalsInTruck: "Animales por camión*",
            minimumAge: "Edad mínima para la venta*",
            maximumAge: "Edad máxima para la venta*",
            minimumWeight: "Peso mínimo en venta*",
            maximumWeight: "Peso máximo en venta*",
            useDefaultMaximumWeight: "Peso máximo en venta*",
            allowSeparateSell: "¿Se pueden dividir los lotes?",
            goalType: "Objetivo del escenario*",
            commitments: "¿Hay algún compromiso para el escenario?",
            newCommitment: "Añadir un nuevo compromiso",
            marketAnalysisId: "Análisis de mercado*",
            useCustomCarcassHarnessing:
              "¿Introducir el nuevo % de rendimiento de la canal?",
            useCustomCarcassHarnessingHelp:
              " De forma predeterminada, el sistema utiliza el % de rendimiento de canales informado en el proceso de adquisición de animales y la formación de lotes.",
            carcassHarnessing: "Carcasa Yiel",
          },
        },
      },
    },
    edit: {
      title: "Montaje: Boitel Sal",
    },
    details: {
      messageSelectDates:
        " Seleccione una fecha sugerida (s) del calendario para ver la información de los animales.",
      calendarSuggested: "Calendario sugerido",
      weekDateNull: " Animales con violación Boitel ",
      animalsToSell: " Animales en venta ",
      planningIncome: "Ingresos estimados",
      dietStrategiesSuggested: "Estrategia dietética sugerida",
      commitments: "Compromisos",
      violations: "Violaciones",
      parameters: "Parámetros del escenario",
      marketValues: " Valores de referencia ",
      violationAge: "Edad",
      violationWeight: "Peso",
      violationBoitel: "Boitel",
      violationMinAge: "Edad mínima",
      violationMaxAge: "Edad máxima",
      violationMinWeight: "Peso mínimo",
      violationMaxWeight: "Peso máximo",
      table: {
        columns: {
          animalHandlingNumber: "Identificación",
          sellDate: "Fecha sugerida",
          weight: "Estim. peso",
          lastDailyWeight: "Último peso",
          averageWeightGain: "Subdirector General",
          aggregateArroba: "Neto añadido @",
          saleIncome: "Ingresos",
          aggregateIncome: "Ingresos añadidos",
          cost: "Costar",
          aggregateMargin: "Margen añadido",
          margin: "Margi",
        },
      },
    },
  },
  importSupplements: {
    title: " Suplementos de importación ",
    message:
      '<p class="message">Descarga <strong>la plantilla a continuación, llena las columnas de la hoja de cálculo</strong> con datos de suplementos, <strong> impórtalo</strongy haz clic para procesar suplementos</p>',
    draggerMessage:
      " Haga clic o arrastre el archivo a esta área para cargarlo.",
  },
  importSuppliersClients: {
    title: "Importar proveedores/clientes",
    message:
      '<p class="message">Descarga <strong>la plantilla a continuación, llena las columnas de la hoja de cálculo</strong> con datos de proveedores/clientes, <strong> impórtalo</strong> y haz clic para procesar</p>',
    draggerMessage:
      "Haga clic o arrastre el archivo a esta área para cargarlo.",
    groupFarmVisibility: "¿Dónde se importarán los proveedores/clientes?",
    success: {
      title: "Proveedores/Clientes importados",
      description: "La importación fue procesada con éxito.",
    },
    error: {
      title: "Error al importar",
      description: "Ningún proveedor/cliente fue incluido.",
    },
  },
  eventLog: {
    fromValueLabel: "Modificado de",
    toValueLabel: "Para",
    dateLabel: "Fecha",
    attributeLabel: "Propiedad",
    userLabel: "Usuario",
    nullLabel: "vacío",
    Supplement: {
      createdAt: "Creación de registro: ",
      name: "Nombre",
      type: "Tipo",
      classification: "Clasificación",
      industrialName: "Marca",
      status: "Condición",
      cost: "Costar",
      cp: "CP",
      tdn: "TDN",
      npn: "NNP",
      dryMatterPercentage: "DECÍMETRO",
      nitrogen: "Nitrógeno",
      calcium: "Calcio",
      phosphorus: "Fósforo",
      zinc: "Zinc",
      sodium: "Sodio",
      minimumVoluntaryConsumption: "Alimentación voluntaria (mín.)",
      maximumVoluntaryConsumption: "Alimentación voluntaria (máx.)",
      voluntaryConsumptionType: "Unidad",
      minimumPure: "Producto puro ofrecido (Min)",
      maximumPure: "Producto puro ofrecido (Max)",
      minimumPureTrough: "Recom. Tamaño de la cubeta (mín.)",
      maximumPureTrough: "Recom. Tamaño del canal (máx.)",
      pureConsumptionType: "Unidad",
      minimumMix: "Producto Mixto Ofrecido (Min)",
      maximumMix: "Producto Mixto Ofrecido (Max)",
      minimumMixTrough: "Recom. Tamaño de la cubeta (mín.)",
      maximumMixTrough: "Recom. Tamaño del canal (máx.)",
      mixConsumptionType: "Unidad",
      currentVersion: "Versión",
      proportion: "Roportio",
      additiveEffect: "Efecto aditivo",
      additiveEffectUnit: "Unidade Efeito Aditivo",
      fda: "ADF",
      lignin: "Lignina",
      ee: "Extracto etéreo",
    },
  },
  reproductionParameters: {
    title: " Parámetros de reproducción ",
    parameters: {
      IDADE_INICIO_FASE_REPRODUTIVA: "Edad mínima para la cría*",
      PERIODO_DESCANSO_POS_PARTO: " Periodo de descanso postparto *",
      TEMPO_APOS_COBERTURA_PARA_DG:
        " Tiempo posterior al servicio para el diagnóstico del embarazo *",
      TOURO_COBERTURAS_DESCONHECIDAS: "Toro de servicio desconocido*",
      IDADE_DESMAMA: "Edad de destete",
      CONSISTIR_TEMPO_GESTACAO_NO_PARTO:
        "Al lanzar partos de IA, con tiempo de gestación superior al parametrizado, lanzar automáticamente un MC/Repasse, de TORO DESCONOCIDO, utilizando el tiempo medio de gestación?*",
    },
    reproductionPeriod: {
      title: "Temporadas de cría",
      titleHelper:
        " La Temporada de Cría es el período reproductivo de la propiedad, comenzando el D0 del primer protocolo/Servicio de Inseminación del lote y finalizando con el Diagnóstico Final de Gestación",
    },
    score: {
      title: " Puntuación de probabilidad de éxito reproductivo ",
      titleHelper:
        " Define, en base a la escala de puntuación de 1 a 9, la probabilidad en % de éxito reproductivo. Esta puntuación se aplicará en la tabla para generar la curva de puntuación Edad x Peso x Cuerpo",
    },
    breedScore: {
      title: " Curva de Edad x Peso x Puntuación Corporal ",
      titleHelper:
        " Definir para las Hembras Reproductoras, considerando la Edad, el Peso Actual y la Puntuación de Probabilidad de Éxito Reproductivo, las variables necesarias para calcular el costo para, hasta la próxima Temporada de Cría, alcanzar cada puntuación corporal.",
      form: {
        title: " Nueva entrada (Raza X Edad X Peso X Puntuación)",
        breedId: "Raza*",
        age: "Edad*",
        startWeight: "Peso inicial*",
        endWeight: "Peso final*",
        weight: "Peso",
        score: "Puntuación*",
        errors: {
          errorWithFieldWeights:
            ' Hay algunos pesos sin "Puntuación". Rellénelos para guardar el formulario',
        },
      },
    },
  },
  semen: {
    title: " Listado de semen ",
    buttonNewSemen: "Nuevo semen",
    table: {
      columns: {
        name: "Nombre",
        registration: "Registro",
        breedName: "Bree",
      },
    },
    form: {
      titleCreateNewSemen: "Nuevo semen",
      titleEditSemen: "Editar Semen",
      name: "Nombre",
      registration: "Registro",
      breedId: "Bree",
      genealogy: "Genealogía",
      father: "Padre",
      mother: "Madre",
      identification: "Identificación",
    },
  },
  movimentAnimals: {
    title: "Transferencias entre lotes",
    description:
      ' Seleccione los animales de la tabla y haga clic en el botón "Transferir" para reubicar los animales ',
    buttonMovementAnimals: "Transferencia",
    form: {
      title: " Nueva transferencia - Lote de destino",
    },
  },
  closedSalesReport: {
    form: {
      title: "Resultados de ventas",
      salesPeriod: "Periodo de ventas",
      clientId: "Cliente",
      supplierId: "Proveedor",
      saleScenarioId: "Escenario(s) de ventas",
      animalGender: "Género",
      showOriginData: "¿Mostrar origen de los animales vendidos?",
      dailyOperationalCostMode: "Diaria Operacional",
      dailyOperationalCostModeOptions: {
        BOVEXO_COSTING: "Calculado por BovExo",
        USER_DEFINED: "Definido por el Usuario (R$/Día)",
      },
      additionalSlaughterCostValue: "Costos Adicionales de Faena",
    },
  },
  exportFinancialTransactions: {
    modal: {
      title: " Operaciones financieras de exportación ",
      billingPeriod: " Facturación ",
      expirationPeriod: " Madurez ",
      suppliers: "Proveedor(es)",
      costActivities: "Actividad(es)",
      clients: "Cliente(s)",
      transactionType: "Tipo",
      financialProjectId: "Proyecto de inversión",
      status: "Statu",
    },
  },
  unit: {
    title: " Listado de unidades ",
    buttonNew: "Nueva unidad",
    table: {
      columns: {
        name: "Abreviatura",
        description: "Descripción",
        basicUnit: "Unidad Básica",
        multiplier: "Multiplicador",
        status: "Estado",
        createdAt: "Fecha de creación",
        createdBy: "Responsable de Creatio",
      },
    },
    form: {
      titleCreateNew: "Nueva unidad",
      titleEdit: "Unidad de edición",
      groupFarmVisibility: " ¿Quién usará la Unidad?",
      name: "Abreviatura",
      description: "Descripción",
      basicUnit: "Unidad Básica",
      multiplier: "Multiplicador",
      status: "Statu",
    },
  },
  measurement: {
    title: "Listado de Mediciones",
    buttonNew: "Nueva Medición",
    table: {
      columns: {
        name: "Nombre",
        code: "Código",
        status: "Estado",
        createdAt: "Fecha de creación",
        createdBy: "Responsable de Creación",
      },
    },
    form: {
      titleCreateNew: "Nueva Medición",
      titleEdit: "Editar Medición",
      name: "Nombre",
      code: "Código",
      status: "Estado",
      nameRequired: "El nombre es obligatorio",
      codeRequired: "El código es obligatorio",
    },
  },
  veterinary: {
    title: " Lista de suministros veterinarios ",
    buttonNew: "Nuevo aporte veterinario",
    table: {
      columns: {
        name: "Marca",
        type: "Tipo",
        supplierId: "Proveedor",
        supplierName: "Proveedor",
        status: "Estado",
        createdAt: "Fecha de creación",
        createdBy: "Responsable de Creatio",
      },
    },
    form: {
      titleCreateNew: "Nuevo aporte veterinario",
      titleEdit: "Editar la entrada veterinaria",
      groupFarmVisibility: "¿Quién utilizará el insumo veterinario?",
      name: "Marca",
      type: "Tipo",
      supplierId: "Proveedor",
      applicationGender: "Género",
      applicationAge: "Edad",
      applicationType: "Vía de administración",
      applicationValue: "Administración amt.",
      applicationWeightValueParam: "Peso",
      unitId: "Unidad utilizada",
      applicationCost: "Costo de administración",
      status: "Statu",
    },
  },
  handlingReproduction: {
    title: "Agricultura",
    tabs: {
      reproductiveProtocol: "Protocolos",
      coverage: "Servicio de reproducción",
      pregnancyDiagnosis: " Diagnóstico del embarazo ",
      animalBirth: " Nacimientos y pérdidas",
    },
    dashboards: {
      dashboardReproductionPeriod: {
        reproductionPeriodSelected: "Estación de Monta",
        lotIdsSelected: "Lotes",
        totalFemalesSuitable: "Hembras Aptas",
        totalCoverageFemales: "Hembras Trabajadas",
        totalInserminatedFemales: "Hembras Inseminadas",
        totalInserminations: "N° de Inseminaciones",
        totalCoverageIatfPlusRepasseFemales: "Hembras en Servicio Natural",
        totalPregnancyFemales: "Hembras Preñadas",
        pregnancyRate: "Tasa de Preñez",
        totalFemalesWithNoResult: "Sin Resultado",
        totalFemalesWithGestationalLosses: "Pérdidas Gestacionales",
      },
    },
  },
  handlingReproductionCoverage: {
    title: "Listado de servicios de Reprod",
    buttonHandlingReproductionCoverage: "Nuevo servicio",
    type: {
      iatf: "Inteligencia Islámica del Comercio (IA)",
      repasse: "FS/Derogación",
    },
    table: {
      columns: {
        animalHandlingNumber: "Hembra",
        coverageDate: "Fecha",
        type: "Tipo",
        maleHandlingNumber: "Toro",
        semenNameAndRegistration: "Semen",
        semenOrMaleIdentification: "Toro/Semen",
        lotName: "LOTE",
        dose: "Dosificación",
        reproductionPeriodDescription: "Época de cría",
        inseminatorName: "Técnico de IA",
        pregnancyDiagnosisResult: "Resul",
        semenDeparture: "Salida",
        observation: "Observación",
        bodyConditionScore: "ECC",
        last_weight: "Último Peso",
        last_weight_date: "Fecha de Última Pesaje",
        animal_farm_function: "Propósito",
      },
    },
    form: {
      type: "Tipo",
      animalId: "Identificación",
      category: "Categoría",
      semenId: "Semen",
      maleId: "Toro",
      dose: "Dosificación",
      inseminatorId: "Técnico de IA",
      coverageDate: "Fecha de servicio",
      reproductionPeriodId: "Cría Seaso",
      semenDeparture: "Salida",
      observation: "Observación",
      bodyConditionScore: "ECC",
    },
    errorsAndMessages: {
      successMessage: " ¡Servicio guardado/actualizado con éxito!",
      femaleWithoutReproductionAge:
        " La hembra no tiene la edad suficiente para comenzar la fase reproductiva, ¿quieres continuar?",
      femaleDontHaveAgeToCoverage:
        " ¡Atención! La mujer no tiene la edad suficiente para este servicio.",
      reproductionPeriodWithoutCurrentDate:
        " ¡Atención! Es necesario tener registrada una temporada de cría durante el período de servicio.",
      errorFemaleWithFutureCoverages:
        " ¡Atención! Female ya tiene el servicio publicado en fechas posteriores.",
      errorFemaleWithCoverageInSameDateAndType:
        " ¡Atención! Servicio ya registrado con anterioridad.",
      errorInternalError:
        " Error al registrar/actualizar el servicio. Póngase en contacto con el servicio de",
    },
  },
  inseminator: {
    title: "Listado de técnicos de IA",
    buttonNewInseminator: "Nuevo técnico de IA",
    table: {
      columns: {
        name: "Nombre",
        code: "ID de código",
        status: "Statu",
      },
    },
    form: {
      titleCreateNewInseminator: "Técnico de IA de Novo",
      titleEditInseminator: "Editar Técnico de IA",
      name: "Nombre",
      code: "Código I",
    },
  },
  multipleBull: {
    title: "Toros múltiples",
    buttonNewMultipleBull: "Nuevo Toro Múltiple",
    table: {
      columns: {
        name: "Nombre",
        code: "ID de código",
        males: "Toros",
        formationDate: "Fecha de agrupación",
        status: "Statu",
      },
    },
    form: {
      titleCreateNewMultipleBull: "Nuevo Toro Múltiple",
      titleEditMultipleBull: "Editar Toro Múltiple",
      name: "Nombre",
      code: "ID de código",
      males: "Toros",
      formationDate: "Fecha de agrupación",
      status: "Statu",
    },
  },
  ovarianResult: {
    SemAvaliacao: "Sin evaluación",
    CorpoLuteo: " cuerpo lúteo ",
    Foliculo: "Folicular",
    Cisto: " Quistes ováricos ",
    Anestro: " Anestro ",
    Normal: "Normal",
    Reabsorvendo: "Resorción",
    Gemelar: "Doble conditio",
  },
  animalPregnancyDiagnosis: {
    title: "Diagnóstico del embarazo",
    buttonNew: "Nuevo diagnóstico de embarazo",
    table: {
      columns: {
        animalHandlingNumber: "Hembra",
        lotOriginalName: "LOTE",
        diagnosisDate: "Fecha de PD",
        result: "Resultado",
        ovarianEvaluationResult: "Evaluación ovárica",
      },
      export: {
        columns: {
          handling_number: "Identificación",
          tag_id: "Identificación Electrónica",
          sisbov: "SISBOV",
          name: "Nombre",
          status: "Estado",
          last_lot: "Último Lote",
          move_date: "Fecha de Movimentación",
          current_lot: "Lote Actual",
          last_pregnancy_diagnosis_date: "Fecha Penúltimo DG",
          last_pregnancy_diagnosis_result: "Resultado Penúltimo DG",
          last_pregnancy_diagnosis_ovarian_evaluation_result:
            "Resultado Penúltimo DG Evaluación Ovárica",
          current_pregnancy_diagnosis_date: "Fecha Último DG",
          current_pregnancy_diagnosis_result: "Resultado Último DG",
          current_pregnancy_diagnosis_ovarian_evaluation_result:
            "Resultado Último DG Evaluación Ovárica",
          current_birth_date: "Fecha Último Parto",
          current_birth_type: "Tipo de Parto",
        },
      },
    },
    form: {
      titleCreateNew: "Nuevo diagnóstico de embarazo",
      titleEdit: "Editar Diagnóstico de Embarazo",
      diagnosisDate: "Fecha de diagnóstico",
      animalId: "Identificación",
      animalReproductionCategory: "Categoría",
      femaleSituation: "Condición",
      lastCoverage: "Último servicio",
      lotName: "Lote actual",
      result: "Resultado",
      ovarianEvaluationResult: "Evaluación ovárica",
      lastCoverageReproductionPeriodId: "Época de cría",
      lotDestination: "Lote de destino",
      timeGestationMC: " Periodo de gestación MC",
      gestationDays: "Periodo de gestación",
      birthForecast: "Pronóstico de nacimientos",
      shouldDiscardFemale: "¿Descartar hembra?",
      discardMotive: "Caus",
      defineCoverage: "Definir Servicio",
      selectCoverageTitle: "Seleccione el servicio responsable del embarazo:",
      coverageModalDate: "Fecha",
      coverageModalReproductor: "Toro",
      coverageModalGestationDays: "Gestación (días)",
      coverageModalInputPlaceholder: "Escribir",
      newEntry: "Nueva entrada",
      editEntry: "Editar entrada",
    },
    messages: {
      deleteSuccess: "¡Diagnóstico de gestación eliminado con éxito!",
      deleteErrorWithBirth:
        "No es posible eliminar el Diagnóstico de Gestación porque existe un registro de Parto.",
      deleteError:
        "No fue posible eliminar el Diagnóstico de Gestación. Contacte al soporte.",
      saveSuccess: "¡Diagnóstico de Gestación guardado con éxito!",
      validResultRequired: "Ingrese un resultado válido: Positivo o Negativo",
      ovarianResultRequired: "Ingrese un resultado para la Evaluación Ovárica",
      selectCoverage:
        'Seleccione un servicio usando el botón "Definir Servicio".',
      inconsistentGestationDays:
        "¡Atención! El período de gestación ingresado es inconsistente, ya que abarca un período en el que la hembra ya tiene servicio(s) con resultado(s).",
      duplicateDiagnosisDate:
        "¡Atención! Ya existe un diagnóstico de gestación en la misma fecha seleccionada.",
    },
  },
  animalWeightHistory: {
    title: " Lista de pesaje ",
    buttonExport: "Análisis de pesaje",
    buttonNew: " Nuevo pesaje ",
    table: {
      columns: {
        origination: "Origen",
        handlingNumber: "Animal",
        date: "Fecha",
        weight: "Peso",
        originationLotName: "LOTE",
        originationPicketName: "Paddock",
        event: "Typ",
      },
    },
    originEvents: {
      birthday: "DOB",
      sale: "Venta",
      weaning: "Destete",
      purchase: "Adquisición",
    },
    form: {
      titleCreateNew: "Añadir pesaje",
      titleEdit: " Editar pesaje ",
      animalId: "Identificación del animal",
      date: "Fecha de pesaje",
      weight: "Peso",
      gmd: "Subdirector General",
      lotOriginalId: "Lote actual",
      lotDestinationId: "Lote de destino",
      lastDateWeight: "Última fecha de pesaje",
      lastWeight: "Último pesaje",
      weaningWeight: "¿Destetados?",
      editIdentifications: "Editar identificaciones",
    },
    modalExportReport: {
      title: "Análisis de pesaje",
      periodDate: "Período de pesaje",
      gender: "Género",
      status: "Situación de los animales",
      periodAge: "Idade(meses)",
      lotId: "LOTE",
      supplierId: "Proveedor",
      listAnimalsWithoutWeight: "¿Lista de animales sin pesar en el período?",
      showProjectedWeight:
        " Mostrar el peso proyectado por la Estrategia de Dieta en la fecha actual",
    },
    messages: {
      successMessage: "¡Peso guardado/actualizado con éxito!",
      errorMessage: "Error al guardar/actualizar el peso. Contacte al soporte.",
      error5029Message:
        "¡Atención! El animal ya tiene un movimiento entre lotes en una fecha posterior.",
      weaningWeightError:
        "¡Atención! No es posible marcar el pesaje como destete. El animal puede tener mais de 12 meses o ya estar en el peso de destete.",
      deleteSuccess: "¡Pesaje eliminado con éxito!",
      deleteError: "El pesaje no fue eliminado. Contacte al soporte.",
      alreadyInLot: "¡Atención! El animal ya se encuentra en este Lote.",
    },
  },
  animalMeasurement: {
    title: "Lista de Mediciones",
    buttonNew: "Nueva Medición",
    tabs: {
      weights: "Pesajes",
      measurements: "Mediciones",
    },
    table: {
      columns: {
        origination: "Origen",
        handlingNumber: "Animal",
        breedName: "Raza",
        gender: "Género",
        measurementDate: "Fecha",
        originationLotName: "Lote",
        originationPicketName: "Paddock/Corral",
        measurementName: "Medición",
        value: "Valor",
      },
    },
    origination: {
      bovManager: "BovManager",
      import: "Importación",
      manual: "Manual",
    },
    gender: {
      M: "Macho",
      F: "Hembra",
    },
    export: {
      columns: {
        status: "Estado",
        handlingNumber: "Identificación",
        tagId: "Id. Electrónico",
        gender: "Género",
        breedName: "Raza",
        lastWeightDate: "Fecha Último Pesaje",
        lastWeight: "Último Pesaje",
        measurementDate: "Fecha Evaluación",
        measurementName: "Medición",
        value: "Valor",
        tempPerm: "Días en la Hacienda",
        exitDate: "Fecha de Salida",
        exitWeight: "Peso Salida",
      },
      filters: {
        status: "Estado",
        gender: "Género",
        breed: "Raza",
        measurementDate: "Fecha Evaluación",
        measurement: "Medición",
        value: "Valor de la Medición",
        lot: "Lote",
        picket: "Paddock/Corral",
      },
      statusOptions: {
        active: "Activos",
        sold: "Vendidos",
        dead: "Muertos",
      },
      genderOptions: {
        male: "Machos",
        female: "Hembras",
      },
    },
    form: {
      titleCreateNew: "Nueva Medición",
      titleEdit: "Editar Medición",
      date: "Fecha",
      measurement: "Medición",
      value: "Valor",
      currentLot: "Lote Actual",
      gender: "Género",
      breed: "Raza",
      lotDestination: "Lote Destino",
      lastMeasurement: "MEDICIÓN ANTERIOR",
      lastDate: "Fecha de la última medición",
      lastValue: "Valor de la última medición",
      saveOptions: {
        onlySave: "Guardar solamente",
        saveAndAddNew: "Guardar y agregar nueva medición",
      },
      messages: {
        successMessage: "¡Medición guardada con éxito!",
        errorMessage: "Error al guardar la medición. Inténtelo de nuevo.",
        deleteSuccess: "¡Medición eliminada con éxito!",
        deleteError: "Error al eliminar la medición. Inténtelo de nuevo.",
      },
    },
  },
  dailyLiveCattlesDataAgro: {
    codes: {
      D_PEPR_GO_BR: "@ IR",
      D_PEPR_MG_BR: "@ MG",
      D_PEPR_MT_BR: "@ MT",
      D_PEPR_MS_BR: "@ MS",
      D_PEPR_SP_BR: "@ SP",
      D_PEPR_RO_BR: "@ RO",
      D_PEPR_TO_BR: "@ A",
      D_PEPR_PA_BR: "@ PA",
      D_PEPR_BA_BR: "@ BA",
      D_PEPR_MT_N_BR: "@ MT N",
      D_PEPR_MT_S_BR: "@ MT S",
      D_PEPR_MT_NE_BR: "@ MT NE",
      D_PEPR_MT_SE_BR: "@ MT SE",
    },
  },
  animalBirth: {
    title: "Lista de nacimientos y pérdidas reproductivas",
    buttonNew: "Nuevo Nacimiento/Pérdida",
    table: {
      columns: {
        matrizAnimalHandlingNumber: "Vaca de cría",
        birthDate: "Fecha de entrega",
        type: "Tipo",
        coverageDate: "Fecha de serv.",
        coverageType: "Tipo de servicio",
        reproductor: "Toro",
        child_handling_number: "Cría",
        child_gender: "Género",
        child_birthday_weight: "Peso al Nacer",
        child_situation: "Situación",
        child_weaning_weight: "Peso al Destete",
        child_weaning_date: "Fecha Destete",
        iep: "Intervalo Partos",
        childs: {
          handlingNumber: "Identificación",
          gender: "Género",
          birthdayWeight: "Peso al nacer",
          situation: "Conditio",
        },
      },
    },
    types: {
      parto: "Nacimiento",
      aborto: "Aborto",
      morteEmbrionaria: "Muerte embrionaria",
    },
    form: {
      titleCreateNew: "Nuevo Nacimiento/Pérdida",
      titleEdit: "Editar Nacimiento/Pérdida",
      matrizAnimalId: "Identificación",
      type: "Tipo",
      birthDate: "Fecha",
      animalReproductionCategory: "Categoría",
      femaleSituation: "Condición",
      gestationDays: "Periodo de gestación",
      coverageInfoType: "Tipo",
      coverageInfoDate: "Fecha",
      coverageInfoGestationTime: "Periodo de gestación",
      coverageInfoBirthForecast: "Pronóstico de nacimientos",
      coverageInfoReprodutor: "Toro",
      coverageInfoDGDate: "Fecha de PD",
      coverageInfoDGResult: "Resultado de PD",
      shouldDiscardFemale: "¿Descartar hembra?",
      discardMotive: "Causa",
      lotMatrizDestinationId: "Lote de producción",
      observation: "Observaciones",
      child: {
        nickname: "Nombre",
        nicknamePlaceHolder: "Nombre",
        sisbov: "NAIS",
        sisbovPlaceHolder: "NAIS",
        tagId: "Identificación electrónica de la etiqueta",
        tagIdPlaceHolder: "Identificación electrónica de la etiqueta",
        sex: "Género",
        male: "Masculino",
        female: "Hembra",
        acquisition: "Adquisición",
        handlingNumber: "Identificación",
        handlingNumberPlaceHolder: "Identificación del animal.",
        breed: "Raza",
        breedPlaceHolder: "Selecciona una raza",
        cap: "¿Animal castrado?",
        birthday: "DOB",
        birthdayWeight: "Peso al nacer",
        firstInseminationWeight: "Primera inseminación",
        weaningWeight: "Peso al destete",
        weaningDate: "Fecha de destete",
        asymptoticWeight: "Peso sigmoide",
        asymptoticWeightInfoTooltip:
          " El peso sigmoide es el peso que, con base en la información que el usuario/productor tiene sobre la historia del Animal o Lote de Animales (considerando genética, manejo previo, interacción genotipo-ambiente, marco, entre otras variables), cree que es el límite de peso potencial. Es decir, por encima de este peso, este animal difícilmente aumentará de peso en condiciones normales.",
        acquisitionDate: "Fecha de adquisición",
        acquisitionEstimatedWeight: "Peso de adquisición",
        carcassHarnessing: "Rendimiento de la canal",
        animalFarmFunction: "Propósito",
        animalReproductionCategory: "Categoría",
        sisbovIdentificationDate: "Identificar fecha",
        sisbovInsertBNDDate: "Inclusión de fecha NAIS",
        sisbovSlaughterDate: "Fecha de lanzamiento de Slaughter",
        lotId: "Lote de producción",
        farmOwner: "Dueño",
        purchaseCost: "Valor de Acq.",
        stillborn: "Nacido muerto",
      },
      newEntry: "Nueva entrada",
      editEntry: "Editar entrada",
      newChild: "Nueva Cría",
      childTab: "Cría",
      defineCoverage: "Definir Servicio",
      selectCoverageTitle: "Seleccione el servicio responsable del embarazo:",
      coverageModalDate: "Fecha",
      coverageModalReproductor: "Toro",
      coverageModalGestationDays: "Gestación (días)",
      coverageModalInputPlaceholder: "Escribir",
      childStatusNatural: "Vivo",
      childStatusStillborn: "Nac.",
      coverageDataTitle: "Datos del Servicio",
    },
    messages: {
      deleteSuccess: "¡Parto eliminado con éxito!",
      deleteError: "Error al eliminar el parto.",
      deleteErrorWithChilds:
        "Este parto no puede eliminarse porque la cría ({{childs}}) tiene registros posteriores a la fecha de creación.",
      saveSuccess: "¡Parto guardado con éxito!",
      saveErrorConflict:
        "¡Atención! Este parto no puede guardarse, hay conflictos de fechas entre los eventos reproductivos.",
      saveError: "Error al guardar el Parto, contacte al soporte.",
      selectCoverage:
        'Seleccione un servicio usando el botón "Definir Servicio".',
      inconsistentGestationDays:
        "¡Atención! El período de gestación ingresado es inconsistente, ya que abarca un período en el que la hembra ya tiene servicio(s) con resultado(s).",
      minGestationViolation:
        "¡Atención! Período de gestación inferior al tiempo mínimo ({{days}} días), definido en los parámetros de raza de la Vaca de Cría. ¡Operación cancelada!",
      maxGestationViolation:
        "¡Atención! Período de gestación superior al tiempo máximo ({{days}} días), definido en los parámetros de raza de la Vaca de Cría. ¡Operación cancelada!",
    },
  },
  animalVaccination: {
    messages: {
      animalNotFound: "¡Ningún animal encontrado!",
      saveSuccess: "Aplicación creada/actualizada con éxito.",
      saveError: "La aplicación no fue creada/actualizada. Contacte al soporte",
    },
  },
  animalReproductionState: {
    solteira: "Vaca no preñada",
    parida: "Ternado co",
  },
  animalReproductionCategory: {
    nulipara: "Nulíparas",
    novilha: "Novilla",
    primipara: "Primíparas",
    secundipara: "Secundiparo",
    multipara: "Multípara",
    reprodutor: "Bul",
  },
  femaleSituation: {
    vazia: "Vacío",
    prenha: "Embarazada",
    servida: "Servicio",
  },
  animalFarmFunction: {
    reproduction: "Reproducción",
    fatten: "Engorda",
  },
  birthTypes: {
    parto: "Nacimiento",
    aborto: "Aborto",
    morteEmbrionaria: "Muerte embrionaria",
  },
  animalStatus: {
    A: "Activo",
    Active: "Activo",
    S: "Vendido",
    Sold: "Vendido",
    D: "Muerto",
    Dead: "Muerto",
    I: "Inactivo",
    Inactive: "Inactiv",
    T: "Transferido",
    Transfer: "Transferido",
    P: "Pendente",
    Pending: "Pendente",
  },
  animalMovementEvents: {
    weight: "Pesaje",
    vacination: "Vacunación",
    coverage: "Servicio",
    pregnancyDiagnosis: "Diagnóstico del embarazo",
    birth: "Nacimiento",
    discard: "Descartar",
    lotEntry: "Entrada a la Lo",
  },
  financialClass: {
    buttonNew: "Nueva clase",
    form: {
      titleCreateNew: "Nueva clase",
      titleEdit: "Editar clase",
      financialNatureId: "Naturaleza",
      name: "Nombre",
      shouldCost: "¿Considerado para el cálculo de costos?",
      shouldDisbursement: " ¿Considerado para el desembolso?",
      depreciation: "Depreciación",
      costCenterName: "Costo Cente",
      externalIntegrationCode: "Código de Integración",
    },
  },
  financialNature: {
    buttonNew: "Nueva Naturaleza",
    form: {
      titleCreateNew: "Nueva Naturaleza Financiera",
      titleEdit: "Editar Naturaleza Financiera",
      name: "Nombre",
      type: "Tipo",
      typeIncome: "Ingreso",
      typeExpense: "Gasto",
      stock: "Inventario",
      stockTooltip:
        "Seleccione si esta naturaleza financiera está relacionada con inventario.",
      canBudget: "¿Puede Presupuestar?",
      canBudgetTooltip:
        "Seleccione si esta naturaleza financiera puede ser utilizada en presupuestos.",
      externalIntegrationCode: "Código de Integración",
      scope: "Alcance",
      scopeFarm: "Finca Actual",
      scopeGroup: "Grupo",
    },
    messages: {
      createSuccess: "Naturaleza financiera creada con éxito.",
      updateSuccess: "Naturaleza financiera actualizada con éxito.",
      error:
        "Error al crear/actualizar Naturaleza financiera. Contacte al soporte.",
      adjustResultCenterWarning:
        "Recomendamos ajustar los Centros de Resultados creados para la finca, después de guardar la naturaleza financiera.",
    },
  },
  costCenterDefaultNames: {
    PRODUCAO_ANIMAL: "Producción animal",
    UTILIDADES: "Utilidades",
    INFRAEST_PRODUTIVA: "Product Infrast.",
    INFRAEST_OPERACIONAL: "Operat. Infrast.",
    INFRAEST_APOIO: "Infraestructura de servicios.",
    TAXA_IMPOSTOS: "Tarifas e impuestos",
    SERVICOS: "Servicios",
    INVSUMOS_OPERACIONAIS: "Oper. Entradas",
    PRODUCAO_PASTO_AGRICOLA: "Cultivo/Pastura",
  },
  financialProject: {
    title: "Proyectos de Inversión",
    buttonNew: "Nuevo proyecto",
    messages: {
      deleteSuccess: "Proyecto financiero eliminado con éxito.",
      errorTitle: "Error",
      linkedError:
        "Este Proyecto Financiero no puede ser eliminado, ya está vinculado a Movimientos Financieros.",
      deleteError: "Error al eliminar el proyecto financiero.",
    },
    table: {
      columns: {
        name: "Nombre del proyecto",
        description: "Observaciones",
        startProjectDate: "Fecha de inicio",
        finishProjectDate: "Fecha final",
        status: "Statu",
      },
    },
    form: {
      titleCreateNew: "Nuevo Proyecto de Inversión",
      titleEdit: "Editar Proyecto de Inversión",
      name: "Nombre del proyecto",
      description: "Observaciones",
      startProjectDate: "Fecha de inicio",
      finishProjectDate: "Fecha final",
      status: "Activo",
    },
  },
  animalGender: {
    Female: "Hembra",
    Male: "Mal",
  },
  lotItemEntry: {
    form: {
      entryDate: "Fecha de ingreso",
      amountAnimals: "Importe",
      averageWeight: "Peso medio",
      animalFarmFunction: "Propósito",
      animalReproductionCategory: "Categoría",
      ageInDays: "Edad (días/meses/años)",
      usePrefixedIdentification: "Usar identificación con prefijo",
      prefixIdentification: " Prefijo para identificación ",
      initialIdentificationSequence: "Secuencia inicial de identificación",
      lotDestinationId: "Destino Batc",
    },
  },
  picketSupplyForecast: {
    buttonOpen: "Editar Previsión",
    title: "Editar Previsión de Suministro",
    forecastDate: "Fecha de la previsión",
    table: {
      picket: "Corral/Potrero",
      lot: "Lote",
      baseDayTotalSupplied: "Ofrecido (día base)",
      supplyNumber: "Trato",
      recipe: "Receta",
      calculatedQuantity: "Calculado",
      quantity: "A ofrecer",
      realizedTooltip: "Trato ya realizado en esta fecha",
      restoreCalculated: "Volver al valor calculado",
      empty: "Ningún corral en la previsión de esta fecha",
    },
    messages: {
      noSupply: "No hay suministro en el día anterior a la fecha elegida.",
      loadError: "Ocurrió un error al cargar la previsión. Contacte al soporte.",
      nothingToSave: "Ningún cambio para guardar.",
      saveSuccess: "Previsión guardada con éxito.",
      saveError: "Ocurrió un error al guardar la previsión. Contacte al soporte.",
    },
  },
  picketSupplementSupply: {
    title: "Entrega de piensos",
    buttonNew: "Informe de entrega de feeds",
    table: {
      columns: {
        supplyDate: "Fecha",
        picketsCount: "Potreros/Corrales",
        totalSupplementSupplied: "Cantidad entregada(kg)",
        responsibleName: "Responsable",
        subTable: {
          retreatName: "Rango Unidad/Fila",
          picketName: "Potreros/Corrales",
          lotName: "LOTE",
          totalAnimals: "Amt. Animales",
          supplementName: "Supleménte./Concent.",
          weightedAverageDryMatter: "%DM",
          totalSupplementSupplied: "Amt. Entregado",
          productionSubSystem: "Subsistema de producción",
          subTable: {
            supplyNumber: "Ejecución de entrega N°",
            supplementName: "Supleménte./Concent.",
            dryMatterPercentage: "%DM",
            quantitySupplied: "Amt. Entregado",
            responsibleName: "Responsable",
            version: "Versión",
            prevSupplyHourInMinutes: "Tiempo planificado",
            supplyHourInMinutes: "Tiempo real",
            readFeederValue: "Evaluadores de la ingesta de alimentos",
          },
        },
      },
    },
    form: {
      titleCreateNew: "Nuevo/Editar Entrega de Alimentos",
      titleEdit: "Editar Entrega",
      filtersTitle: "Filtros",
      speedersTitle: "Aceleradores",
      applyFilterHint:
        "Al hacer clic en Aplicar, los datos de la sección 'Entrega' serán sobrescritos por los potreros filtrados.",
      applyDefaultsHint:
        "Al hacer clic en Aplicar, los campos vacíos de la sección 'Entrega' serán sobrescritos por los valores elegidos en los campos contiguos.",
      supplyDate: "Fecha",
      supplyNumber: "Ejecución de entrega N°",
      responsibleName: "Responsable",
      retreats: "Rango Unidad/Fila",
      pickets: "Potreros/Corrales",
      lots: "Lotes",
      subSystems: "Subsistema de producción",
      quantitySupplied: "Amt. Entregado",
      supplement: "Supleménte./Concent.",
      hourSupplied: "Plazo de entrega",
      searchPicketOrLot: "Buscar potrero/corral o lote",
      noResults: "No se encontraron resultados.",
      current: "Actual",
      previous: "Anterior",
      applyPreviousValue: "Aplicar valor anterior",
      saveOptions: {
        only_save: "Salvar",
        save_and_create_new: "Guardar y crear nuevas entregas",
      },
      tableSupplies: {
        picketName: "Picket/Bay",
        lotName: "Lot",
        animalsCount: "Animal Qty",
        avgWeight: "Estimated Weight",
        avgGdp: "Estimated GDP",
        supplementId: "Supplement/Feed",
        dryMatterPercentage: "DM: Dry Matter",
        quantitySupplied: "Qty Supplied",
        prevSuppliedPerAnimal: "Prev. per animal/day",
        prevSuppliedDryMatterByWeight: "Prev. DM %BW",
        prevSupplyHourInMinutes: "Scheduled Time",
        supplyHourInMinutes: "Actual Time",
        observation: "Observation",
      },
    },
    dashboard: {
      picketId: "Piquetes/Bahías",
      lotId: "Lotes",
      periodType: "Período",
      startDate: "Fecha de inicio",
      endDate: "Fecha de finalización",
      exibitionType: "Visualización",
      exibitionTypeOptions: {
        column: "Columnas/Barra",
        line: "Línea",
      },
      buttonProcessDashboard: "Filtro/Gráfico de proceso",
    },
  },
  partialPayment: {
    title: " Crear pago parcial ",
    form: {
      valuePartialPayment: " Pago Parcial Amt.",
      settleDate: "Fecha de liquidación",
      expirationDate: "Nueva fecha de vencimiento",
      valuePendingPayment: "Pago Adeudado Amt.",
      fees: " Monto de Intereses/Multas",
    },
  },
  financialDashboard: {
    resultCenter: "Centro de beneficio",
    costCenter: "Centro de costos",
    costType: "Actividad",
    period: "Periodo",
    financialProject: "Proyecto Inv.",
    bankAccount: "Cuenta bancaria.",
    buttonConfirm: "Proceso",
    periods: {
      lastSevenDays: "Últimos 7 días",
      lastThirdyDays: "Últimos 30 días",
      currentMonth: "Mes actual",
      lastMonth: "El mes pasado",
      currentYear: "Año en curso",
      lastYear: "Año pasado",
      currentHarvest: "Año de cosecha actual",
      lastHarvest: "Último año de cosecha",
      customDateRange: " Especificar fecha",
    },
  },
  animalHandlingAlert: {
    title: "Alertas de Manejo",
    buttonNew: "Nueva Alerta",
    table: {
      columns: {
        status: "Estado",
        handlingNumber: "Animal",
        visualizationType: "Tipo de Visualización",
        message: "Mensaje",
      },
    },
    form: {
      titleNew: "Nueva Alerta de Manejo",
      titleEdit: "Editar Alerta de Manejo",
      animals: "Animales",
      message: "Mensaje",
      visualizationType: {
        label: "Tipo de Visualización",
        permanent: "Permanente",
        confirm: "Confirmación",
        expiration: "Expiración",
      },
      expirationDate: "Fecha de Expiración",
      notifications: {
        saveSuccess: "Alerta guardada/actualizada con éxito.",
        saveError: "Error al guardar/editar Alerta de Manejo.",
        inactivateSuccess: "Alerta inactivada con éxito!",
        inactivateError: "Error al inactivar Alerta. Contacte al soporte.",
        deleteSuccess: "Alerta eliminada con éxito!",
        deleteError: "Error al eliminar Alerta. Contacte al soporte.",
        activateSuccess: "Alerta activada con éxito!",
        activateError: "Error al activar Alerta. Contacte al soporte.",
        validationAnimals:
          "Seleccione al menos un animal para crear una alerta.",
      },
    },
  },
  reproductiveProtocol: {
    title: " Protocolos Reproductivos ",
    buttonNew: "Nuevo protocolo",
    table: {
      columns: {
        status: "Estado",
        name: "Nombre",
        duration: "Duración",
        createdAt: "Fecha de creación",
        createdBy: "Responsable de la creación",
        applicationDays: {
          orderApplication: "Orden",
          dayApplication: "¿Día?",
          product: " Producto/Hormona",
        },
      },
    },
    form: {
      titleCreateNew: "Nuevo protocolo",
      titleEdit: "Editar protocolo",
      groupFarmVisibility: "¿Quién utilizará este Protocolo?",
      name: "Nombre genérico",
      duration: "Duración del protocolo",
      newApplicationDay: "Fila",
      observations: "Observaciones",
      applicationDays: {
        orderApplication: "Orden",
        dayApplication: "¿Día?",
        product: " Producto/Hormona",
      },
    },
  },
  animalFarmReproductiveProtocol: {
    title: "Protocolos de publicación",
    buttonNew: "Ejecución de protocolos",
    table: {
      columns: {
        handlingNumber: "Hembra",
        dateApplication: "Fecha",
        reproductiveProtocolName: "Protocolo",
        reproductionPeriodDescription: "Época de cría",
        lotOriginName: "Lote de origen",
        lotDestinationName: "Destino Batc",
      },
    },
    form: {
      titleCreateNew: "Aplicar protocolo",
      titleEdit: "Editar protocolo",
      buttonApply: "Aplicar",
      applyForAnimalsGroupForm: {
        dateApplication: "D0 Fecha",
        reproductiveProtocolId: "Protocolo",
        reproductionPeriodId: "Época de cría",
        lotDestinationId: "Destino Batc",
      },
      groupTitle: "Ejecuciones",
      animalsTable: {
        handlingNumber: "Identificación",
        lotName: "LOTE",
        breedName: "Raza",
        age: "Edad",
        femaleSituation: "Condición",
        animalFarmFunction: "Propósito",
        animalReproductionState: "Condición",
        animalReproductionCategory: "Categoría",
        lastBirthDate: "Último Nacimiento Dat",
      },
      selectAllAnimals: "Seleccionar todos los animales",
      clearSelections: "Limpiar selecciones",
    },
    messages: {
      deleteSuccess: "Entrada de protocolo eliminada con éxito.",
      deleteError: "Error al eliminar la entrada de protocolo.",
      saveSuccess: "Protocolo aplicado con éxito.",
      saveErrorConflict:
        "¡Atención! Algunos animales ya tienen un protocolo registrado en la misma fecha.",
      saveError: "Error al aplicar el Protocolo",
      allAnimalsAlreadySelected:
        "Todos los animales activos de la granja ya han sido seleccionados.",
    },
  },
  currency: {
    AED: "Dírham - Emirato",
    AFN: "Afgano - Afganistán",
    ALL: "Lek - Albany",
    AMD: "Dram - Armenia",
    ANG: "Florín - Antillas Neerlandesas ",
    AOA: "Kwanza - Angola",
    ARS: "Peso - Argentina",
    AUD: "Dólar - Australia",
    AZN: "Manat - Azerbaiyán ",
    BAM: "Mark - Bosnia y Herzegovina ",
    BBD: "Dólar - Barbados",
    BDT: "Taka - Bangladesh",
    BGN: "Lev - Bulgaria",
    BHD: "Dinar - Bahrein",
    BIF: "Franco - Burundi",
    BND: "Dólar - Brunéi",
    BOB: "Bolívar - Bolivia",
    BRL: "Real - Brasil",
    BRLT: "Turista Real - Brasil",
    BSD: "Dólar - Bahamas",
    BTC: "Bitcoin (en inglés)",
    BWP: "Pula - Botsuana",
    BYN: "Rublo - Bielorrusia",
    BZD: "Dólar - Belice",
    CAD: "Dólar - Canadá",
    CHF: "Franco - Suiza",
    CHFRTS: "Franco - Suiza",
    CLP: "Peso - Chile",
    CNH: "Yuan – China en alta mar",
    CNY: "Yuan - China",
    COP: "Peso - Colombia",
    CRC: "Colón – Costa Rica",
    CUP: "Peso - Cuba",
    CVE: "Escudo – Cabo Verde",
    CZK: "Coroa - Checo ",
    DJF: "Franco - Djubouti",
    DKK: "Coroa - Dinamarca",
    DOGE: "Dogecoin",
    DOP: "Peso – Rep. Dominicana",
    DZD: "Dinar - Argelia",
    EGP: "Libra - Egipto",
    ETB: "Birr - Etiopía",
    ETH: "Ethereum",
    EUR: "Euro",
    FJD: "Dólar - Fiyi",
    GBP: "Libra esterlina – Gran Bretaña",
    GEL: "Lari - Georgia",
    GHS: "Cedi - Ghana",
    GMD: "Dalasi - Gambiam",
    GNF: "Franco - Guinea",
    GTQ: "Quetzal - Guatemalteco",
    HKD: "Dólar - Hong Kong",
    HNL: "Lempira - Honduras",
    HRK: "Kuna - Croacia",
    HTG: "Gourde - Haití",
    HUF: "Florim - Hungría",
    IDR: "Rupia - Indonesia",
    ILS: "Novo Shekel – Israel",
    INR: "Rúpia - India",
    IQD: "Dinar - Irak",
    IRR: "Rial - Irán",
    ISK: "Coroa - Islandia",
    JMD: "Dólar - Jamaic",
    JOD: "Dinar - Jordania",
    JPY: "Iene - Japón",
    JPYRTS: "Iene - Japón",
    KES: "Chelín - Kenia",
    KGS: "Som - Kirguistán ",
    KHR: "Riel, Camboya",
    KMF: "Franco - Comoras",
    KRW: "Won – Corea del Sur",
    KWD: "Dinar - Kwait",
    KYD: "Dólar - Caimán",
    KZT: "Tengue - Kazajistán",
    LAK: "Kip - Laos",
    LBP: "Libra - Libia",
    LKR: "Rúpia - Sri Lanka",
    LSL: "Loti - Lesoto",
    LTC: "Litecoin",
    LYD: "Dinar - Libia",
    MAD: "Dirham - Marruecos",
    MDL: "Leu - Moldavia",
    MGA: "Ariary - Madagascar",
    MKD: "Denar - Macedonia",
    MMK: "Kyat - Mianmar",
    MNT: "Mongol - Tugrik",
    MOP: "Pataca - Macao",
    MRO: "Ouguiya - Mauritania",
    MUR: "Rúpia - Mauricio",
    MVR: "Rufiyaa - Maldivas",
    MWK: "Kwacha - Malaui",
    MXN: "Peso - México",
    MYR: "Ringgit - Malasia",
    MZN: "Metical - Mozambique",
    NAD: "Dólar - Namib",
    NGN: "Naira - Nigeria",
    NGNI: "Naira - Nigeriaa",
    NGNPARALLEL: "Naira Nigeriana",
    NIO: "Córdoba - Nicaragua",
    NOK: "Krone - Norwich",
    NPR: "Rúpia - Nepal",
    NZD: "Dólar – Nueva Zelanda",
    OMR: "Rial - Omán",
    PAB: "Balboa - Panamá",
    PEN: "Sol - Perú",
    PGK: "Kina Papúa-Nueva Guinea",
    PHP: "Peso - Filipinas",
    PKR: "Rúpia - Pakistán",
    PLN: "Zlóti - Polonia",
    PYG: "Guaraní - Paraguay",
    QAR: "Rial - Qatar",
    RON: "Leu - Rumanía",
    RSD: "Dinar - Servia",
    RUB: "Rublo - Rusia",
    RUBTOD: "Rublo - Rusia",
    RUBTOM: "Rublo - Rusia",
    RWF: "Franco - Ruanda",
    SAR: "Riyal - Arabia",
    SCR: "Rúpias - Seichelles",
    SDG: "Libra - Sudán",
    SDR: "DSE",
    SEK: "Krown - Suecia",
    SGD: "Dólar - Singapur",
    SOS: "Chelín - Somaly",
    STD: "Dobra - San Tomé/Príncipe",
    SVC: "Colón - El Salvador",
    SYP: "Libra - Siria",
    SZL: "Lilangeni - Suazilandia",
    THB: "Baht - Tailandia",
    TJS: "Somoni - Tayikistán",
    TMT: "TMT",
    TND: "Dinar - Túnez",
    TRY: "Nova Lira - Turquía",
    TTD: "Dólar - Trinidad",
    TWD: "Dólar - Taiwán",
    TZS: "Chelín - Tanzania",
    UAH: "Hryvinia - Ucrania",
    UGX: "Chelín - Uganda",
    USD: "Dólar – Estados Unidos",
    USDT: "Dólar – Estados Unidos",
    UYU: "Peso - Uruguay",
    UZS: "Som - Uzbekistán",
    VEF: "Bolívar - Venezuela",
    VND: "Dong - Vietnam",
    VUV: "Vatu - Vanuatu",
    XAF: "Franco - CFA Central",
    XAGG: "Prata",
    XBR: "Brent al contado",
    XCD: "Dólar - Caribe Occidental ",
    XOF: "Franco CFA Este",
    XPF: "Franco CFP",
    XRP: "XRP (en inglés)",
    YER: "Riyal - Yemen",
    ZAR: "Rand – Sudáfrica",
    ZMK: "Kwacha - Zambia",
    ZWL: "Dólar - Zimbabue",
    XAU: "Gol",
  },
  importFinancialTransaction: {
    title: "Importar transacciones financieras",
    message:
      '<p class="message">Descargue <strong>template a continuación, complete las columnas de la hoja de cálculo</strong> con entradas financieras, <strong>import it</strong> y haga clic en process.</p>',
    draggerMessage:
      " Haga clic o arrastre el archivo a esta área para cargarlo.",
    importNewSupplierClientLabel: "¿Importar nuevos Proveedores/Clientes?",
  },
  importPicketSupplementSupplyAndFeedReader: {
    title: "Importar Suministro y Lectura de Comedero",
    buttonImport: "Importar Suministro/Lectura",
    message:
      '<p class="message">Descargue <strong>el template a continuación, complete la hoja de cálculo</strong> con los suministros y lecturas de comedero, <strong>impórtelo</strong> y haga clic en procesar.</p>',
    draggerMessage:
      " Haga clic o arrastre el archivo a esta área para cargarlo.",
    messages: {
      templateGenerating:
        "Su template de importación se está generando y pronto se descargará. Espere la descarga.",
      templateError:
        "Hubo un error al generar el template. Póngase en contacto con el soporte.",
      importedAndUpdated:
        "Suministros y lecturas de comedero importados y actualizados",
      importedAndUpdatedDesc:
        "Algunos suministros/lecturas de comedero fueron actualizados/insertados.",
      imported: "Suministros y lecturas de comedero importados",
      partiallyImported:
        "Suministros y lecturas de comedero importados parcialmente",
      partiallyImportedDesc:
        "Algunos suministros/lecturas de comedero no fueron importados.",
      processedWithError: "¡Archivo procesado con error!",
      processedWithErrorDesc:
        "Ninguno de los suministros/lecturas de comedero fue importado.",
      importError: "Error al importar",
      importErrorDesc: "Ningún suministro/lectura de comedero fue incluido.",
    },
  },
  confinementResultReport: {
    form: {
      title: "Resultado del corral de engorde",
      salesPeriod: "Periodo de ventas",
      clientId: "Cliente",
      supplierId: "Proveedor",
      saleScenarioId: "Escenario(s) de ventas",
      documentNumber: "Doc. N° ",
      lotIds: "Lotes",
      showDeathData: "¿Mostrar datos de defunciones en el período?",
      showOriginData: "¿Mostrar origen de los animales vendidos?",
      dailyOperationalCostMode: "Diaria Operacional",
      dailyOperationalCostModeOptions: {
        BOVEXO_COSTING: "Calculado por BovExo",
        USER_DEFINED: "Definido por el Usuario (R$/Día)",
      },
      additionalSlaughterCostValue: "Costos Adicionales de Faena",
    },
  },
  farmDayScaleTreatmentParameter: {
    title: "Lista de semen",
    buttonNewSemen: "Nuevo semen",
    table: {
      columns: {
        name: "Nombre",
        registration: "Registro",
        breedName: "Bree",
      },
    },
    form: {
      titleCreateNewSemen: "Nuevo semen",
      titleEditSemen: "Editar Semen",
      name: "Nombre",
      registration: "Registro",
      breedId: "Bree",
      genealogy: "Genealogía",
      father: "Padre",
      mother: "Madre",
      identification: "Identificación",
    },
  },
  troughFeedingAssessment: {
    title: "Evaluación de la ingesta de alimentos",
    buttonNew: "Informe de Evaluación de la Ingesta de Alimentos",
    table: {
      columns: {
        readingDate: "Fecha",
        supplyDate: "Carrera de entrega de comida",
        responsibleName: "Responsable",
        picketName: "Potreros/Corrales",
        lotName: "LOTE",
        dietStrategyName: "Estrategia de dieta",
        totalAnimals: "Amt. Animales",
        quantitySupplied: "Peso Entregado (Kg)",
        readValue: "Evaluación de admisión",
      },
    },
    form: {
      titleCreateNew: "Nuevo/Editar Evaluación de Admisión ",
      filtersTitle: "Filtros",
      speedersTitle: "Aceleradores",
      applyFilterHint:
        "Al hacer clic en Aplicar, los datos de la sección 'Evaluaciones' serán sobrescritos por los potreros filtrados.",
      applyDefaultsHint:
        "Al hacer clic en Aplicar, los campos vacíos de la sección 'Evaluaciones' serán sobrescritos por los valores elegidos en los campos contiguos.",
      readingAlreadyDone: "Evaluación de admisión ya realizada en esta fecha.",
      dietWithoutDryMatter:
        "Dieta sin MS registrada: el ajuste no se aplicará.",
      dietWithoutDryMatterOnSave:
        "Los corrales {{pickets}} tienen una dieta sin MS registrada. La lectura se guardará, pero el ajuste no se aplicará a ellos.",
      searchPicketOrLot: "Buscar potrero/corral o lote",
      noResults: "No se encontraron resultados.",
      daysUnit: "Días",
      daysConfinementUnit: "Días Conf.",
      informType: "Informe de",
      informTypeValues: {
        byDate: "Fecha",
        byPicket: "Potrero/PE",
      },
      readingType: " Formato de evaluación de admisión",
      readingTypeValues: {
        unique: "Soltero",
        perSupply: "Ru",
      },
      readingResult: " Ases de ingesta. valor",
      readingDate: " Ases de ingesta. Fecha",
      readingHour: " Ases de ingesta. Hora ",
      supplyNumber: "Tirada de entrega N°(s)",
      supplyDates: "Fecha de ejecución",
      responsibleName: "Responsable",
      retreats: "Rango Unidad/Fila",
      pickets: "Potreros/Corrales",
      lots: "Lotes",
      tableSupplyNumber: "#Run",
      amountAnimals: "#Heads",
      confinementTime: "T. Perm.",
      supplement: "Supleménte./Concent.",
      realHour: "Tiempo real",
      prevHour: "Tiempo planificado",
      prevQuantitySupplied: "Pronóstico Amt. (Kg)",
      realQuantitySupplied: "Peso entregado (kg)",
      observation: "Observaciones",
      saveOptions: {
        only_save: "Salvar",
        save_and_create_new: "Guardar y crear una nueva evaluación de admisión",
      },
    },
  },
  processTransferAnimalTransactionModal: {
    title: "Procesar Transferencia de Animales",
    form: {
      origin: "Origen",
      amountAnimals: "Cant. Cabezas",
      sellDate: "Fecha",
      animalValue: "Valor Promedio",
      totalValue: "Valor Total",
      totalInstallments: "Cant. Cuotas",
      firstInstallmentDate: "Fecha de la 1ª Cuota",
      firstInstallmentValue: "Valor de la 1ª Cuota",
      resultCenter: "Centro de Resultado",
      lotDestinationId: "Lote Destino",
      financialNatureId: "Naturaleza",
      financialClassId: "Clase",
      farmOwnerId: "Propietario",
      dividerTitle: "DATOS ADICIONALES",
      useFarmOwnersFromOrigin: "Mantener propietarios de la Granja de Origen",
    },
    messages: {
      rejectModalTitle: "Alerta",
      rejectModalContent:
        "¿Realmente desea rechazar esta transferencia? ¡Esta acción es irreversible!",
      successSubmit:
        "La transferencia ha sido confirmada con éxito y está en proceso. La transacción se completará pronto.",
      errorSubmit:
        "Se produjo un error al intentar confirmar la transferencia. Por favor contacte con soporte.",
      successReject:
        "La transferencia está siendo rechazada. La transacción será rechazada con éxito pronto.",
      errorReject:
        "Se produjo un error al intentar rechazar la transferencia. Por favor contacte con soporte.",
      errorNotSelectFarmOwnerOrCheckUseOriginalFarmOwner:
        "Debe seleccionar un Propietario o marcar la opción para mantener los propietarios de la Granja de Origen.",
      errorFarmOwnerNotCreated:
        "¡Atención! Hay propietarios (enumerados a continuación) de animales, no registrados en esta granja. Para realizar ajustes, vaya a [Administración/Granjas]",
    },
  },
  weightRanking: {
    top: "Cabecera",
    middle: "Medio",
    bottom: "Fondo",
  },
  menuNavigation: {
    menu_stock: "INVENTARIO",
    menu_diet_strategy: "ESTRATEGIA DE DIETA",
    menu_picket_supplement_supply: "SUMINISTRO",
    menu_trough_feeding_assessment: "EVALUACIÓN DE ALIMENTACIÓN EN COCHO",
    menu_weights: "PESAJES Y MEDICIONES",
    menu_veterinary: "VETERINARIO",
    menu_reproductive: "REPRODUCTIVO",
    menu_dashboard: "PANEL DE CONTROL",
    menu_purchase_scenario: "ESCENARIO DE COMPRA",
    menu_sale_scenario: "ESCENARIO DE VENTA",
    menu_purchase_scenario_boitel: "ESCENARIO DE COMPRA",
    menu_sale_scenario_boitel: "ESCENARIO DE VENTA",
    menu_nutritional: "NUTRICIONAL",
    menu_entry: "ENTRADA",
    menu_technician_veterinary: "VETERINARIO",
    menu_exit: "SALIDA",
    menu_manager: "GESTIÓN",
    menu_handling: "MANEJOS",
    menu_purchase: "COMPRA",
    menu_sale: "VENTA",
    menu_purchase_boitel: "COMPRA",
    menu_sale_boitel: "VENTA",
    menu_recreate_fatten_extensive: "R/E PASTO",
    menu_growth: "CRECIMIENTO",
    menu_confinement: "R/E CONFINAMIENTO",
    menu_boitel: "BOITEL",
    menu_commercial_boitel: "COMERCIAL",
    menu_contracts_boitel: "CONTRATOS",
    menu_contracts_boitel_confinament: "COMERCIAL",
  },
  weather: {
    title: "Datos Climáticos",
  },
  arrobaPrice: {
    title: "Datos Financieros",
    dataAgro: {
      selectDate: "Seleccione una fecha: ",
    },
    marketAnalysisDash: {
      title: "Curva de Precios",
      selectCurve: "Seleccione la curva que desea visualizar:",
      emptyMessage: "Seleccione una curva para mostrar el gráfico",
    },
  },
  alertPanel: {
    title: "alertas y pendientes",
    emptyMessage: "No se encontraron alertas en esta fecha",
  },
  viewTransferAnimalTransactionModal: {
    title: "Detalles de Transferencia de Animales",
    form: {
      origin: "Origen",
      amountAnimals: "Cant. Cabezas",
      sellDate: "Fecha",
      animalValue: "Valor Promedio",
      totalValue: "Valor Total",
      totalInstallments: "Cant. Cuotas",
      firstInstallmentDate: "Fecha de 1ra Cuota",
      firstInstallmentValue: "Valor de 1ra Cuota",
      resultCenter: "Centro de Resultado",
      lotDestinationId: "Lote de Destino",
      financialNatureId: "Naturaleza",
      financialClassId: "Clase",
      farmOwnerId: "Propietario",
      dividerTitle: "DATOS COMPLEMENTARIOS",
    },
    table: {
      columns: {
        handlingNumber: "Animal",
        dateTransferCreation: "Fecha de Registro",
        dateTransferAccept: "Fecha de Confirmación",
        weightTransfer: "Peso",
        priceTransfer: "Valor",
        lotOriginName: "Lote de Origen",
        lotDestinationName: "Lote de Destino",
        responsibleCreateTransfer: "Responsable Origen",
        responsibleAcceptTransfer: "Responsable Destino",
      },
    },
  },
  movementAnimalReportParameter: {
    title: "Dinámica de rebaño por edad",
    classification: "Clasificación",
    externalIntegrationCode: "Código de integración externa",
    messages: {
      errorLenghtEqualZero:
        "Se requiere al menos una clasificación de edad por género.",
      errorClassificationWithoutMinAge:
        "Las clasificaciones deben tener una edad mínima.",
      errorClassificationWithManyMaxAgeNull:
        "Solo se permite una clasificación sin edad máxima por género.",
      errorClassificationWithMaxAgeLessThanOrEqualToMinAge:
        "La edad máxima debe ser mayor que la edad mínima.",
      errorClassificationWithWrongOrder:
        "Las clasificaciones deben seguir un orden de edad, donde la edad mínima de una clasificación debe ser mayor que la máxima de la anterior.",
    },
  },
  movementAnimalReportModalRequest: {
    title: "Movimientos animales",
    form: {
      onlyFinalStock: "Existencia de animales actual",
      allFarmGroups: "Todas las granjas",
      datePeriod: "Período",
      breedId: "Raza",
      ownerId: "Propietario",
      supplierId: "Proveedor",
      lotIds: "Lotes",
    },
  },
  successGenerateReport: "Informe generado con éxito",
  errorGenerateReport:
    "Hubo un error al generar el informe. Por favor, contacte con soporte",
  reports: {
    tabs: {
      favorite: "Favoritos",
      animal: "Animales",
      produciton: "Producción",
      financial: "Financieros",
      management: "Gerenciales",
      operational: "Operaciones",
    },
    titles: {
      SimpleAnimalReport: "Informe Simple de Animales",
      ListAnimalReportReproduction:
        "Informe de Listado de Animales (Reproducción)",
      ListAnimalReportFatten: "Informe de Listado de Animales (Engorde)",
      AnimalWeightImportReport: "Informe de Importación de Pesajes",
      AnimalManagementObservation: "Informe de Observaciones de Manejo",
      ReportMovementAnimals: "Informe de Movimientos",
      ReportNutritionalConsumption: "Informe de Consumo de Alimento/Suplemento",
      ReportPicketFeedingAssessment: "Planilla de Suministro",
      IntensiveResultReport: "Informe de Resultados de Confinamiento",
      FarmSalesReport: "Informe de Resultados de Ventas",
      FinancialTransactionsReport: "Exportación de Movimientos Financieros",
      FinancialCashFlowReport: "Informe de Flujo de Caja",
      DisbursementReport: "Informe de Desembolsos",
      ReportAnimalWeightHistory: "Informe de Pesajes",
      ReportLotStock: "Informe de acciones por lote",
      ReportTroughReadingSheet: "Ficha de Lectura de Comedero",
      ContractsReport: "Informe de Contratos",
      ContractsSaleResultReport: "Resultado de Venta - Contratos",
    },
    messages: {
      errorUpdateFavorite:
        "Se produjo un error al actualizar/eliminar el informe de favoritos",
    },
  },
  financialCashFlowReportModalRequest: {
    title: "Informe de Flujo de Caja",
    form: {
      transactionType: "Tipo",
      periodStartDate: "Inicio",
      periodEndDate: "Fin",
      periodType: "Período",
      intervalType: "Intervalo",
      farmIds: "Finca(s)",
      financialNatureId: "Naturaleza",
      financialClassId: "Clase",
      costActivityType: "Actividad",
      showZeroValues: "¿Mostrar clases sin movimientos en el período?",
      showAnalyticalData: "¿Generar informe analítico?",
    },
    periods: {
      lastSevenDays: "Últimos 7 días",
      lastThirdyDays: "Últimos 30 días",
      currentMonth: "Mes Actual",
      lastMonth: "Mes Anterior",
      currentYear: "Año Actual",
      lastYear: "Año Anterior",
      currentHarvest: "Cosecha Actual",
      lastHarvest: "Cosecha Anterior",
      customDateRange: "Especificar Fecha (Máx. 12 meses)",
    },
    intervals: {
      daily: "Diario",
      weakly: "Semanal",
      monthly: "Mensual",
      yearly: "Anual",
    },
    messages: {
      errorPeriodMoreThanTwelveMonths:
        "El período no puede exceder los 12 meses.",
      errorNoDataFound: "No se encontraron resultados con el filtro aplicado",
    },
  },
  disbursementReportModalRequest: {
    title: "Informe de Desembolso",
    form: {
      transactionType: "Tipo",
      periodStartDate: "Inicio",
      periodEndDate: "Fin",
      periodType: "Período",
      intervalType: "Intervalo",
      farmIds: "Finca(s)",
      financialNatureId: "Naturaleza",
      financialClassId: "Clase",
      costActivityType: "Actividad",
      showZeroValues: "¿Mostrar Clases sin transacciones en el período?",
      showAnalyticalData: "¿Generar informe analítico?",
    },
    periods: {
      lastSevenDays: "Últimos 7 días",
      lastThirdyDays: "Últimos 30 días",
      currentMonth: "Mes Actual",
      lastMonth: "Mes Anterior",
      currentYear: "Año Actual",
      lastYear: "Año Anterior",
      currentHarvest: "Cosecha Actual",
      lastHarvest: "Cosecha Anterior",
      customDateRange: "Especificar Fecha (Máx. 12 meses)",
    },
    intervals: {
      daily: "Diario",
      weakly: "Semanal",
      monthly: "Mensual",
      yearly: "Anual",
    },
    messages: {
      errorPeriodMoreThanTwelveMonths:
        "El período no puede exceder los 12 meses.",
      errorNoDataFound:
        "No existen movimientos financieros y/o animales en el periodo reportado.",
    },
  },
  reportTroughReadingSheetModalRequest: {
    title: "Ficha de Lectura de Comedero",
    form: {
      date: "Fecha",
      pickets: "Retiros/Piquetes",
    },
    messages: {
      informData:
        "Ingrese los datos a continuación para generar la ficha de lectura de comedero.",
      preparingReport:
        "¡Su informe se está preparando y se descargará en breve! Por favor, no cierre esta pestaña del navegador.",
      noDataFound: "No se encontraron datos con los filtros proporcionados.",
    },
  },
  financialPaymentMethod: {
    parameter4004: "¿Utilizar método de pago?",
    title: "Método de Pago",
    buttonNew: "Nuevo Método",
    table: {
      columns: {
        name: "Método de Pago",
        code: "Código",
        status: "Estado",
      },
    },
    form: {
      groupFarmVisibility: "¿Quién utilizará el Método de Pago?",
      titleCreateNew: "Nuevo Método de Pago",
      titleEdit: "Editar Método de Pago",
      name: "Nombre",
      code: "Código",
      status: "¿Activo?",
    },
    messages: {
      successMessage: "Método de Pago guardado/actualizado con éxito.",
      errorMessage:
        "No se pudo guardar/actualizar el método de pago. Contacte con soporte.",
      activateMessage: "Método de Pago activado",
      inactivateMessage: "Método de Pago desactivado",
      deleteSuccess: "Método de Pago eliminado con éxito.",
      errorTitle: "Error",
      linkedError:
        "Este Método de Pago no puede ser eliminado, ya está vinculado a Movimientos Financieros.",
      deleteError: "Error al eliminar el método de pago.",
    },
  },
  financialIssue: {
    parameter4003: "¿Utilizar pendientes financieros?",
    title: "Pendiente Financiero",
    buttonNew: "Nuevo Pendiente",
    table: {
      columns: {
        name: "Pendiente Financiero",
        code: "Código",
        status: "Estado",
      },
    },
    form: {
      groupFarmVisibility: "¿Quién utilizará el Pendiente Financiero?",
      titleCreateNew: "Nuevo Pendiente Financiero",
      titleEdit: "Editar Pendiente Financiero",
      name: "Nombre",
      code: "Código",
      status: "¿Activo?",
    },
    messages: {
      successMessage: "Pendiente Financiero guardado/actualizado con éxito.",
      errorMessage:
        "No se pudo guardar/actualizar el pendiente financiero. Contacte con soporte.",
      activateMessage: "Pendiente Financiero activado",
      inactivateMessage: "Pendiente Financiero desactivado",
      deleteSuccess: "Pendiente Financiero eliminado con éxito.",
      errorTitle: "Error",
      linkedError:
        "Este Pendiente Financiero no puede ser eliminado, ya está vinculado a Movimientos Financieros.",
      deleteError: "Error al eliminar el pendiente financiero.",
    },
  },
  financialTaxableDeductible: {
    parameter4005: "¿Utilizar tributable y deducible IR?",
    title: "Tributable y Deducible",
    buttonNew: "Nuevo Tributable y Deducible",
    table: {
      columns: {
        name: "Tributable y Deducible",
        code: "Código",
        status: "Estado",
      },
    },
    form: {
      groupFarmVisibility: "¿Quién utilizará Tributable y Deducible?",
      titleCreateNew: "Nuevo Tributable y Deducible",
      titleEdit: "Editar Tributable y Deducible",
      name: "Nombre",
      code: "Código",
      status: "¿Activo?",
    },
    messages: {
      successMessage: "Tributable y deducible guardado/actualizado con éxito.",
      errorMessage:
        "No se pudo guardar/actualizar el tributable y deducible. Contacte con soporte.",
      activateMessage: "Tributable y deducible activado",
      inactivateMessage: "Tributable y deducible desactivado",
      deleteSuccess: "Tributable y deducible eliminado con éxito.",
      errorTitle: "Error",
      linkedError:
        "Este Tributable y Deducible no puede ser eliminado, ya está vinculado a Movimientos Financieros.",
      deleteError: "Error al eliminar el tributable y deducible.",
    },
  },
  radiogroup: {
    farm: "Solo esta finca",
    group: "Fincas del grupo",
  },
  importAnimalCoverage: {
    title: "Importar Coberturas e DG's",
    message:
      '<p class="message">Descargue la <strong>plantilla a continuación, complete la hoja de cálculo</strong> con las coberturas e/ou DGs, <strong>impórtela</strong> y luego haga clic en procesar.</p>',
    draggerMessage: "Haga clic o arrastre el archivo a esta área para subirlo",
  },
  bankAccountFarm: {
    parameter4006: "¿Utilizar cuenta bancaria?",
    title: "Cuenta Bancaria",
    buttonNew: "Nueva Forma",
    table: {
      columns: {
        description: "Nombre",
        bankName: "Banco",
        bankCode: "Código del Banco",
        bankAccountNumber: "Número de Cuenta",
        bankAgencyNumber: "Número de Agencia",
        initialBalanceDate: "Fecha de Saldo Inicial",
        initialBalance: "Saldo Inicial",
        status: "Estado",
      },
    },
    form: {
      groupFarmVisibility: "¿Quién utilizará la cuenta bancaria?",
      titleCreateNew: "Nueva Cuenta Bancaria",
      titleEdit: "Editar Cuenta Bancaria",
      description: "Nombre",
      bankId: "Banco",
      bankAccountNumber: "Número de Cuenta",
      bankAgencyNumber: "Número de Agencia",
      initialBalanceDate: "Fecha de Saldo Inicial",
      initialBalance: "Saldo Inicial",
      status: "¿Activo?",
      type: "Tipo de Cuenta",
      types: {
        PESSOA_FISICA: "Persona Física",
        PESSOA_JURIDICA: "Persona Jurídica",
      },
    },
    messages: {
      successMessage: "Cuenta bancaria guardada/actualizada con éxito.",
      errorMessage:
        "No se pudo guardar/actualizar la cuenta bancaria. Contacte al soporte.",
      activateMessage: "Cuenta bancaria activada",
      inactivateMessage: "Cuenta bancaria desactivada",
    },
  },
  bankConciliation: {
    tabs: {
      bankConciliation: "Conciliación",
      bankStatement: "Extracto",
    },
  },
  statement: {
    title: "Extractos",
    buttonNew: "Importar Extracto",
    table: {
      columns: {
        bankCode: "Código del Banco",
        bankName: "Banco",
        bankAccountNumber: "Número de Cuenta",
        bankAgencyNumber: "Número de Agencia",
        fileName: "Nombre del Archivo",
        startTransactionsDate: "Fecha de Inicio",
        endTransactionsDate: "Fecha de Fin",
        transactionDate: "Fecha",
        type: "Tipo",
        name: "Descripción",
        amount: "Valor",
        accountFarmDescription: "Cuenta Bancaria",
        status: "Estado",
      },
    },
    form: {
      steps: {
        step1: "Carga",
        step2: "Revisión",
        step3: "Importar BovExo",
      },
      bankCode: "Código del Banco",
      bankName: "Banco",
      bankAccountNumber: "Número de Cuenta",
      bankAgencyNumber: "Número de Agencia",
      fileName: "Nombre del Archivo",
      startTransactionsDate: "Fecha de Inicio",
      endTransactionsDate: "Fecha de Fin",
      transactionDate: "Fecha",
      type: "Tipo",
      name: "Descripción",
      amount: "Valor",
      accountFarmDescription: "Cuenta Bancaria",
      status: "Estado",
      period: "Período",
      transactions: "Transacciones",
    },
    types: {
      DEBIT: "Débito",
      CREDIT: "Crédito",
      XFER: "Transferencia",
      CHECK: "Cheque",
      PAYMENT: "Pago",
      CASH: "Efectivo",
      DIRECTDEP: "Depósito Directo",
      DIRECTDEBIT: "Débito Directo",
      HOLD: "Pendiente",
      OTHER: "Otro",
      DEP: "Depósito",
    },
    messages: {
      reviewMessage:
        "Revise los datos del extracto importado y seleccione los movimientos que serán posteriormente conciliados.",
      successMessage: "Cuenta bancaria guardada/actualizada con éxito.",
      errorMessage:
        "No se pudo guardar/actualizar la cuenta bancaria. Contacte al soporte.",
      activateMessage: "Cuenta bancaria activada",
      inactivateMessage: "Cuenta bancaria desactivada",
    },
  },
  conciliation: {
    form: {
      statementTransactionType: "Tipo",
      statementTransactionBankAccountFarmName: "Fuente de pago",
      statementTransactionDate: "Fecha",
      statementTransactionAmount: "Monto",
      statementTransactionDescription: "Descripción",
    },
    table: {
      columns: {
        statementTransactionType: "Tipo",
        statementTransactionBankAccountFarmName: "Fuente de pago",
        statementTransactionDate: "Fecha",
        statementTransactionAmount: "Monto",
        statementTransactionDescription: "Descripción",
        expirationDate: "Fecha",
        billingDate: "Fecha",
        value: "Monto",
        documentNumber: "Número de Documento",
        installmentNumber: "Cuota",
        transactionType: "Tipo",
        supplierClientName: "Proveedor/Cliente",
        paymentMethodName: "M. Pago",
        bankAccountFarmName: "Fuente de pago",
      },
    },
    transactionTypes: {
      income: "Ingreso",
      expense: "Gasto",
    },
    selectFinancialInstallmentsModal: {
      statementTransactionType: "Tipo",
      statementTransactionBankAccountFarmName: "Fuente de pago",
      statementTransactionDate: "Fecha",
      statementTransactionAmount: "Monto",
      statementTransactionDescription: "Descripción",
      selectedRows: "Seleccionados",
      selectedRowsSum: "Total Seleccionados",
      differenceLabel: "Diferencia",
    },
    messages: {
      successConciliation: "Conciliación realizada con éxito",
      errorConciliation: "Error al conciliar. Contacte con el soporte",
      errorNoTransactionsSelectedMessage: "No se seleccionaron transacciones",
      errorNoTransactionsSelectedDescription:
        "Por favor, seleccione al menos una transacción para conciliar.",
      errorSelectedStatementsWithoutTransactionsSelected:
        "Hay transacciones sin movimientos financieros seleccionados",
      errorTransactionsWithWrongSumValueMessage:
        "Valores inválidos en los movimientos financieros",
      errorTransactionsWithWrongSumValueDescription:
        "Todos los valores de los movimientos financieros deben estar completados y la suma debe ser igual al monto de la transacción.",
      errorWrongSumValuesMessageOnSelectInstallmentModal: "Error",
      errorWrongSumValuesDescriptionOnSelectInstallmentModal:
        "La suma de los valores seleccionados es diferente al monto del extracto.",
      successRemoveConciliation:
        "Se ha eliminado la conciliación bancaria de este registro",
      errorRemoveConciliation:
        "No se pudo eliminar la conciliación bancaria de este registro. Contacte con el soporte",
      successAddNewConciliation: "Se ha añadido un registro para conciliación",
      errorAddNewConciliation:
        "No se pudo añadir un registro para conciliación. Contacte con el soporte",
    },
  },
  contractsReportModal: {
    title: "Informe de Contratos",
    form: {
      cattleProducerId: "Productor Ganadero",
      contractDate: "Fecha del Contrato",
      identificationContract: "Identificación del Contrato",
      identificationContractPlaceholder:
        "Ingrese la identificación del contrato",
      cattleProducerRequired: "El Productor Ganadero es obligatorio",
    },
    messages: {
      errorNoDataFound:
        "No se encontró ningún resultado con el filtro proporcionado",
      checkVigente:
        "Confirme si los contratos del filtro tienen el estado VIGENTE",
      checkActiveLot:
        "Confirme si todos los animales seleccionados en los contratos tienen un Lote con estado Activo",
    },
  },
  contractsSaleResultReportModal: {
    title: "Informe: Resultado de Venta - Contratos",
    form: {
      salesPeriod: "Período de Ventas",
      contractType: "Tipo de Contrato",
      contractTypeOptions: {
        ARROBA_PRODUCTION: "Sociedad (@ Producida)",
      },
      cattleProducerId: "Socio",
      dailyOperationalCostMode: "Diaria Operacional",
      dailyOperationalCostModeOptions: {
        BOVEXO_COSTING: "Calculado por BovExo",
        USER_DEFINED: "Definido por el Usuario (R$/Día)",
      },
      additionalSlaughterCostValue: "Costos Adicionales de Faena",
      splitByOriginLot: "Separar por Lote de Origen",
    },
    messages: {
      errorNoDataFound:
        "No se encontró ningún resultado con el filtro proporcionado",
    },
  },
  exportReportLotStockModal: {
    title: "Informe de Stock por Lote",
    form: {
      breedIds: "Razas",
      lotIds: "Lotes",
      supplierIds: "Proveedores",
      farmOwnerIds: "Propietarios",
    },
    messages: {
      errorNoDataFound:
        "No se encontró ningún resultado con el filtro proporcionado",
    },
  },
  farmReadFeederTreatmentParameter: {
    form: {
      freeScale: "Escala de Lectura del Comedero",
      freeScaleOption: {
        default: "Predeterminada",
        free: "Libre",
      },
      readFrequency: "Frecuencia de Lectura del Comedero",
      readFrequencyOption: {
        readOnceADay: "Una vez al día",
        readAtEveryTreat: "En cada alimentación",
        readInTreat: "Durante las alimentaciones",
      },
      applicationType: "Ajuste de Cantidad debe aplicarse a",
      applicationTypeOption: {
        apply_equal_for_all_treats: "Uniforme en todas las alimentaciones",
        concentrated_on_last_treat: "Concentrada en la última alimentación",
      },
      adjustmentType: "Cálculo de la Lectura del Comedero",
      adjustmentTypeOption: {
        percent_original_matter: "% MO (Materia Original)",
        percent_dry_matter: "% MS (Materia Seca)",
        kg_dry_matter: "kg MS (Materia Seca)",
      },
    },
    messages: {
      confirmAdjustmentTypeChange:
        "Al cambiar el cálculo de la lectura del comedero, los valores de la escala se borrarán y deberán informarse nuevamente. ¿Desea continuar?",
      percentAboveLimit:
        'El valor del porcentaje de la escala "{{scale}}" superó el 25%, ¿desea confirmar?',
      successSave: "¡Parámetros de Lectura del Comedero guardados con éxito!",
      errorSave: "Error al guardar los Parámetros de Lectura del Comedero",
    },
  },
  areaMap: {
    title: "Mapa de Áreas",
    newArea: "Nueva Área",
    clearAllAreas: "Limpiar Todas las Áreas",
    totalAreas: "Total",
    form: {
      title: "Nueva Área",
      editTitle: "Editar Área",
      identificationCode: "Código de Identificación",
      identificationCodePlaceholder: "Ingrese el código de identificación",
      type: "Tipo",
      typePlaceholder: "Seleccione el tipo",
      picketSelection: "Selección de Piquete",
      picketPlaceholder: "Seleccione un piquete",
      retreatSelection: "Selección de Retiro",
      retreatPlaceholder: "Seleccione un retiro",
      observation: "Observación",
      observationPlaceholder: "Ingrese una observación sobre el área",
      color: "Color de marcación del mapa",
      colorPlaceholder: "Seleccione un color",
      area: "Área en hectáreas",
      areaPlaceholder: "0.00",
      areaDescription:
        "Área calculada automáticamente a partir del polígono dibujado",
      save: "Guardar",
      update: "Actualizar",
      cancel: "Cancelar",
    },
    colors: {
      red: "Rojo",
      green: "Verde",
      blue: "Azul",
      yellow: "Amarillo",
      magenta: "Magenta",
      cyan: "Cian",
      orange: "Naranja",
      purple: "Púrpura",
      darkGreen: "Verde Oscuro",
      darkBlue: "Azul Oscuro",
      brown: "Marrón",
      pink: "Rosa",
    },
    types: {
      AGRICULTURA: "Agricultura",
      BENFEITORIAS: "Mejoras",
      CONFINAMENTO: "Confinamiento",
      INTEGRACAO_LAVOURA_PECUARIA: "Integración Cultivo-Ganado",
      INTEGRACAO_LAVOURA_PECUARIA_FLORESTA: "Integración Cultivo-Ganado-Bosque",
      INTEGRACAO_LAVOURA_FLORESTA: "Integración Cultivo-Bosque",
      PASTAGEM: "Pastura",
      RESERVA: "Reserva",
      SILVICULTURA: "Silvicultura",
    },
    messages: {
      mapLoadError: "Error al cargar el mapa",
      mapLoadErrorDescription:
        "Verifique si la clave de la API de Google Maps está configurada correctamente.",
      areasLoadError: "Error al cargar áreas",
      areasLoadErrorDescription:
        "No se pudieron cargar las áreas existentes del mapa.",
      polygonRequired: "Polígono requerido",
      polygonRequiredDescription:
        "Dibuje un polígono en el mapa antes de guardar.",
      drawingHint: "Modo de dibujo activo",
      drawingHintDescription:
        "Haz clic en el mapa para agregar vértices. Para finalizar, haz doble clic o usa el botón de abajo (mínimo 3 vértices).",
      drawingVerticesLabel: "Vértices",
      drawingFinishButton: "Finalizar polígono",
      areaSaved: "Área guardada exitosamente",
      areaSavedDescription: "El área de {area} hectáreas ha sido guardada.",
      areaUpdated: "Área actualizada exitosamente",
      areaUpdatedDescription:
        "El área de {area} hectáreas ha sido actualizada.",
      areaSaveError: "Error al guardar área",
      areaSaveErrorDescription:
        "No se pudo guardar la área. Contate al soporte.",
      picketAlreadySelected:
        "El Piquete o Retiro seleccionado ya fue seleccionado en otra área",
      areaDeleteError: "Error al eliminar área",
      areaDeleteErrorDescription:
        "No se pudo eliminar la área. Contate al soporte.",
      loadingAreas: "Cargando áreas...",
      areaDeleted: "Área eliminada exitosamente",
    },
    validation: {
      colorRequired: "El color es obligatorio",
      areaRequired: "El área es obligatoria",
      areaMin: "El área debe ser mayor que 0",
    },
    centerCard: {
      infoMessage:
        "Para centrar el mapa correctamente, configure los datos de ubicación de su propiedad.",
      configureLocation: "Configurar Ubicación",
      formTitle: "Configurar Centrado del Mapa",
      savedLocation: "Ubicación Configurada",
      coordinates: "Coordenadas",
      edit: "Editar",
      savedAt: "Guardado en",
      form: {
        locationType: "Tipo de Ubicación",
        coordinates: "Coordenadas (Lat/Lng)",
        address: "Dirección",
        addressPlaceholder: "Ingrese la dirección de la propiedad",
        latitude: "Latitud",
        latitudePlaceholder: "Ej: -15.7801",
        longitude: "Longitud",
        longitudePlaceholder: "Ej: -47.9292",
        description: "Descripción (opcional)",
        descriptionPlaceholder: "Ej: Sede de la finca, Portón principal",
        save: "Guardar",
        cancel: "Cancelar",
        loadingPlaces: "Cargando servicio de direcciones...",
        geocoding: "Obteniendo coordenadas...",
      },
      validation: {
        locationTypeRequired: "El tipo de ubicación es obligatorio",
        addressRequired: "La dirección es obligatoria",
        latitudeRequired: "La latitud es obligatoria",
        longitudeRequired: "La longitud es obligatoria",
        latitudeMin: "La latitud debe ser mayor que -90",
        latitudeMax: "La latitud debe ser menor que 90",
        longitudeMin: "La longitud debe ser mayor que -180",
        longitudeMax: "La longitud debe ser menor que 180",
      },
      messages: {
        saved: "Ubicación guardada exitosamente",
        savedDescription: "El mapa se centrará en la ubicación configurada.",
        saveError: "Error al guardar ubicación",
        saveErrorDescription:
          "No se pudo guardar la ubicación. Intente nuevamente.",
        placesApiError: "Error al cargar Google Places",
        placesApiErrorDescription:
          "No se pudo cargar el servicio de autocompletar direcciones.",
        geocodingWarning: "Advertencia de Geocodificación",
        geocodingWarningDescription:
          "No se pudieron obtener las coordenadas de la dirección. Verifique que la dirección sea correcta.",
      },
    },
    modal: {
      title: "Información del Área",
      identificationCode: "Código de Identificación",
      type: "Tipo",
      picketName: "Nombre del Piquete",
      retreatName: "Nombre del Retiro",
      areaSquareMeters: "Área (m²)",
      areaHectares: "Área (hectáreas)",
      observation: "Observación",
      deleteButton: "Eliminar Área",
      deleteConfirmTitle: "Confirmar Eliminación",
      deleteConfirmMessage:
        "¿Está seguro de que desea eliminar esta área? Esta acción no se puede deshacer.",
      deleteConfirmOk: "Sí, eliminar",
      deleteConfirmCancel: "Cancelar",
      tabs: {
        details: "Detalles del Área",
        production: "Producción",
        history: "Historial",
        observations: "Observaciones",
      },
      details: {
        status: "Estado",
        picketProductionSubSystem: "Actividad",
        identificationCode: "Código de Identificación",
        type: "Tipo",
        picketName: "Nombre Piquete/Corral",
        areaSquareMeters: "Área (m²)",
        areaHectares: "Área (hectáreas)",
        picketPastureName: "Forraje",
        areaObservations: "Observaciones del Área",
      },
      production: {
        stockingRate: "Tasa de Carga",
        animalInfo: "Información de Animales",
        activeAnimals: "ANIMALES ACTIVOS",
        dataReference: "Datos referentes a",
        averageWeight: "Peso promedio",
        averageWeightProjected: "Peso projetado atual",
        averageGdp: "GDP promedio",
        averageAge: "Edad promedio",
        months: "Meses",
        kg: "kg",
      },
      history: {
        title: "Historial de Lotes",
        recentLot: "Historial de Lotes - Lote más reciente",
        lotName: "Nombre del Lote",
        entryDate: "Entrada",
        exitDate: "Salida",
        totalDays: "Total de días",
        viewAll: "Ver todo",
      },
      observations: {
        title: "Observaciones del Piquete",
        timeline: "Línea de Tiempo",
      },
      status: {
        A: "Activo",
        B: "Descanso",
        P: "Pastoreo",
        R: "Renovación",
        M: "Mantenimiento",
        L: "Arrendado",
        D: "Eliminado",
        X: "Excluido de la Finca",
        I: "Inactivo",
        Break: "Descansando",
        Pasturage: "Pastoreo",
        Renovation: "Renovación",
        Maintenance: "Mantenimiento",
        Leased: "Arrendado",
        Deleted: "Borrado",
        Active: "Activo",
        Inactive: "Inactiv",
      },
      picketProductionSubSystem: {
        extensive: "Extensivo",
        semiIntensive: "Semi-Intensivo",
        intensive: "Intensivo",
      },
    },
  },
  excelExport: {
    buttonText: "Exportar",
    modalTitle: "Exportar a Excel",
    fields: {
      exportName: "Nombre del Informe",
      columns: "Columnas",
      filters: "Filtros",
    },
    placeholders: {
      exportName: "Ingrese el nombre del informe",
      inOperator: "Separado por comas",
    },
    operators: {
      EQ: "Igual",
      NEQ: "Diferente",
      GT: "Mayor que",
      LT: "Menor que",
      GTE: "Mayor o igual",
      LTE: "Menor o igual",
      LIKE: "Contiene",
      IN: "En",
      BETWEEN: "Entre",
    },
    buttons: {
      export: "Exportar",
      selectAllColumns: "Seleccionar todas",
      deselectAllColumns: "Deseleccionar todas",
    },
    validation: {
      exportNameRequired: "El nombre del informe es obligatorio",
    },
    successMessage: "¡Archivo exportado con éxito!",
    errorMessage: "Error al exportar archivo. Inténtelo de nuevo.",
  },
  importAnimalBirth: {
    title: "Importación de Partos y Perdidas Reproductivas",
    message:
      "Importe el archivo de partos y perdidas reproductivas para el sistema.",
    draggerMessage: "Haga clic o arrastre el archivo a esta área para subirlo",
  },
  stockItem: {
    pageTitle: "Inventario de Insumos",
    tabs: {
      stockItems: "Artículos de Inventario",
      materialMovements: "Movimientos",
      pendencies: "Pendencias",
      audit: "Auditoría",
      parameters: "Parámetros",
    },
    summaryCards: {
      stockValue: "Valor del Inventario",
      totalQty: "Cantidad Total",
      items: "Artículos",
      belowReplenishment: "Bajo Reposición",
    },
    table: {
      internalId: "Identificación",
      abbreviation: "Abrev",
      group: "Grupo",
      subgroup: "Subgrupo",
      currentQty: "Cant. Actual",
      unit: "Unidad",
      replenishmentPoint: "Pto. Repos.",
      currentCost: "Costo Actual",
      value: "Valor",
      actions: "Acciones",
    },
    searchPlaceholder: "Buscar por ID, abreviación o descripción...",
    toggleInactive: "Inactivos",
    toggleActive: "Activos",
    newItem: "Nuevo Artículo",
    drawerLabels: {
      internalId: "Identificación",
      abbreviation: "Abreviación",
      description: "Descripción",
      group: "Grupo",
      subgroup: "Subgrupo",
      unit: "Unidad",
      currentQty: "Cant. Actual",
      replenishmentPoint: "Punto de Reposición",
      currentCost: "Costo Actual",
      lastPurchaseCost: "Costo Últ. Compra",
      lastPurchaseDate: "Fecha Últ. Compra",
      lastSupplier: "Últ. Proveedor",
      notes: "Notas",
      variantControl: "Ctrl Variante",
      batchControl: "Ctrl Lote",
      variantsAndBatches: "Variantes y Lotes",
      variants: "Variantes",
      batches: "Lotes",
      dietItem: "Artículo de Dieta",
      supplementSupplierId: "Fornecedor",
      supplementGroup: "Grupo do Suplemento",
      supplementSubGroup: "Subgrupo do Suplemento",
      supplementPresentation: "Apresentação",
      nutritionalDetails: "DADOS NUTRICIONAIS",
      cost: "Custo",
      dryMatterPercentage: "DM: Materia seca",
      ndt: "NDT: Nutrientes Digest. Totais",
      pb: "PB: Proteína Bruta",
      ee: "Extrato Etéreo",
      fdn: "FDN",
      fda: "FDA",
      ca: "Cálcio",
      p: "Fósforo",
      k: "Potássio",
      s: "Enxofre",
      na: "Sódio",
      zinc: "Zinco",
      manufacturer: "Fabricante",
      veterinarySupplement: "Artículo Veterinario",
      type: "Tipo",
      name: "Marca",
      supplierId: "Proveedor",
      applicationGender: "Género",
      applicationType: "Vía de administración",
      applicationValue: "Administración amt.",
      applicationWeightValueParam: "Peso",
      unitId: "Unidad utilizada",
      applicationCost: "Costo de administración",
      originalSupplement: "Matéria Prima/Suplemento Original",
    },
    journal: {
      tabs: { details: "Detalles", movements: "Movimientos" },
      searchPlaceholder: "Buscar por factura o solicitante...",
      filter: {
        type: "Tipo",
        origin: "Origen",
        startDate: "Fecha inicial",
        endDate: "Fecha final",
        clear: "Limpiar filtros",
      },
      sort: {
        label: "Ordenar por",
        movementDate: "Fecha del movimiento",
        createdAt: "Fecha de registro",
        amount: "Cantidad",
        unitCost: "Costo unitario",
        cost: "Costo total",
        ascending: "Orden ascendente",
        descending: "Orden descendente",
      },
      card: {
        amount: "Cantidad",
        unitCost: "Costo Unit.",
        cost: "Costo Total",
        cmpResult: "Costo Medio (CMP)",
        amountBalance: "Saldo Cant.",
        costBalance: "Saldo Costo",
        invoice: "Factura",
        requester: "Solicitante",
        createdAt: "Registrado el",
      },
      viewInvoice: "Ver Factura",
      total: "{count} movimiento(s)",
      empty: "No se encontraron movimientos.",
      loadError: "Error al cargar los movimientos del ítem.",
    },
    form: {
      internalId: "Identificación",
      abbreviation: "Abreviación",
      description: "Descripción",
      group: "Grupo",
      subgroup: "Subgrupo",
      measurementUnit: "Unidad de Medida",
      replenishmentPoint: "Punto de Reposición",
      currentCost: "Costo Actual ($)",
      variantControl: "Control de Variante",
      batchControl: "Control de Lote",
      notes: "Notas Complementarias",
      dietItem: "Artículo de Dieta",
      product: "Producto",
      supplementSupplierId: "Fornecedor do Suplemento",
      supplementGroup: "Grupo del Suplemento",
      supplementSubGroup: "Subgrupo del Suplemento",
      supplementPresentation: "Presentación",
      nutritionalDetails: "DATOS NUTRICIONALES",
      supplementTypeNew: "Nuevo",
      supplementTypeExisting: "Ya existente",
      veterinarySupplement: "Artículo Veterinario",
      veterinaryDetails: "DATOS DEL SUPLEMENTO VETERINARIO",
      veterinarySupplementTypeNew: "Nuevo",
      veterinarySupplementTypeExisting: "Ya existente",
      veterinarySupplementId: "Artículo Veterinario",
      type: "Tipo",
      name: "Marca",
      supplierId: "Proveedor",
      applicationGender: "Género",
      applicationType: "Vía de administración",
      applicationValue: "Administración amt.",
      applicationWeightValueParam: "Peso",
      unitId: "Unidad utilizada",
      applicationCost: "Costo de administración",
      cost: "Custo",
      dryMatterPercentage: "DM: Materia seca",
      ndt: "TDN: Nutrientes Digestibles Totales",
      pb: "CP: Proteína bruta",
      ee: "Extracto etéreo",
      fdn: "FDN",
      fda: "ADF",
      ca: "Calcio",
      p: "Fósforo",
      k: "Potasio",
      s: "Azufre",
      na: "Sodio",
    },
    auditWarning:
      "Los campos marcados con ⚡ requieren la aprobación de otro usuario para entrar en vigor.",
    pendingAuditAlert:
      "Artículo bloqueado — Existen cambios pendientes de aprobación en auditoría.",
    confirmInactivate: '¿Está seguro de que desea inactivar "{description}"?',
    confirmReactivate: '¿Está seguro de que desea reactivar "{description}"?',
    confirmDelete:
      '¿Está seguro de que desea eliminar "{description}"? Esta acción no se puede deshacer.',
    saveOptions: {
      savedSuccess: "¡Artículo guardado con éxito!",
      deletedSuccess: "Artículo eliminado con éxito.",
      inactivatedSuccess: "Artículo inactivado.",
      reactivatedSuccess: "Artículo reactivado.",
    },
    error: {
      loadError: "Error al cargar artículos de inventario.",
      saveError: "Error al guardar artículo.",
      deleteError: "Error al eliminar artículo.",
    },
    movements: {
      summary: { entries: "Entradas", exits: "Salidas", pending: "Pendientes" },
      searchPlaceholder: "Buscar por artículo, ID o factura...",
      filter: {
        all: "Todos",
        entries: "Entradas",
        exits: "Salidas",
        inactive: "Inactivados",
      },
      buttons: { newEntry: "Entrada", newExit: "Salida" },
      table: {
        id: "ID",
        type: "Tipo",
        origin: "Origen",
        item: "Artículo",
        batch: "Lote",
        quantity: "Cantidad",
        unitCost: "Costo Unit.",
        measurementUnit: "Unidad de Medida",
        nf: "Factura",
        status: "Estado",
        date: "Fecha",
        user: "Usuario",
        actions: "Acciones",
        totalCost: "Costo Total",
        createdAt: "Creado en",
      },
      type: { entry: "Entrada", exit: "Salida" },
      status: {
        pending: "Pendiente",
        completed: "Realizado",
        audit: "Auditoría",
        inactive: "Inactivo",
        processing: "Procesando",
        error: "Erro",
      },
      entryOrigins: {
        purchase: "Compra",
        adjustment: "Ajuste",
        transfer: "Transferencia",
        return: "Devolución",
        production: "Producción",
      },
      exitOrigins: {
        sale: "Venta",
        withdrawal: "Retiro",
        loss: "Pérdida",
        adjustment: "Ajuste",
        transfer: "Transferencia",
        productionConsumption: "Consumo Produção",
      },
      form: {
        title: { entry: "Entrada de Material", exit: "Salida de Material" },
        origin: "Origen",
        documentType: "Tipo Documento",
        nfReference: "Nº Documento",
        documentTypes: {
          invoice: "Factura",
          simpleRemittance: "SR (Remito Simple)",
          internalDoc: "Doc. Interno",
        },
        nfDate: "Fecha Emisión",
        issueDate: "Fecha Emisión",
        productionDate: "Fecha de Producción",
        receiptDate: "Fecha Recepción",
        supplier: "Proveedor",
        cpfCnpj: "CPF/CNPJ",
        requester: "Solicitante",
        materials: "Materiales",
        addItem: "Agregar Artículo",
        totalCost: "Costo Total de los Artículos",
        stockItem: "Artículo de Inventario",
        variant: "Variante",
        newVariant: "+ Crear nueva variante",
        batch: "Lote",
        newBatch: "+ Crear nuevo lote",
        manufacturer: "Fabricante",
        batchNumber: "Número do Lote",
        serialNumber: "Número de Série",
        specification: "Especificación",
        measurementUnit: "Unidad de Medida",
        quantity: "Cantidad",
        unitCost: "Costo Unitario",
        expiration: "Expiración",
        expirationMode: { date: "Fecha", days: "Días" },
        locations: "Ubicaciones",
        location: {
          warehouse: "Almacén",
          shelf: "Estante",
          rack: "Estantería",
          drawer: "Gaveta",
          deposit: "Depósito",
          tank: "Tanque",
        },
        conversion: {
          title: "Conversión de Unidad (Factura → Inventario)",
          nfQty: "Cant. Factura",
          nfUnit: "Unid. Factura",
          factor: "Factor",
          nfUnitCost: "Costo Unit. Factura",
          stockUnit: "Unid. Inventario",
        },
        observations: "Observaciones",
        loadXml: "Cargar XML",
        loadPdf: "Cargar PDF",
        view: "Visualizar",
        pendingHint:
          'Si la factura aún no fue registrada en el módulo Financiero, el movimiento quedará con estado "Pendiente".',
        auditHint:
          "Este movimiento creará una pendencia para aprobación por otro usuario.",
        financialTransaction: {
          title: "Gasto Financiero Vinculado",
          mainValueHelp:
            "Valor calculado automáticamente con base en el costo total de los artículos de este movimiento (cantidad x costo unitario).",
        },
      },
      detail: {
        title: "Detalles del Movimiento",
        generalInfo: "Información General",
        itemInfo: "Artículo",
        observations: "Observaciones",
        viewNfe: "Ver Factura",
        delete: "Eliminar",
        blocked:
          "Movimiento bloqueado — Existe una solicitud de eliminación pendiente de auditoría.",
      },
      deleteConfirm: {
        title: "Solicitar Eliminación de Movimiento",
        description:
          "Se creará un registro de auditoría y la eliminación deberá ser aprobada por un segundo usuario. Mientras esté pendiente, este movimiento y los artículos relacionados quedarán bloqueados.",
        confirm: "Confirmar Eliminación",
      },
      duplicateNf: {
        title: "Factura ya registrada",
        cancel: "Cancelar movimiento",
        continue: "Continuar de todos modos",
      },
      saveOptions: {
        savedSuccess: "¡Movimiento(s) guardado(s) con éxito!",
        deleteRequested: "Solicitud de eliminación enviada para auditoría.",
      },
      error: {
        loadError: "Error al cargar movimientos.",
        saveError: "Error al guardar movimiento.",
        originRequired: "Seleccione el origen del movimiento.",
        requesterRequired: "Informe el solicitante.",
        receiptDateRequired: "Informe la fecha de recepción.",
        supplierRequired: "Seleccione el proveedor.",
        stockItemRequired: "Seleccione el artículo de inventario.",
        manufacturerRequired: "Seleccione el fabricante.",
        measurementUnitRequired: "Seleccione la unidad de medida.",
        conversionFactorRequired: "Informe el factor de conversión.",
        quantityRequired: "Informe la cantidad.",
        costRequired: "Informe el costo unitario.",
        lineRequired: "Agregue al menos un artículo con cantidad.",
      },
      emptyTable: "No se encontraron movimientos.",
      notifications: {
        batchCreated: "Lote creado con éxito",
        errorBatchCreated: "Error al crear lote",
        variantCreated: "Variante creada con éxito",
        errorVariantCreated: "Error al crear variante",
      },
    },
  },
  importAnimalVaccination: {
    title: "Importar Vacunaciones",
    message:
      '<p class="message">Descargue la <strong>plantilla a continuación, complete la hoja de cálculo</strong> con las vacunaciones, <strong>importe</strong> y luego haga clic en procesar vacunaciones</p>',
    draggerMessage: "Haga clic o arrastre el archivo a esta área para subirlo",
    identificationLabel: "Identificación*",
    identification: "Identificación",
    electronicId: "Id. Electrónica",
    sisbov: "SISBOV",
    successMessage: "Vacunaciones en procesamiento",
    successDescription:
      "Su archivo está siendo procesado, espere. Se le notificará cuando se procesen todas las vacunaciones.",
    errorMessage: "Error al importar",
    errorDescription: "No se incluyó ninguna vacunación.",
  },
  register: {
    title: "Registro de usuario",
    subtitle: "Complete los campos a continuación para iniciar el registro",
    form: {
      registrationEmail: "Correo electrónico de registro",
      fullname: "Nombre completo",
      document: "CPF",
      contact: "Contacto",
      address: "Dirección",
      addressNumber: "Número",
      neighborhood: "Barrio",
      placeholder: "Ingrese aquí...",
    },
    step2: {
      title: "Confirmación de registro",
      subtitle:
        "Por favor, copie y pegue el código enviado a su correo electrónico en el campo a continuación.",
      codePlaceholder: "Ingrese el código aquí",
      resendCode: "Reenviar código",
      password: "Contraseña",
      confirmPassword: "Confirmar contraseña",
      confirmPasswordPlaceholder: "Confirmar contraseña",
    },
    step4: {
      title: "Elija una forma de pago",
      creditCard: "Tarjeta de Crédito",
      bankSlip: "Boleta Bancaria",
      differentHolderData:
        "Datos del titular de la tarjeta diferentes al registro",
      holderName: "Nombre del titular",
      cardNumber: "Número de Tarjeta",
      cardExpiration: "Fecha de vencimiento",
      cardCVV: "Código de seguridad",
      dueDateTitle: "Elija la fecha de vencimiento de la factura",
      dueDatePlaceholder: "Seleccione una fecha",
      form: {
        dayPrefix: "Día",
      },
    },
    messages: {
      emailAlreadyRegistered:
        "Correo electrónico ya registrado en nuestra base de datos",
      emailInvalid: "Correo electrónico inválido.",
      emailInvalidUrl:
        "El correo electrónico en la URL tiene un formato inválido",
      emailRequired: "Por favor, ingrese un correo electrónico.",
      nameRequired: "Es necesario ingresar un nombre.",
      cpfInvalid: "El CPF ingresado es inválido, ingrese otro.",
      phoneInvalid:
        "El número de teléfono ingresado es inválido, ingrese otro.",
      validationCodeSent: "Código de validación enviado al correo electrónico.",
      internalError: "Error interno. Contacte al soporte.",
      registrationErrorCpf:
        "Error al realizar el registro. CPF ya registrado en nuestro sistema.",
      registrationError: "Error al realizar el registro",
      notRobot: "Demuestre que no es un robot",
      codeInvalid: "Código inválido",
      dueDateInvalid: "Fecha de vencimiento de la factura inválida.",
      holderNameRequired: "El nombre del titular es obligatorio.",
      cpfInvalidPayment: "CPF inválido.",
      cardNumberInvalid: "Número de tarjeta inválido.",
      cardExpirationInvalid: "Fecha de vencimiento inválida.",
      cardCvvInvalid: "Código de seguridad inválido.",
      trialEnvironmentReady:
        "Su entorno demo está listo y ya puede iniciar sesión.",
      trialEnvironmentCreating:
        "Su entorno demo está siendo creado, le enviaremos un correo electrónico cuando esté listo.",
      registerGroupFarm: "Ahora registre un grupo y una granja",
      codeVerified: "Código verificado con éxito",
    },
    drawer: {
      title: "Completar datos",
      codeInstructions:
        "Se envió un código al correo electrónico proporcionado, cópielo y péguelo en el campo a continuación",
      codeInputPlaceholder: "INGRESE EL CÓDIGO AQUÍ",
      resendCode: "REENVIAR CÓDIGO",
      verified: " Verificado",
      validate: "Validar",
      definePassword: "Defina su contraseña de acceso",
      newPassword: "Nueva contraseña",
      confirmNewPassword: "Confirme la nueva contraseña",
      address: "Dirección",
      processing: "Procesando",
    },
  },
  changePassword: {
    title: "Recuperar mi contraseña",
    subtitle: "Ingrese su correo electrónico de registro a continuación",
    back: "Volver",
    registrationEmail: "Correo electrónico de registro",
    placeholder: "Ingrese aquí...",
    submitButton: "Recuperar contraseña",
    emailNotRegistered:
      "Correo electrónico no registrado, por favor ingrese un correo válido",
    messages: {
      codeSent:
        "El código de verificación fue enviado al correo electrónico proporcionado",
      somethingWentWrong: "Algo salió mal, por favor intente más tarde",
    },
    drawer: {
      title: "Cambiar contraseña",
      codeInstructions:
        "Se envió un código al correo electrónico proporcionado, cópielo y péguelo en el campo a continuación",
      codeInputPlaceholder: "INGRESE EL CÓDIGO AQUÍ",
      resendCode: "REENVIAR CÓDIGO",
      verified: " Verificado",
      validate: "Validar",
      definePassword: "Defina su contraseña de acceso",
      newPassword: "Nueva contraseña",
      confirmNewPassword: "Confirme la nueva contraseña",
      messages: {
        codeSent: "Código de validación enviado al correo electrónico.",
        emailAlreadyRegistered:
          "Correo electrónico ya registrado en nuestra base de datos",
        internalError: "Error interno. Contacte al soporte.",
        codeVerified: "Código verificado con éxito",
        codeInvalid: "Código inválido",
        passwordChanged: "¡Contraseña restablecida con éxito!",
        notRobot: "Demuestre que no es un robot",
        passwordUsedBefore: "Contraseña ya utilizada anteriormente.",
        errorResettingPassword: "Error al restablecer la contraseña.",
      },
    },
    logged: {
      title: "Restablecer contraseña",
      definePassword: "Defina su contraseña de acceso",
      newPassword: "Nueva contraseña",
      confirmNewPassword: "Confirme la nueva contraseña",
      passwordMismatch: "Los valores no coinciden",
      messages: {
        passwordChanged: "¡Contraseña restablecida con éxito!",
        passwordUsedBefore: "Contraseña ya utilizada anteriormente.",
        errorResettingPassword: "Error al restablecer la contraseña.",
      },
    },
  },
  login: {
    title: "Iniciar sesión",
    subtitle: "Inicie sesión en la plataforma y gestione su granja",
    loginLabel: "INICIO DE SESIÓN",
    passwordLabel: "contraseña",
    usernamePlaceholder: "Ingrese su correo electrónico de registro",
    passwordPlaceholder: "Ingrese su contraseña de registro",
    showPassword: "Mostrar contraseña",
    submitButton: "Iniciar sesión",
    forgotPassword: "¿Olvidó su contraseña?",
    forgotPasswordLink: "¡Haga clic aquí!",
    messages: {
      notRobot: "Demuestre que no es un robot",
    },
  },
  accessConfirmation: {
    title: "Parece que aún no tiene un registro",
    subtitle: "Complete los campos a continuación para registrar su usuario",
    passwordMismatch:
      "La contraseña y la confirmación de contraseña no coinciden",
    emailLabel: "Correo electrónico",
    fullnameLabel: "Nombre completo*",
    documentLabel: "CPF*",
    birthdayLabel: "Fecha de Nacimiento*",
    contactLabel: "Contacto*",
    newPasswordLabel: "Nueva contraseña",
    confirmNewPasswordLabel: "Confirme la nueva contraseña",
    termText: "Al marcar la casilla acepta los",
    termLink: "términos y condiciones de uso",
    termTextEnd: "del sistema Bovexo",
    placeholder: "Ingrese aquí...",
    messages: {
      registerError: "No fue posible registrar el usuario",
      documentAlreadyExists:
        "Ya existe un usuario registrado con este documento",
    },
    justConfirm: {
      title: "¡Invitación confirmada!",
      subtitle: "Haga clic en el botón a continuación e inicie sesión.",
      button: "OK, ENTENDIDO",
    },
    alreadyConfirm: {
      title: "Invitación ya confirmada",
      subtitle: "Haga clic en el botón a continuación e inicie sesión.",
      button: "OK, ENTENDIDO",
    },
    expirated: {
      title: "¡Invitación expirada!",
      subtitle: "Espere o contacte al responsable para reenviar la invitación",
      button: "OK, ENTENDIDO",
    },
  },
  accessInvitations: {
    inviteButton: "Invitar",
    resendInvite: "Reenviar invitación",
    statusSended: "Invitación enviada",
    statusExpirated: "Invitación expirada",
    statusAccepted: "Invitación aceptada",
    statusCanceled: "Invitación cancelada",
    columnEmail: "Correo electrónico",
    columnSentAt: "Enviado el",
    columnExpiresAt: "Expira el",
    messages: {
      fetchError: "No fue posible recuperar las invitaciones",
      resubmitSuccess: "Invitación reenviada",
      resubmitError: "Ocurrió un error al reenviar la invitación",
    },
  },
  supplierManagement: {
    buttons: {
      invite: "Invitar",
    },
    table: {
      columns: {
        businessName: "Razón Social",
        fantasyName: "Nombre Comercial",
        documentNumber: "CNPJ",
      },
      menu: {
        edit: "Editar",
        resendInvite: "Reenviar invitación",
      },
    },
    messages: {
      fetchError: "No fue posible recuperar las invitaciones",
      resendSuccess: "¡Correo reenviado con éxito!",
      resendError: "Ocurrió un error al intentar reenviar los correos!",
      saveSuccess: "¡Contratación realizada con éxito!",
      saveError:
        "Ocurrió un error al intentar guardar la información del grupo!",
      loadError: "Ocurrió un error al acceder a la información.",
    },
    form: {
      back: "Volver",
      title: "Grupos y empresas de proveedores",
      subtitle:
        "Complete el formulario a continuación para invitar a un nuevo usuario proveedor",
      groupNameLabel: "Razón Social*",
      groupFantasyNameLabel: "Nombre Comercial*",
      documentLabel: "CNPJ*",
      managerSectionTitle: "Responsable",
      nameLabel: "Nombre*",
      emailLabel: "Correo electrónico*",
      phoneLabel: "Teléfono*",
      companiesSectionTitle: "Empresas",
      companyNameLabel: "Razón Social*",
      fantasyNameLabel: "Nombre Comercial*",
      placeholder: "Ingrese aquí...",
      save: "Guardar",
    },
    validation: {
      groupNameRequired: "Es necesario informar la Razón Social del Grupo.",
      groupFantasyNameRequired:
        "Es necesario informar el Nombre Comercial del Grupo.",
      documentNumberRequired: "Es necesario informar el CNPJ del Grupo.",
      documentNumberInvalid: "CNPJ del Grupo inválido.",
      managerRequired: "Es necesario informar al menos 1 Responsable.",
      companyRequired: "Es necesario informar al menos 1 Empresa.",
      managerNameRequired: "Es necesario informar el Nombre del Responsable.",
      managerEmailRequired: "Es necesario informar el Correo del Responsable.",
      managerEmailInvalid: "Correo del Responsable inválido.",
      managerPhoneRequired:
        "Es necesario informar el Teléfono del Responsable.",
      managerPhoneInvalid: "Teléfono del Responsable inválido.",
      companyNameRequired:
        "Es necesario informar la Razón Social de la Empresa.",
      companyFantasyNameRequired:
        "Es necesario informar el Nombre Comercial de la Empresa.",
      companyDocumentRequired: "Es necesario informar el CNPJ de la Empresa.",
      companyDocumentInvalid: "CNPJ de la Empresa inválido.",
    },
  },
  supplierGroup: {
    invites: {
      title: "Invitaciones",
      buttons: {
        invite: "Invitar",
      },
      table: {
        columns: {
          name: "Nombre",
          email: "Correo",
        },
        menu: {
          resendInvite: "Reenviar invitación",
        },
      },
      status: {
        sent: "Enviado",
        confirmed: "Confirmado",
        cancelled: "Cancelado",
      },
      messages: {
        fetchError: "No fue posible recuperar las invitaciones",
        resendSuccess: "¡Correo reenviado con éxito!",
        resendError: "Ocurrió un error al intentar reenviar los correos!",
        saveSuccess: "Invitación registrada con éxito",
        saveError: "Ocurrió un error al registrar la invitación",
      },
      drawer: {
        title: "Invitar",
        subtitle:
          "Complete los campos a continuación para invitar a un colaborador",
        labels: {
          name: "Nombre*",
          email: "Correo electrónico*",
          accessProfile: "Perfil de acceso*",
          companies: "Empresa(s)*",
          selectCompanyMessage:
            "Seleccione la empresa a ser gestionada por este usuario",
        },
        roles: {
          manager: "Responsable",
          collaborator: "Colaborador",
        },
      },
    },
    collaborators: {
      title: "Colaboradores",
      table: {
        columns: {
          name: "Nombre",
          email: "Correo",
          profile: "Perfil",
          company: "Empresa",
        },
      },
      messages: {
        fetchError: "No fue posible recuperar las invitaciones",
      },
      roles: {
        collaborator: "Colaborador",
        admin: "Responsable",
      },
    },
  },
  inviteUser: {
    drawerTitle: "Invitar usuario",
    subtitle:
      "Complete los campos a continuación para invitar a un colaborador",
    labels: {
      email: "Correo electrónico*",
      accessProfile: "Perfil de acceso*",
      group: "Grupo*",
      farms: "Hacienda(s)*",
      selectFarmMessage:
        "Seleccione la hacienda a ser gestionada por este usuario",
    },
    roles: {
      farmAdmin: "Administrador de Hacienda",
      technician: "Técnico",
    },
    messages: {
      saveSuccess: "Invitación registrada con éxito",
      saveError: "Ocurrió un error al registrar la invitación",
    },
  },
  registerSupplierGroup: {
    pageTitle: "Registro de usuario",
    pageSubtitle: "Complete el formulario a continuación para acceder a bovexo",
    labels: {
      fullName: "Nombre Completo*",
      contact: "Contacto*",
      cpf: "CPF*",
      password: "Contraseña*",
      confirmPassword: "Confirme la contraseña*",
    },
    placeholders: {
      password: "Contraseña",
      confirmPassword: "Confirme la contraseña",
    },
    term: {
      checkboxText: "Al marcar la casilla acepta las",
      linkText: "condiciones y reglas de uso",
      suffix: "del sistema Bovexo",
    },
    buttons: {
      save: "Guardar",
    },
    messages: {
      fetchError: "No fue posible obtener la información de la invitación",
      saveSuccess: "¡Registro realizado con éxito!",
      cpfAlreadyExists:
        "Error al registrarse. CPF ya registrado en nuestro sistema.",
      emailAlreadyExists:
        "Error al registrarse. Correo electrónico ya registrado en nuestro sistema.",
      saveError: "Ocurrió un error al intentar guardar la información!",
    },
    validation: {
      fullNameRequired: "Es necesario informar el Nombre.",
      phoneRequired: "Es necesario informar el Teléfono.",
      phoneInvalid: "Teléfono Inválido.",
      cpfInvalid: "El CPF informado es inválido, ingrese otro.",
      passwordRequired: "Es necesario informar una Contraseña.",
      confirmPasswordRequired:
        "Es necesario informar la confirmación de contraseña.",
      passwordMismatch: "La Contraseña y la Confirmación deben coincidir.",
      termRequired: "Es necesario aceptar los términos de servicio.",
    },
  },
  changeEmail: {
    drawer: {
      title: "Cambiar correo electrónico",
      codeFromInstructions:
        "Se envió un código a su correo electrónico, cópielo y péguelo en el campo a continuación",
      codeFromPlaceholder: "Ingrese el código aquí",
      codeToInstructions:
        "Se envió un código a su nuevo correo electrónico, cópielo y péguelo en el campo a continuación",
      codeToPlaceholder: "Ingrese el código aquí",
      newEmailInstructions:
        "Ingrese su nuevo correo electrónico en el campo a continuación",
      newEmailPlaceholder: "Ingrese el correo electrónico",
      resendCode: "Reenviar código",
      updateButton: "Actualizar",
      verified: " Verificado",
      validate: "Validar",
      messages: {
        codeSentFrom: "Código de validación enviado al correo electrónico.",
        codeSentTo: "Código de validación enviado al nuevo correo electrónico.",
        userNotFound: "Usuario no encontrado.",
        internalError: "Error interno. Contacte al soporte.",
        emailAlreadyExists: "El correo electrónico ingresado ya existe.",
        codeInvalid: "Código inválido.",
        emailInvalid: "Correo electrónico inválido",
      },
    },
  },
  common: {
    marketingTagline: "Decisiones que engordan tu bolsillo",
    nav: {
      contactUs: "contáctenos",
      aboutUs: "sobre nosotros",
      support: "soporte",
    },
    address: {
      zipCode: "Código Postal",
      sectionTitle: "DIRECCIÓN",
      numberAddon: "Nº",
      complementAddon: "Comp.",
    },
    cpf: "ID Fiscal (CPF)",
    time: {
      days: "días",
      months: "meses",
      dayPrefix: "Día",
    },
  },
  weightGainProjection: {
    title: "Proyecciones de Ganancia de Peso",
    buttonNew: "Nueva Proyección",
    table: {
      status: "Estado",
      name: "Nombre",
      informType: "Tipo de Información",
    },
    form: {
      title: "Proyección de Ganancia de Peso",
      name: "Nombre",
      namePlaceholder: "Ingrese el nombre",
      informType: "Tipo de Información",
      timeUnitReference: "Unidad de Tiempo",
      fixedGmdWeight: "GMD Fijo (kg)",
      supplement: "Suplemento",
      supplementPlaceholder: "Seleccione un suplemento (opcional)",
      addPeriod: "Agregar Período",
      period: "Período",
      gmdWeight: "GMD (kg)",
      deleteLastOnly: "Solo se puede eliminar el último período",
      periodMustBeGreaterError:
        "El período ingresado ({period}) debe ser mayor que el último período agregado ({lastPeriod})",
      chart: {
        title: "GMD (kg)",
        fixed90days: "Proyección fija de 90 días",
      },
      radiogroup: {
        farm: "Finca",
        group: "Grupo",
      },
    },
    informType: {
      period: "Período",
      fixed: "Fijo",
    },
    timeUnit: {
      day: "Día",
      week: "Semana",
    },
    status: {
      active: "Activo",
      inactive: "Inactivo",
    },
    notification: {
      success: {
        create: { message: "Proyección creada exitosamente" },
        update: { message: "Proyección actualizada exitosamente" },
        activate: { message: "Proyección activada" },
        inactivate: { message: "Proyección inactivada" },
      },
      error: {
        save: { message: "Error al guardar la proyección" },
        activate: { message: "Error al activar la proyección" },
      },
    },
  },
  groupItem: {
    title: "Grupo",
    buttonNew: "Nuevo Grupo de Ítem",
    table: {
      columns: {
        status: "Estado",
        name: "Nombre",
      },
      inactivateSuccess: "¡Grupo de Ítem inactivado con éxito!",
      inactivateError: "Error al inactivar Grupo de Ítem. Contacte soporte.",
      activateSuccess: "¡Grupo de Ítem activado con éxito!",
      activateError: "Error al activar Grupo de Ítem. Contacte soporte.",
    },
    form: {
      titleCreateNew: "Nuevo Grupo de Ítem",
      titleEdit: "Editar Grupo de Ítem",
      groupFarmVisibility: "Visibilidad",
      name: "Nombre",
      description: "Descripción",
      externalIntegrationCode: "Código de Integración",
      status: "Estado",
      successMessage: "Grupo de Ítem guardado/actualizado con éxito.",
      errorMessage: "Error al guardar/editar Grupo de Ítem.",
    },
  },
  itemsGroup: {
    title: "Subgrupo",
    buttonNew: "Nuevo Ítem del Grupo",
    table: {
      columns: {
        status: "Estado",
        name: "Nombre",
        groupItemName: "Grupo de Ítem",
      },
      inactivateSuccess: "¡Ítem del Grupo inactivado con éxito!",
      inactivateError: "Error al inactivar Ítem del Grupo. Contacte soporte.",
      activateSuccess: "¡Ítem del Grupo activado con éxito!",
      activateError: "Error al activar Ítem del Grupo. Contacte soporte.",
    },
    form: {
      titleCreateNew: "Nuevo Ítem del Grupo",
      titleEdit: "Editar Ítem del Grupo",
      groupFarmVisibility: "Visibilidad",
      name: "Nombre",
      description: "Descripción",
      externalIntegrationCode: "Código de Integración",
      status: "Estado",
      groupItemId: "Grupo de Ítem",
      successMessage: "Ítem del Grupo guardado/actualizado con éxito.",
      errorMessage: "Error al guardar/editar Ítem del Grupo.",
    },
    select: {
      selectGroupItemFirst: "Seleccione primero un Grupo de Ítem",
    },
    classify: {
      title: "Clasificar Ítem del Grupo",
      classification: "Clasificación",
      classificationPlaceholder: "Seleccione una clasificación",
      supplement: "Suplemento",
      veterinarySupplement: "Insumos Veterinarios",
      successMessage: "¡Ítem del Grupo clasificado con éxito!",
      errorMessage: "Error al clasificar Ítem del Grupo. Contacte soporte.",
      name: "Nombre",
      description: "Descripción",
      externalIntegrationCode: "Código de Integración",
      groupItemName: "Grupo de Ítem",
      status: "Estado",
    },
  },
  wagon: {
    table: {
      title: "Mezcladores",
      columns: {
        name: "Nombre",
        integrationCode: "Código de Integración",
        capacityKg: "Capacidad (Kg)",
        observations: "Observaciones",
        status: "Estado",
      },
    },
    buttonNew: "Nuevo Mezclador",
    drawer: {
      titleNew: "Nuevo Mezclador",
      titleEdit: "Editar Mezclador",
      subTitle:
        "Complete los campos a continuación para registrar un nuevo mezclador",
      form: {
        name: "Nombre",
        integrationCode: "Código de Integración",
        capacityKg: "Capacidad (Kg)",
        observations: "Observaciones",
      },
    },
    messages: {
      saveSuccess: "Mezclador registrado con éxito",
      saveError: "Error al registrar el mezclador",
      updateSuccess: "Mezclador actualizado con éxito",
      updateError: "Error al actualizar el mezclador",
      activateError: "Error al activar el mezclador. Contacte al soporte",
      inactivateError: "Error al inactivar el mezclador. Contacte al soporte",
      nameAlreadyExists: "Ya existe un mezclador con este nombre",
      integrationCodeAlreadyExists:
        "Ya existe un mezclador con este código de integración",
    },
  },
};
